import React, { useState, useEffect, useRef } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Form,
  FormGroup,
  FormLabel,
  Button,
  Table,
  Spinner,
  Alert,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "react-bootstrap"
import { Container } from "reactstrap"
import { useNavigate, useLocation } from "react-router-dom"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { API_WEB_URLS } from "../../constants/constAPI"
import { useDispatch, useSelector } from "react-redux"
import {
  Fn_FillListData,
  Fn_GetReport,
  Fn_AddEditData,
  Fn_DeleteData,
} from "../../store/Functions"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import { toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { Input } from "reactstrap"
import Select from "react-select"
import EditContract from "../Transaction/EditContract"
import MultiSelectDropdown from "../../components/Common/MultiSelectDropdown"
import ExcelJS from "exceljs"
import { FileText, Download } from "react-feather"
import jsPDF from "jspdf"
import { applyPlugin as applyAutoTable } from "jspdf-autotable"
applyAutoTable(jsPDF)
import { registerHindiFont, setHindiFont } from "../../helpers/pdfHindiFont"
import useFilterLayout from "../../helpers/useFilterLayout"
import "../../helpers/filterLayout.css"
import { getCompanyName } from "constants/constAPI"
import useColumnResize from "../../helpers/useColumnResize"
import "../../helpers/columnResize.css"

const LedgerReport = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()

  // State for scroll to top button
  const [showScrollTop, setShowScrollTop] = useState(false)

  // Ref for table container
  const tableContainerRef = useRef(null)

  // Add CSS to ensure borders persist during scrolling and fix hover backgrounds
  useEffect(() => {
    const style = document.createElement("style")
    style.textContent = `
      .table th,
      .table td:not(.group-header-td) {
        border: 1.5px solid black !important;
      }
      .table th[style*="border"] {
        border: 1.5px solid black !important;
      }
      .table td[style*="border"]:not(.group-header-td) {
        border: 1.5px solid black !important;
      }
      .table tbody tr td:not(.group-header-td) {
        border: 1.5px solid black !important;
      }
      .table thead tr th {
        border: 1.5px solid black !important;
      }
      
      /* Off-white for table-secondary rows (not started contracts) */
      .table-secondary {
        background-color: #f8f8f6 !important;
      }
      .table-secondary td {
        background-color: #f8f8f6 !important;
      }
      
      /* Lighter blue for table-info rows (fully lifted contracts) */
      .table-info {
        background-color: #d6ebff !important;
      }
      .table-info td {
        background-color: #d6ebff !important;
      }
      
      /* Lighter red for table-danger rows (partially lifted contracts) */
      .table-danger {
        background-color: #fde7e9 !important;
      }
      .table tbody tr.table-danger td {
        background-color: #fde7e9 !important;
      }
      
      /* Group header row: no internal column borders, only outer row borders */
      /* Must beat: .table th/.table td, .table td[style*=border], .table tbody tr td — all !important */
      .table tbody tr td.group-header-td,
      .table td.group-header-td,
      .table td[style*="border"].group-header-td {
        border-left: none !important;
        border-right: none !important;
        border-top: 1.5px solid black !important;
        border-bottom: 1.5px solid black !important;
      }
      
      /* Force totals row background color and override Bootstrap 5 table shadows */
      tfoot tr.totals-row td {
        background-color: #4B0082 !important;
        --bs-table-bg: #4B0082 !important;
        --bs-table-accent-bg: transparent !important;
        box-shadow: none !important;
        color: #FFFFFF !important;
      }
      tfoot tr.selected-totals-row td {
        background-color: #FF8C00 !important;
        --bs-table-bg: #FF8C00 !important;
        --bs-table-accent-bg: transparent !important;
        box-shadow: none !important;
        color: #FFFFFF !important;
      }
      
      /* Remove all gaps between input and table sections */
      .card.mb-0,
      .card.shadow-sm,
      .card-body {
        margin-bottom: 0 !important;
        margin-top: 0 !important;
      }
      
      /* Remove default Bootstrap card margin */
      .card {
        margin-bottom: 0 !important;
      }
      
      /* Ensure no spacing between main container divs */
      .col-12 {
        margin-bottom: 0 !important;
        padding-bottom: 0 !important;
      }
      
      /* Remove row spacing */
      .row {
        margin-bottom: 0 !important;
        margin-top: 0 !important;
      }
      
      /* Remove all bottom spacing */
      .card-body {
        padding: 0 !important;
      }
      
      /* Table container full height */
      .table-responsive {
        margin: 0 !important;
        padding: 0 !important;
      }
      
      /* Remove ALL bottom gaps */
      * {
        box-sizing: border-box !important;
      }
      
      /* Ensure page fills entire viewport */
      html, body {
        height: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
        overflow-x: hidden !important;
      }
      
      /* Remove any wrapper padding */
      #root {
        height: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
      }
      
      /* Bottom filters bar - sab controls ki same height (32px) */
      .bottom-filters-bar input.form-control,
      .bottom-filters-bar .form-control-sm,
      .bottom-filters-bar input[type="text"] {
        height: 32px !important;
        min-height: 32px !important;
        box-sizing: border-box !important;
      }
      .bottom-filters-bar .react-select__control {
        height: 32px !important;
        min-height: 32px !important;
        box-sizing: border-box !important;
        display: flex !important;
        align-items: center !important;
      }
      .bottom-filters-bar .react-select__value-container {
        display: flex !important;
        align-items: center !important;
        padding: 0 8px !important;
      }
      .bottom-filters-bar .react-select__placeholder,
      .bottom-filters-bar .react-select__single-value {
        margin: 0 !important;
        line-height: 1 !important;
      }
      .bottom-filters-bar .react-select__input-container {
        margin: 0 !important;
        padding: 0 !important;
      }
      .bottom-filters-bar .btn {
        height: 32px !important;
        min-height: 32px !important;
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        display: inline-flex !important;
        align-items: center !important;
        box-sizing: border-box !important;
      }
      .bottom-filters-bar .d-flex.align-items-center > div > div,
      .bottom-filters-bar .bottom-filter-control {
        height: 32px !important;
        min-height: 32px !important;
        box-sizing: border-box !important;
        display: flex !important;
        align-items: center !important;
      }
      
      /* Fix dropdown in table footer to render outside table */
      tfoot td {
        overflow: visible !important;
      }
      
      tfoot .position-relative > div.position-absolute {
        position: fixed !important;
        z-index: 99999 !important;
      }
      
      /* Make period dropdown open upward */
      .period-dropdown-upward > div > div.position-absolute {
        bottom: 100% !important;
        top: auto !important;
        margin-bottom: 2px !important;
        margin-top: 0 !important;
      }
      
      .period-dropdown-upward div[class*="position-absolute"] {
        bottom: 100% !important;
        top: auto !important;
        margin-bottom: 2px !important;
        margin-top: 0 !important;
      }
      
      /* Fix dropdown text visibility */
      .period-dropdown-upward button {
        color: #333 !important;
        background-color: #E8D5E8 !important;
        border-radius: 6px !important;
        height: 28px !important;
        min-height: 28px !important;
        padding: 2px 8px !important;
        font-size: 0.65rem !important;
      }
      
      .period-dropdown-upward button span {
        color: #333 !important;
        font-size: 0.65rem !important;
      }

      .period-dropdown-upward .position-absolute {
        color: #000000 !important;
        background-color: #fff !important;
        min-width: 250px !important;
        white-space: nowrap !important;
      }

      .period-dropdown-upward .position-absolute > div {
        color: #000000 !important;
      }

      .period-dropdown-upward .position-absolute .dropdown-item {
        color: #000000 !important;
        white-space: nowrap !important;
      }

      .period-dropdown-upward .position-absolute * {
        color: #000000 !important;
      }
      
      .period-dropdown-upward button:hover {
        background-color: #D1B3D1 !important;
      }
      
      /* Party dropdown styling - MultiSelectDropdown */
      .party-dropdown-upward button {
        color: #333 !important;
        background-color: #E8D5E8 !important;
        border: none !important;
        border-radius: 6px !important;
        height: 28px !important;
        min-height: 28px !important;
        padding: 2px 8px !important;
        font-size: 0.65rem !important;
      }
      
      .party-dropdown-upward button span {
        color: #333 !important;
        font-size: 0.65rem !important;
      }
      
      .party-dropdown-upward button:hover {
        background-color: #D1B3D1 !important;
      }
      
      .party-dropdown-upward .position-absolute {
        background-color: white !important;
        border: 1px solid #dee2e6 !important;
        box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
      }
      
      .party-dropdown-upward .form-control {
        color: #212529 !important;
        background-color: white !important;
      }
      
      .party-dropdown-upward .position-absolute > div > div {
        color: #212529 !important;
      }
      
      .party-dropdown-upward .position-absolute span {
        color: #212529 !important;
      }
      
      .party-dropdown-upward .position-absolute div {
        color: #212529 !important;
      }
      
      .party-dropdown-upward .bg-primary {
        background-color: #0d6efd !important;
        color: white !important;
      }
      
      .party-dropdown-upward .bg-primary span {
        color: white !important;
      }
      
      .party-dropdown-upward .text-muted {
        color: #6c757d !important;
      }
      
      /* Date picker input width */
      .date-picker-custom {
        width: 100% !important;
      }
      
      .date-picker-custom input {
        width: 100% !important;
        padding: 0.25rem 0.5rem !important;
      }
      
      .react-datepicker-wrapper {
        width: 100% !important;
      }
      
      .react-datepicker__input-container {
        width: 100% !important;
      }
      
      .react-datepicker__input-container input {
        width: 100% !important;
      }
      
      /* Hide calendar icon in native date inputs */
      input[type="date"]::-webkit-calendar-picker-indicator {
        display: none;
        -webkit-appearance: none;
      }
      
      /* Ensure datepicker dropdown appears above sticky headers */
      .react-datepicker-popper {
        z-index: 12000 !important;
      }
      
      /* Remove pagination controls spacing */
      .pagination-controls {
        margin: 0 !important;
        padding: 0 !important;
        min-height: 0 !important;
      }
      
      /* Mobile: lock body scroll so only table scrolls */
      @media (max-width: 768px) {
        body.ledger-report-mobile {
          overflow: hidden !important;
          height: 100% !important;
        }
      }
      
      /* ContractNo column selected/unselected background */
      .ledger-report-container td.contractno-selected {
        background-color: #fffec8 !important;
        box-shadow: none !important;
      }
      .ledger-report-container td.contractno-unselected {
        background-color: white !important;
        box-shadow: none !important;
      }
      
      /* Mobile: fix layout - only table data scrolls; container height excludes fixed nav footer so no overlap */
      @media (max-width: 768px) {
        /* Nav footer space - container shorter; table height thodi aur kam */
        .ledger-report-container {
          height: calc(100vh - 115px - env(safe-area-inset-bottom, 0px)) !important;
          height: calc(100dvh - 115px - env(safe-area-inset-bottom, 0px)) !important;
          max-height: calc(100vh - 115px - env(safe-area-inset-bottom, 0px)) !important;
          max-height: calc(100dvh - 115px - env(safe-area-inset-bottom, 0px)) !important;
          overflow: hidden !important;
          padding-top: 0 !important;
          padding-bottom: 0 !important;
          box-sizing: border-box !important;
          display: flex !important;
          flex-direction: column !important;
          touch-action: none !important;
        }
        
        .ledger-report-container .col-12:first-child {
          flex: 0 0 auto !important;
          min-height: auto !important;
        }
        
        /* Table section: takes remaining space, only inner table scrolls */
        .ledger-report-container .row.ledger-table-section {
          flex: 1 1 auto !important;
          min-height: 0 !important;
          overflow: hidden !important;
          display: flex !important;
          flex-direction: column !important;
        }
        
        .ledger-report-container .ledger-table-section .col-12 {
          min-height: 0 !important;
          display: flex !important;
          flex-direction: column !important;
        }
        
        .ledger-report-container .ledger-table-section .card {
          min-height: 0 !important;
          flex: 1 !important;
          display: flex !important;
          flex-direction: column !important;
          overflow: hidden !important;
        }
        
        /* Table section card-body: bottom padding reduces table height so filters stay above nav footer */
        .ledger-report-container .ledger-table-section .card-body {
          min-height: 0 !important;
          flex: 1 !important;
          display: flex !important;
          flex-direction: column !important;
          overflow: hidden !important;
          padding-bottom: 32px !important;
        }
        
        /* Only this div scrolls - table height thodi kam so no overlap with nav footer */
        .ledger-report-container .table-responsive.ledger-table-scroll {
          flex: 1 1 auto !important;
          min-height: 0 !important;
          max-height: 100% !important;
          overflow-y: auto !important;
          overflow-x: auto !important;
          -webkit-overflow-scrolling: touch !important;
          margin-bottom: 0 !important;
          padding-bottom: 0 !important;
          border-bottom: none !important;
        }
        
        /* Sticky header - fixed at top when scrolling */
        .ledger-report-container .table-responsive thead th {
          position: sticky !important;
          top: 0 !important;
          z-index: 12 !important;
          background-color: #0000FF !important;
          box-shadow: 0 2px 4px rgba(0,0,0,0.15) !important;
        }
        
        /* Sticky footer - both total rows fixed at bottom when scrolling */
        .ledger-report-container .table-responsive tfoot {
          position: sticky !important;
          bottom: 0 !important;
          z-index: 11 !important;
        }
        
        .ledger-report-container .table-responsive tfoot tr {
          box-shadow: 0 -2px 4px rgba(0,0,0,0.15) !important;
        }

        /* Totals row text color */
        @media (min-width: 768px) {
          tfoot tr.totals-row td,
          tfoot tr.selected-totals-row td {
            color: #FFFFFF !important;
          }
        }
        @media (max-width: 767.98px) {
          tfoot tr.totals-row td,
          tfoot tr.selected-totals-row td {
            color: black !important;
          }
        }
        
        /* Bottom filters bar - attached to table top, sits above app footer (no overlap) */
        .ledger-report-container .bottom-filters-bar {
          flex-shrink: 0 !important;
          margin-top: 0 !important;
          margin-bottom: 0 !important;
          padding-top: 6px !important;
          padding-bottom: 6px !important;
          border-top: 2px solid #5a2d5a !important;
          border-bottom: none !important;
          min-height: 40px !important;
          /* stays in container above padding-bottom = above app footer */
        }
        
        .ledger-report-container .card-body {
          gap: 0 !important;
        }
        
        .ledger-report-container .text-center.py-2 {
          padding-top: 0.5rem !important;
          padding-bottom: 0.5rem !important;
        }
        
        /* Note column - single line on mobile, wider column, scroll horizontally if long */
        .ledger-report-container .table-responsive .ledger-note-cell {
          padding: 2px 4px !important;
          font-size: 0.7rem !important;
          line-height: 1.35 !important;
        }
        .ledger-note-cell .note-inner {
          white-space: nowrap;
          overflow-x: auto;
          overflow-y: hidden;
          -webkit-overflow-scrolling: touch;
        }
        @media (max-width: 768px) {
          .ledger-note-cell .note-inner {
            max-width: 130px;
          }
        }
        
        .bottom-filters-bar::-webkit-scrollbar {
          height: 6px;
        }
        .bottom-filters-bar::-webkit-scrollbar-track {
          background: rgba(255, 255, 255, 0.1);
          border-radius: 3px;
        }
        .bottom-filters-bar::-webkit-scrollbar-thumb {
          background: rgba(255, 255, 255, 0.3);
          border-radius: 3px;
        }
      }
      
      @media (max-width: 480px) {
        .party-dropdown-upward button,
        .period-dropdown-upward button {
          font-size: 0.6rem !important;
          padding: 1px 6px !important;
          height: 26px !important;
          min-height: 26px !important;
        }
        .party-dropdown-upward button span,
        .period-dropdown-upward button span {
          font-size: 0.6rem !important;
        }
      }
      /* Ensure td cells handle overflow for fixed table layout */
      .table td {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      `
    document.head.appendChild(style)
    return () => {
      document.head.removeChild(style)
    }
  }, [])

  // On mobile: lock body scroll so only table content scrolls
  useEffect(() => {
    const isMobile = () => window.innerWidth <= 768
    if (isMobile()) {
      document.body.classList.add("ledger-report-mobile")
    }
    const handleResize = () => {
      if (!isMobile()) {
        document.body.classList.remove("ledger-report-mobile")
      } else {
        document.body.classList.add("ledger-report-mobile")
      }
    }
    window.addEventListener("resize", handleResize)
    return () => {
      document.body.classList.remove("ledger-report-mobile")
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  // --- Column Resize Feature ---------------------------------------
  const COLUMN_DEFAULT_WIDTHS = {
    CheckBox: 35,
    ContractNo: 110,
    ContractDate: 90,
    Seller: 120,
    Buyer: 120,
    Status: 45,
    Unit: 55,
    Item: 90,
    PurQty: 70,
    SelQty: 70,
    Vessel: 80,
    Rate: 65,
    ContPeriod: 85,
    DeliveryPort: 90,
    SAdvPayment: 80,
    PAdvPayment: 80,
    AdvPayment: 80,
    AdvDate: 80,
    Lifted: 65,
    Contract: 70,
    Lifting: 260,
    Note: 120,
  }

  const { columnWidths, handleResizeMouseDown, isResizing } = useColumnResize('ledgerReport_columnWidths', COLUMN_DEFAULT_WIDTHS)
  // --- End Column Resize Feature ----------------------------------

  // --- Column Configuration ---------------------------------------
  const ALL_COLUMNS = [
    { key: 'CheckBox', label: '', sortKey: null },
    { key: 'ContractNo', label: 'Contract No', sortKey: 'ContractNo' },
    { key: 'ContractDate', label: 'Contract Date', sortKey: 'ContractDate' },
    { key: 'Seller', label: 'Seller', sortKey: 'Seller' },
    { key: 'Buyer', label: 'Buyer', sortKey: 'Buyer' },
    { key: 'Status', label: 'S/P', sortKey: 'Status' },
    { key: 'Unit', label: 'Unit', sortKey: 'Unit' },
    { key: 'Item', label: 'Item', sortKey: 'Item' },
    { key: 'PurQty', label: 'Pur Qty', sortKey: 'PurQty' },
    { key: 'SelQty', label: 'Sel Qty', sortKey: 'SelQty' },
    { key: 'Vessel', label: 'Vessel', sortKey: null },
    { key: 'Rate', label: 'Rate', sortKey: null },
    { key: 'ContPeriod', label: 'Cont Period', sortKey: null },
    { key: 'DeliveryPort', label: 'Delivery Port', sortKey: null },
    { key: 'SAdvPayment', label: 'S Adv Pay', sortKey: null },
    { key: 'PAdvPayment', label: 'P Adv Pay', sortKey: null },
    { key: 'AdvDate', label: 'Adv Date', sortKey: null },
    { key: 'Lifted', label: 'Lifted', sortKey: null },
    { key: 'Contract', label: 'Contract', sortKey: null },
    { key: 'Lifting', label: 'Lifting', sortKey: null, detailedOnly: true },
    { key: 'Note', label: 'Note', sortKey: null },
  ]

  // Get effective visible columns based on isDetailed flag
  const getVisibleColumns = () => ALL_COLUMNS.filter(c => !c.detailedOnly || isDetailed)
  // --- Column Drag-to-Reorder Feature ---
  const LR_DEFAULT_ORDER = ALL_COLUMNS.map(c => c.key);
  const LR_ORDER_KEY = 'ledgerReport_columnOrder';

  const lrGetInitialOrder = () => {
    try {
      const saved = localStorage.getItem(LR_ORDER_KEY);
      if (saved) {
        const parsed = JSON.parse(saved);
        return [
          ...parsed.filter(k => LR_DEFAULT_ORDER.includes(k)),
          ...LR_DEFAULT_ORDER.filter(k => !parsed.includes(k)),
        ];
      }
    } catch (e) { }
    return [...LR_DEFAULT_ORDER];
  };

  const [lrColumnOrder, setLrColumnOrder] = useState(lrGetInitialOrder);
  const [lrDragOverKey, setLrDragOverKey] = useState(null);
  const lrDragSrcRef = useRef(null);
  const lrJustDraggedRef = useRef(false);

  const lrSaveOrder = (order) => {
    try { localStorage.setItem(LR_ORDER_KEY, JSON.stringify(order)); } catch (e) { }
  };

  const lrDragStart = (e, key) => {
    lrDragSrcRef.current = key;
    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('text/plain', key);
  };
  const lrDragOver = (e, key) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
    if (key !== lrDragSrcRef.current) setLrDragOverKey(key);
  };
  const lrDrop = (e, targetKey) => {
    e.preventDefault();
    const srcKey = lrDragSrcRef.current;
    if (!srcKey || srcKey === targetKey) { setLrDragOverKey(null); return; }
    setLrColumnOrder(prev => {
      const next = [...prev];
      const from = next.indexOf(srcKey);
      const to = next.indexOf(targetKey);
      if (from === -1 || to === -1) return prev;
      next.splice(from, 1);
      next.splice(to, 0, srcKey);
      lrSaveOrder(next);
      return next;
    });
    setLrDragOverKey(null);
    lrDragSrcRef.current = null;
    lrJustDraggedRef.current = true;
    setTimeout(() => { lrJustDraggedRef.current = false; }, 250);
  };
  const lrDragEnd = () => {
    if (lrDragSrcRef.current) {
      lrJustDraggedRef.current = true;
      setTimeout(() => { lrJustDraggedRef.current = false; }, 250);
    }
    setLrDragOverKey(null);
    lrDragSrcRef.current = null;
  };
  const lrVisibleColumns = () => lrColumnOrder
    .map(k => ALL_COLUMNS.find(c => c.key === k))
    .filter(Boolean)
    .filter(c => !c.detailedOnly || isDetailed);
  // --- End Column Drag-to-Reorder Feature ---

  // --- Filter Layout Feature (resizable, reorderable, gap control) ---
  const TOP_FILTER_DEFAULTS = [
    { id: 'checkboxes', defaultWidth: 260 },
    { id: 'dates', defaultWidth: 210 },
    { id: 'ledger', defaultWidth: 70 },
    { id: 'voucher', defaultWidth: 60 },
    { id: 'addContract', defaultWidth: 40 },
    { id: 'lapLip', defaultWidth: 150 },
    { id: 'notes', defaultWidth: 250 },
    { id: 'exit', defaultWidth: 60 },
  ];

  const BOTTOM_FILTER_DEFAULTS = [
    { id: 'period', defaultWidth: 130 },
    { id: 'item', defaultWidth: 130 },
    { id: 'exportButtons', defaultWidth: 140 },
    { id: 'party', defaultWidth: 230 },
    { id: 'contractType', defaultWidth: 150 },
    { id: 'vessel', defaultWidth: 110 },
    { id: 'port', defaultWidth: 110 },
  ];

  const {
    filterOrder: topFilterOrder,
    filterWidths: topFilterWidths,
    gap: topGap,
    setGap: setTopGap,
    handleDragStart: topDragStart,
    handleDragOver: topDragOver,
    handleDrop: topDrop,
    handleDragEnd: topDragEnd,
    handleTouchDragStart: topTouchDragStart,
    handleTouchDragMove: topTouchDragMove,
    handleTouchDragEnd: topTouchDragEnd,
    handleFilterResizeMouseDown: topResizeDown,
    resetLayout: resetTopLayout,
    handleFilterStart: topFilterStart,
    activeReorderId: topActiveReorderId,
  } = useFilterLayout('ledgerReport_topFilters', TOP_FILTER_DEFAULTS);

  const {
    filterOrder: bottomFilterOrder,
    filterWidths: bottomFilterWidths,
    gap: bottomGap,
    setGap: setBottomGap,
    handleDragStart: bottomDragStart,
    handleDragOver: bottomDragOver,
    handleDrop: bottomDrop,
    handleDragEnd: bottomDragEnd,
    handleTouchDragStart: bottomTouchDragStart,
    handleTouchDragMove: bottomTouchDragMove,
    handleTouchDragEnd: bottomTouchDragEnd,
    handleFilterResizeMouseDown: bottomResizeDown,
    resetLayout: resetBottomLayout,
    handleFilterStart: bottomFilterStart,
    activeReorderId: bottomActiveReorderId,
  } = useFilterLayout('ledgerReport_bottomFilters', BOTTOM_FILTER_DEFAULTS);

  // --- Filter Content Renderers ---------------------------------
  const renderTopFilterContent = (filterId) => {
    switch (filterId) {
      case 'checkboxes':
        return (
          <div
            style={{
              border: "1px solid #2196F3",
              borderRadius: "4px",
              padding: "2px 1px",
              backgroundColor: "#E3F2FD",
              display: "flex",
              alignItems: "center",
              flexWrap: "nowrap",
              gap: "0",
              height: "28px",
              width: "100%",
            }}
          >
            <div className="form-check" style={{ display: "flex", alignItems: "center", gap: "1px", marginRight: "3px", paddingLeft: "0" }}>
              <input id="Pending" type="checkbox" className="form-check-input" style={{ width: "12px", height: "12px", margin: "0" }} checked={state.Pending} onClick={() => { setState(prev => ({ ...prev, Pending: !prev.Pending })); }} />
              <label className="form-check-label small mb-0" htmlFor="Pending" style={{ fontSize: "0.55rem", color: "#dc3545", fontWeight: "bold", whiteSpace: "nowrap" }}><i className="fas fa-hourglass-half" style={{ fontSize: "0.5rem" }}></i>R:{state.Pending ? "Y" : "N"}</label>
            </div>
            <div className="form-check" style={{ display: "flex", alignItems: "center", gap: "1px", marginRight: "3px", paddingLeft: "0" }}>
              <input id="NotStarted" type="checkbox" className="form-check-input" style={{ width: "12px", height: "12px", margin: "0" }} checked={state.NotStarted} onClick={() => { setState(prev => ({ ...prev, NotStarted: !prev.NotStarted })); }} />
              <label className="form-check-label small mb-0" htmlFor="NotStarted" style={{ fontSize: "0.55rem", color: "#000000", fontWeight: "bold", whiteSpace: "nowrap" }}><i className="fas fa-clock" style={{ fontSize: "0.5rem" }}></i>Bk:{state.NotStarted ? "Y" : "N"}</label>
            </div>
            <div className="form-check" style={{ display: "flex", alignItems: "center", gap: "1px", paddingLeft: "0" }}>
              <input id="Completed" type="checkbox" className="form-check-input" style={{ width: "12px", height: "12px", margin: "0" }} checked={state.Completed} onClick={() => { setState(prev => ({ ...prev, Completed: !prev.Completed })); }} />
              <label className="form-check-label small mb-0" htmlFor="Completed" style={{ fontSize: "0.55rem", color: "#007bff", fontWeight: "bold", whiteSpace: "nowrap" }}><i className="fas fa-check-circle" style={{ fontSize: "0.5rem" }}></i>Bl:{state.Completed ? "Y" : "N"}</label>
            </div>
          </div>
        );
      case 'dates':
        return (
          <FormGroup className="mb-0" style={{ width: "100%", height: "100%", paddingRight: "6px" }}>
            <div style={{ display: "flex", alignItems: "center", whiteSpace: "nowrap", height: "100%", width: "100%" }}>
              <div style={{ flex: 1, height: '28px' }}>
                <DatePicker selected={fromDate} onChange={date => setFromDate(date)} className="form-control form-control-sm custom-datepicker w-100" dateFormat="dd/MM/yyyy" placeholderText="From Date" portalId="root-portal" popperPlacement="bottom-start" openToDate={new Date()} />
              </div>
              <span style={{ fontSize: "0.6rem", fontWeight: "500", color: "#1976D2", margin: "0 2px" }}>To</span>
              <div style={{ flex: 1, height: '28px' }}>
                <DatePicker selected={toDate} onChange={date => setToDate(date)} className="form-control form-control-sm custom-datepicker w-100" dateFormat="dd/MM/yyyy" placeholderText="To Date" portalId="root-portal" popperPlacement="bottom-start" openToDate={new Date()} />
              </div>
            </div>
          </FormGroup>
        );
      case 'ledger':
        return (
          <FormGroup className="mb-0">
            <Button variant="outline-primary" onClick={handleOpenLedgerModal} style={{ fontSize: "0.55rem", height: "28px", padding: "2px 4px", display: "flex", alignItems: "center", justifyContent: "space-between", backgroundColor: "#E3F2FD", border: "1px solid #2196F3", color: "#1976D2", whiteSpace: "nowrap", minWidth: "fit-content", width: "100%" }}>
              Ledger
              <i className="fas fa-chevron-down" style={{ fontSize: "0.5rem", marginLeft: "2px" }}></i>
            </Button>
          </FormGroup>
        );
      case 'voucher':
        return (
          <Button color="info" style={{ fontSize: "0.55rem", height: "28px", padding: "2px 6px", minWidth: "50px", whiteSpace: "nowrap", width: "100%" }} onClick={() => window.open('/VoucherList', '_blank')}>
            <i className="fas fa-receipt"></i>Vch
          </Button>
        );
      case 'addContract':
        return (
          <Button variant="success" style={{ fontSize: "0.6rem", height: "28px", padding: "2px 6px", minWidth: "32px", width: "100%" }} onClick={() => window.open('/Contract', '_blank')}>
            <i className="fas fa-plus"></i>
          </Button>
        );
      case 'lapLip':
        return (
          <div style={{ border: "1px solid #2196F3", borderRadius: "4px", padding: "2px 3px", backgroundColor: "#E3F2FD", display: "flex", alignItems: "center", flexWrap: "nowrap", height: "28px", width: "100%" }}>
            <div className="form-check" style={{ display: "flex", alignItems: "center", gap: "1px", marginRight: "2px" }}>
              <input id="LAP" type="checkbox" className="form-check-input" style={{ width: "12px", height: "12px", margin: "0" }} onClick={() => { const newLapValue = !state.LAP; setState(prev => ({ ...prev, LAP: newLapValue })); handleLapLipDateChange(newLapValue, state.LIP); }} checked={state.LAP} />
              <label className="form-check-label small mb-0" htmlFor="LAP" style={{ fontSize: "0.55rem", color: "#28a745", fontWeight: "bold", whiteSpace: "nowrap" }}><i className="fas fa-check-circle" style={{ fontSize: "0.5rem" }}></i>LAP:{state.LAP ? "Y" : "N"}</label>
            </div>
            <div className="form-check" style={{ display: "flex", alignItems: "center", gap: "1px" }}>
              <input id="LIP" type="checkbox" className="form-check-input" style={{ width: "12px", height: "12px", margin: "0" }} onClick={() => { const newLipValue = !state.LIP; setState(prev => ({ ...prev, LIP: newLipValue })); handleLapLipDateChange(state.LAP, newLipValue); }} checked={state.LIP} />
              <label className="form-check-label small mb-0" htmlFor="LIP" style={{ fontSize: "0.55rem", color: "#dc3545", fontWeight: "bold", whiteSpace: "nowrap" }}><i className="fas fa-check-circle" style={{ fontSize: "0.5rem" }}></i>LIP:{state.LIP ? "Y" : "N"}</label>
            </div>
          </div>
        );
      case 'notes':
        return (
          <div style={{ border: "1px solid #2196F3", borderRadius: "4px", padding: "2px 4px", backgroundColor: "#E3F2FD", height: "28px", display: "flex", alignItems: "center", width: "100%" }}>
            <label className="fw-bold small mb-0" style={{ fontSize: "0.55rem", whiteSpace: "nowrap", marginRight: "2px", color: "#1976D2" }}>
              <i className="fas fa-sticky-note" style={{ fontSize: "0.5rem" }}></i>Note:
            </label>
            <div style={{ display: "flex", alignItems: "center" }}>
              {[1, 2, 3, 4, 5, 6].map(n => (
                <div key={n} className="form-check" style={{ display: "flex", alignItems: "center", margin: "0" }}>
                  <input id={`note${n}`} type="checkbox" className="form-check-input" style={{ width: "10px", height: "10px", margin: "0 1px" }} onClick={() => setVisibleNotes(prev => ({ ...prev, [`Note${n}`]: !prev[`Note${n}`] }))} checked={visibleNotes[`Note${n}`]} />
                  <label className="form-check-label mb-0" htmlFor={`note${n}`} style={{ fontSize: "0.5rem" }}>{n}</label>
                </div>
              ))}
              <Button size="sm" variant="outline-secondary" style={{ fontSize: "0.45rem", padding: "1px 3px", height: "16px", lineHeight: "1", marginLeft: "2px" }} onClick={() => { const allChecked = Object.values(visibleNotes).every(v => v); toggleAllNotes(!allChecked); }}>All</Button>
            </div>
          </div>
        );
      case 'exit':
        return (
          <Button variant="danger" style={{ fontSize: "0.6rem", height: "28px", padding: "2px 8px", minWidth: "55px", whiteSpace: "nowrap", width: "100%" }} onClick={() => window.close()}>
            <i className="fas fa-times"></i> Exit
          </Button>
        );
      default:
        return null;
    }
  };

  const renderBottomFilterContent = (filterId) => {
    switch (filterId) {
      case 'period':
        return (
          <div onClick={openPeriodModal} className="bottom-filter-control" style={{ backgroundColor: "#E3F2FD", color: "#333", border: "1px solid #2196F3", borderRadius: "6px", height: "32px", minHeight: "32px", padding: "0 8px", fontSize: "0.65rem", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
            <span>{selectedPeriod && selectedPeriod.length > 0 ? `${selectedPeriod.length} selected` : "Period"}</span>
            <i className="fas fa-chevron-down ms-2"></i>
          </div>
        );
      case 'item':
        return (
          <div onClick={openItemModal} className="bottom-filter-control" style={{ backgroundColor: "#E3F2FD", color: "#333", border: "1px solid #2196F3", borderRadius: "6px", height: "32px", minHeight: "32px", padding: "0 8px", fontSize: "0.65rem", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
            <span>{selectedItems && selectedItems.length > 0 && !(selectedItems.length === 1 && selectedItems[0] === "") ? `${selectedItems.filter(item => item !== "").length} selected` : "Items"}</span>
            <i className="fas fa-chevron-down ms-2"></i>
          </div>
        );
      case 'exportButtons':
        return (
          <div className="d-flex align-items-center" style={{ gap: "8px" }}>
            <Button color="success" onClick={exportToExcel} className="shadow-sm" size="sm" style={{ fontSize: "0.6rem", whiteSpace: "nowrap", height: "32px", minHeight: "32px", padding: "0 10px" }}>
              <i className="fas fa-file-excel me-1"></i>Excel
            </Button>
            <Button color="danger" onClick={exportToPDF} className="shadow-sm" size="sm" style={{ fontSize: "0.6rem", whiteSpace: "nowrap", height: "32px", minHeight: "32px", padding: "0 10px" }}>
              <i className="fas fa-file-pdf me-1"></i>PDF
            </Button>
          </div>
        );
      case 'party':
        return (
          <div onClick={openPartyModal} className="bottom-filter-control" style={{ backgroundColor: "#E3F2FD", color: "#333", border: "1px solid #2196F3", borderRadius: "6px", height: "32px", minHeight: "32px", padding: "0 8px", fontSize: "0.65rem", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
            <span>{selectedParties !== null ? `${selectedParties.length} selected` : "Party"}</span>
            <i className="fas fa-chevron-down ms-2"></i>
          </div>
        );
      case 'contractType':
        return (
          <div onClick={openContractTypeModal} className="bottom-filter-control" style={{ backgroundColor: "#E3F2FD", color: "#333", border: "1px solid #2196F3", borderRadius: "6px", height: "32px", minHeight: "32px", padding: "0 8px", fontSize: "0.65rem", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
            <span>{selectedContractTypes && selectedContractTypes.length > 0 ? `${selectedContractTypes.length} selected` : "Contract"}</span>
            <i className="fas fa-chevron-down ms-2"></i>
          </div>
        );
      case 'vessel':
        return (
          <div onClick={openVesselModal} className="bottom-filter-control" style={{ backgroundColor: "#E3F2FD", color: "#333", border: "1px solid #2196F3", borderRadius: "6px", height: "32px", minHeight: "32px", padding: "0 8px", fontSize: "0.65rem", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
            <span>{selectedVessels.length > 0 ? `${selectedVessels.length} selected` : "Vessel"}</span>
            <i className="fas fa-chevron-down ms-2"></i>
          </div>
        );
      case 'port':
        return (
          <div onClick={openPortModal} className="bottom-filter-control" style={{ backgroundColor: "#E3F2FD", color: "#333", border: "1px solid #2196F3", borderRadius: "6px", height: "32px", minHeight: "32px", padding: "0 8px", fontSize: "0.65rem", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
            <span>{selectedPorts && selectedPorts.length > 0 ? `${selectedPorts.length} selected` : "Port"}</span>
            <i className="fas fa-chevron-down ms-2"></i>
          </div>
        );
      default:
        return null;
    }
  };

  // Helper to render a filter bar with drag/resize/gap support
  const renderFilterBar = (filterOrder, filterWidths, gap, setGap, dragStart, dragOver, drop, dragEnd, touchDragStart, touchDragMove, touchDragEnd, resizeDown, resetLayout, renderContent, filterStart, activeReorderId) => {
    return (
      <>
        {filterOrder.map(filterId => {
          const isDragging = activeReorderId === filterId;
          return (
            <div
              key={filterId}
              data-filter-id={filterId}
              className={`filter-item ${isDragging ? 'dragging' : ''}`}
              onMouseDown={e => filterStart(e, filterId, false)}
              onTouchStart={e => filterStart(e, filterId, true)}
              onClickCapture={e => {
                if (activeReorderId) {
                  e.preventDefault();
                  e.stopPropagation();
                }
              }}
              style={{
                width: `${filterWidths[filterId] || 100}px`,
                flexShrink: 0,
                position: "relative",
                cursor: activeReorderId ? (isDragging ? "grabbing" : "default") : "grab",
                touchAction: activeReorderId ? "none" : "pan-x",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                <div style={{ flex: 1, overflow: "hidden" }}>
                  {renderContent(filterId)}
                </div>
              </div>
              <div className="filter-resize-handle" onMouseDown={e => resizeDown(e, filterId)} onTouchStart={e => resizeDown(e, filterId)} />
            </div>
          );
        })}
        {/* Gap & Reset controls */}
        <div className="filter-gap-control" style={{ marginLeft: "4px" }}>
          <button onClick={() => setGap(gap - 2)} title="Decrease gap">-</button>
          <span>{gap}</span>
          <button onClick={() => setGap(gap + 2)} title="Increase gap">+</button>
        </div>
        <button className="filter-reset-btn" onClick={resetLayout} title="Reset layout">
          <i className="fas fa-undo" style={{ fontSize: "0.5rem" }}></i>
        </button>
      </>
    );
  };
  // --- End Filter Layout Feature ---------------------------------

  // Scroll event handler for table container
  const handleTableScroll = () => {
    const tableContainer = tableContainerRef.current
    if (tableContainer) {
      const scrollPosition = tableContainer.scrollTop
      console.log("Table scroll position:", scrollPosition)
      if (scrollPosition > 200) {
        setShowScrollTop(true)
      } else {
        setShowScrollTop(false)
      }
    }
  }

  // Scroll to top button visibility handler for table container
  useEffect(() => {
    // Use a small delay to ensure table is rendered
    const timer = setTimeout(() => {
      const tableContainer = tableContainerRef.current
      if (tableContainer) {
        // Initial check
        handleTableScroll()

        // Add scroll event listener to table container
        tableContainer.addEventListener("scroll", handleTableScroll)
      }
    }, 100)

    return () => {
      clearTimeout(timer)
      const tableContainer = tableContainerRef.current
      if (tableContainer) {
        tableContainer.removeEventListener("scroll", handleTableScroll)
      }
    }
  }, [])

  // Scroll to top function for table container
  const scrollToTop = () => {
    console.log("Scroll to top button clicked!")

    const tableContainer = tableContainerRef.current
    if (tableContainer) {
      try {
        // Smooth scroll the table container to top
        tableContainer.scrollTo({
          top: 0,
          behavior: "smooth"
        })
        console.log("Table scrolled to top")
      } catch (error) {
        // Fallback for browsers that don't support smooth scroll
        tableContainer.scrollTop = 0
        console.log("Table scrolled to top (fallback)")
      }
    } else {
      console.error("Table container not found")
    }
  }

  const breadCrumbTitle = "Ledger Report"
  const breadcrumbItem = "Reports"

  const globalDates = useSelector(state => state.GlobalDates)
  const [selectedLedger, setSelectedLedger] = useState("")
  const [fromDate, setFromDate] = useState(globalDates?.fromDate || new Date("2025-01-01T00:00:00")) // Default from date: from global dates
  const [selectedParty, setSelectedParty] = useState("")
  const [selectedParties, setSelectedParties] = useState(null)
  const [selectedVessels, setSelectedVessels] = useState([])
  const [selectedItem, setSelectedItem] = useState("")
  const [selectedItems, setSelectedItems] = useState([])
  const [itemOptions, setItemOptions] = useState([{ value: "", label: "All" }])
  const [shouldRefreshItemOptions, setShouldRefreshItemOptions] = useState(true)
  const [ledgerDropdown, setLedgerDropdown] = useState([]) // Multi-select ledger dropdown
  const [showLedgerModal, setShowLedgerModal] = useState(false)
  const [tempLedgerSelection, setTempLedgerSelection] = useState([]) // Temporary selection in modal
  const [selectedLedgerNames, setSelectedLedgerNames] = useState([]) // Store selected ledger names for grouping
  const [ledgerSearchTerm, setLedgerSearchTerm] = useState("") // Search term for ledger modal
  const [selectedRowIds, setSelectedRowIds] = useState(new Set())
  const [selectionOrder, setSelectionOrder] = useState([])
  const selectAllRef = useRef(null)

  const [selectedPeriod, setSelectedPeriod] = useState([])
  const selectedPeriodRef = useRef([])
  const periodChangedByUser = useRef(false)
  const navStateProcessedRef = useRef(false)
  const fetchReportRequestIdRef = useRef(0)

  // Filters Modal State - for individual dropdown modals
  const [showPartyModal, setShowPartyModal] = useState(false)
  const [showItemModal, setShowItemModal] = useState(false)
  const [showVesselModal, setShowVesselModal] = useState(false)
  const [tempSelectedVessels, setTempSelectedVessels] = useState([])

  // PDF Remarks Modal state
  const [showRemarksModal, setShowRemarksModal] = useState(false)
  const [remarks, setRemarks] = useState('')
  const [pendingShareFile, setPendingShareFile] = useState(null)
  const [showSharePDFModal, setShowSharePDFModal] = useState(false)
  const [showPeriodModal, setShowPeriodModal] = useState(false)
  const [showContractTypeModal, setShowContractTypeModal] = useState(false)
  const [tempSelectedParties, setTempSelectedParties] = useState([])
  const [tempSelectedItems, setTempSelectedItems] = useState([])
  const [tempSelectedPeriod, setTempSelectedPeriod] = useState([])
  const [tempSelectedContractTypes, setTempSelectedContractTypes] = useState([])
  const [selectedContractTypes, setSelectedContractTypes] = useState([])
  const [showPortModal, setShowPortModal] = useState(false)
  const [tempSelectedPorts, setTempSelectedPorts] = useState([])
  const [selectedPorts, setSelectedPorts] = useState([])


  const [toDate, setToDate] = useState(globalDates?.toDate || new Date()) // Default to date: from global dates
  const [loading, setLoading] = useState(false)
  const [ledgerLoading, setLedgerLoading] = useState(true)
  const [showReport, setShowReport] = useState(false)

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(50) // Default 50 rows per page

  // Sorting state
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" })



  // Grouping state - always grouped, determine field based on navigation ledger
  const getGroupByField = () => {
    if (location.state?.ledgerNames) {
      const ledgerNames = location.state.ledgerNames
        .split(",")
        .map(name => name.trim())
      // Check if the ledger name matches more with Seller or Buyer fields
      // For now, we'll group by Seller by default, but this could be enhanced
      // to actually analyze the data and determine the best grouping field
      return "Seller"
    }
    return "Seller" // Default to Seller
  }

  // Modal state for EditContract
  const [showEditContractModal, setShowEditContractModal] = useState(false)
  const [selectedContractData, setSelectedContractData] = useState(null)
  const [modalLoading, setModalLoading] = useState(false)

  // Modal state for Voucher
  const [showVoucherModal, setShowVoucherModal] = useState(false)

  const [voucherMode, setVoucherMode] = useState("save") // "save" or "edit"
  const [voucherLoading, setVoucherLoading] = useState(false)
  const [voucherSearchTerm, setVoucherSearchTerm] = useState("")
  const [voucherErrors, setVoucherErrors] = useState({})
  const [voucherData, setVoucherData] = useState({
    id: 0,
    VoucherNo: "",
    VoucherDate: "",
    F_LedgerMasterDr: "",
    F_LedgerMasterCr: "",
    Amount: "",
    Narration: "",
  })

  const [state, setState] = useState({
    Vessel: "",
    ContractNoSearch: "",
    DeliveryPort: "",
    AdvPayment: "",
    AdvDate: "",
    Seller: "",
    Buyer: "",
    LiftFromDate: "",
    LiftToDate: "",
    ShipFromDate: "",
    ShipToDate: "",
    Completed: false,
    NotStarted: true,
    Pending: true,
    applyGST: false,
    LAP: false,
    LIP: false,
    LedgerArray: [],
    TaxAccountArray: [],
    UnitArray: [],
    ItemArray: [],
    MonthArray: [],
    FillArray: [],
    GlobalArray: [],
    VoucherNoArray: [],
    VoucherHArray: [],
    PeriodDataArray: [],
  })

  // State for managing visible notes
  const [visibleNotes, setVisibleNotes] = useState({
    Note1: true, // Default to Note1
    Note2: false,
    Note3: false,
    Note4: false,
    Note5: false,
    Note6: false,
  })

  // State for Detailed view (Lifting data)
  const [isDetailed, setIsDetailed] = useState(false)

  const API_URL = API_WEB_URLS.MASTER + "/0/token/PartyAccount"
  const API_URL_Get = `${API_WEB_URLS.GetLedgerReportApp}/0/token`
  const API_URL_PeriodData = `${API_WEB_URLS.PeriodData}/0/token`
  const API_URL_SAVE = `${API_WEB_URLS.VoucherH}/0/token`
  const API_URL1 = API_WEB_URLS.MASTER + "/0/token/ContractType"
  const API_URL2 = API_WEB_URLS.MASTER + "/0/token/UnitMaster"
  const API_URL3 = API_WEB_URLS.MASTER + "/0/token/ItemMaster"
  const API_URL4 = API_WEB_URLS.MASTER + "/0/token/MonthMaster"
  const API_URL5 = API_WEB_URLS.MASTER + "/0/token/VoucherNoNew"
  const API_URL6 = API_WEB_URLS.MASTER + "/0/token/VoucherMaster"
  const API_URL_Delete = API_WEB_URLS.MASTER + "/0/token/VoucherH"
  const API_URL7 = API_WEB_URLS.MASTER + "/0/token/UpdateGlobalOptions"

  // Helper function to format date as YYYY-MM-DD without timezone conversion
  const formatDateForInput = (date) => {
    if (!date) return ''
    if (typeof date === 'string') {
      const match = date.match(/^\d{4}-\d{2}-\d{2}/)
      if (match) return match[0]
      const d = new Date(date)
      if (!isNaN(d.getTime())) {
        const year = d.getFullYear()
        const month = String(d.getMonth() + 1).padStart(2, '0')
        const day = String(d.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
      }
      return ''
    }
    if (date instanceof Date && !isNaN(date.getTime())) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    }
    return ''
  }

  // Helper function to handle LAP/LIP date logic
  const handleLapLipDateChange = (lapValue, lipValue) => {
    if (lapValue || lipValue) {
      // If either LAP or LIP is selected, set dates to the PREVIOUS financial year
      // Indian FY runs April 1 → March 31
      // e.g. if today is Sep 30 2026 → current FY is 2026-27 → previous FY is 2025-26
      //      if today is Jan 15 2026 → current FY is 2025-26 → previous FY is 2024-25
      const today = new Date()
      const month = today.getMonth() // 0-indexed; April = 3
      const year  = today.getFullYear()

      // Year in which the current financial year started (April 1)
      const currentFYStartYear = month >= 3 ? year : year - 1

      // Previous FY: April 1 of (currentFYStartYear - 1)  →  March 31 of (currentFYStartYear)
      const financialYearStart = new Date(currentFYStartYear - 1, 3, 1, 0, 0, 0)  // Apr 1
      const financialYearEnd   = new Date(currentFYStartYear, 2, 31, 0, 0, 0)     // Mar 31

      setFromDate(financialYearStart)
      setToDate(financialYearEnd)

      // Auto-select all three color checkboxes (NotStarted/Black, Pending/Red, Completed/Blue)
      setState(prev => ({
        ...prev,
        NotStarted: true,
        Pending: true,
        Completed: true,
      }))
    } else {
      // If both are unselected, revert to global dates
      setFromDate(globalDates?.fromDate ? new Date(globalDates.fromDate) : new Date("2025-01-01T00:00:00"))
      setToDate(globalDates?.toDate ? new Date(globalDates.toDate) : new Date())
    }
  }

  // Helper function to combine notes based on selection
  const getCombinedNotes = row => {
    const notes = []
    if (visibleNotes.Note1 && row.Note1) notes.push(`Note1: ${row.Note1}`)
    if (visibleNotes.Note2 && row.Note2) notes.push(`Note2: ${row.Note2}`)
    if (visibleNotes.Note3 && row.Note3) notes.push(`Note3: ${row.Note3}`)
    if (visibleNotes.Note4 && row.Note4) notes.push(`Note4: ${row.Note4}`)
    if (visibleNotes.Note5 && row.Note5) notes.push(`Note5: ${row.Note5}`)
    if (visibleNotes.Note6 && row.Note6) notes.push(`Note6: ${row.Note6}`)
    return notes.length > 0 ? notes.join(" | ") : "-"
  }

  // Toggle all notes on/off
  const toggleAllNotes = checked => {
    setVisibleNotes({
      Note1: checked,
      Note2: checked,
      Note3: checked,
      Note4: checked,
      Note5: checked,
      Note6: checked,
    })
  }

  useEffect(() => {
    // Inject custom styles to prevent hover effects
    const styleElement = document.createElement("style")
    styleElement.textContent = `
      /* Disable all hover effects on table rows - keep original background */
      .table tbody tr:hover,
      .table tbody tr:hover > td,
      .table tbody tr:hover > th,
      .table-hover tbody tr:hover,
      .table-hover tbody tr:hover > td,
      .table-hover tbody tr:hover > th {
        --bs-table-color-state: var(--bs-table-color) !important;
        --bs-table-bg-state: var(--bs-table-bg) !important;
        --bs-table-accent-bg: transparent !important;
        --bs-table-hover-bg: transparent !important;
        --bs-table-hover-color: inherit !important;
        background-color: white !important;
        background: white !important;
        color: inherit !important;
        transition: none !important;
      }
      .table tbody tr.table-secondary:hover,
      .table tbody tr.table-secondary:hover > td,
      .table tbody tr.table-secondary:hover > th,
      .table-hover tbody tr.table-secondary:hover,
      .table-hover tbody tr.table-secondary:hover > td,
      .table-hover tbody tr.table-secondary:hover > th {
        --bs-table-color-state: var(--bs-table-color) !important;
        --bs-table-bg-state: var(--bs-table-bg) !important;
        --bs-table-accent-bg: transparent !important;
        --bs-table-hover-bg: transparent !important;
        background-color: #f8f8f6 !important;
        background: #f8f8f6 !important;
        transition: none !important;
      }
      .table tbody tr.table-info:hover,
      .table tbody tr.table-info:hover > td,
      .table tbody tr.table-info:hover > th,
      .table-hover tbody tr.table-info:hover,
      .table-hover tbody tr.table-info:hover > td,
      .table-hover tbody tr.table-info:hover > th {
        --bs-table-color-state: var(--bs-table-color) !important;
        --bs-table-bg-state: var(--bs-table-bg) !important;
        --bs-table-accent-bg: transparent !important;
        --bs-table-hover-bg: transparent !important;
        background-color: #d6ebff !important;
        background: #d6ebff !important;
        transition: none !important;
      }
      .table tbody tr.table-danger:hover,
      .table tbody tr.table-danger:hover > td,
      .table tbody tr.table-danger:hover > th,
      .table-hover tbody tr.table-danger:hover,
      .table-hover tbody tr.table-danger:hover > td,
      .table-hover tbody tr.table-danger:hover > th {
        --bs-table-color-state: var(--bs-table-color) !important;
        --bs-table-bg-state: var(--bs-table-bg) !important;
        --bs-table-accent-bg: transparent !important;
        --bs-table-hover-bg: transparent !important;
        background-color: #fde7e9 !important;
        background: #fde7e9 !important;
        transition: none !important;
      }
      
      /* Custom styles for react-select */
      .react-select__control {
        background-color: #f8f9fa !important;
        border: none !important;
        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
        min-height: 38px !important;
        font-size: 0.875rem !important;
        border-radius: 0.375rem !important;
      }
      
      .react-select__control--is-focused {
        box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25) !important;
        border-color: #86b7fe !important;
      }
      
      .react-select__control:hover {
        border-color: #86b7fe !important;
      }
      
      .react-select__menu {
        background-color: white !important;
        border: 1px solid #dee2e6 !important;
        box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
        z-index: 9999 !important;
        border-radius: 0.375rem !important;
        margin-top: 2px !important;
      }
      
      .react-select__option {
        background-color: white !important;
        color: #212529 !important;
        font-size: 0.875rem !important;
        padding: 0.5rem 0.75rem !important;
        cursor: pointer !important;
      }
      
      .react-select__option--is-focused {
        background-color: #e9ecef !important;
        color: #212529 !important;
      }
      
      .react-select__option--is-selected {
        background-color: #0d6efd !important;
        color: white !important;
      }
      
      .react-select__option__placeholder {
        color: #6c757d !important;
        font-size: 0.875rem !important;
      }
      
      .react-select__single-value {
        color: #212529 !important;
        font-size: 0.875rem !important;
        font-weight: 500 !important;
      }
      
      .react-select__input-container {
        color: #212529 !important;
        font-size: 0.875rem !important;
      }
      
      .react-select__indicator-separator {
        display: none !important;
      }
      
      .react-select__clear-indicator {
        color: #6c757d !important;
        cursor: pointer !important;
      }
      
      .react-select__clear-indicator:hover {
        color: #dc3545 !important;
      }
      
      .react-select__dropdown-indicator {
        color: #6c757d !important;
      }
      
      .react-select__dropdown-indicator:hover {
        color: #495057 !important;
      }
      
      /* Custom styles for EditContract modal */
      .edit-contract-modal .modal-xl {
        max-width: 95vw;
      }
      
      .edit-contract-modal .modal-body {
        padding: 0;
        max-height: 80vh;
        overflow-y: auto;
      }
      
      .edit-contract-modal .contract-page {
        padding: 0;
        margin: 0;
      }
      
      .edit-contract-modal .contract-page > div:first-child {
        height: 0;
      }
      
      .edit-contract-modal .contract-form {
        padding: 1rem;
      }
      
      .edit-contract-modal .form-section {
        margin-bottom: 1rem;
      }
      
      .edit-contract-modal .section-title {
        font-size: 0.9rem !important;
        margin-bottom: 0.5rem;
      }
      
      .edit-contract-modal .form-label-sm {
        font-size: 0.7rem !important;
      }
      
      .edit-contract-modal .form-control-sm {
        font-size: 0.75rem !important;
        padding: 0.25rem 0.5rem !important;
      }
      
      .edit-contract-modal .btn-sm {
        font-size: 0.75rem !important;
        padding: 0.25rem 0.5rem !important;
      }
      
      .edit-contract-modal .table-sm th,
      .edit-contract-modal .table-sm td {
        font-size: 0.7rem !important;
        padding: 0.25rem !important;
      }
      
      /* Additional styles for modal mode */
      .contract-modal {
        padding: 0 !important;
        margin: 0 !important;
      }
      
      .contract-form-modal {
        padding: 0.5rem !important;
      }
      
      .form-section-modal {
        margin-bottom: 0.5rem !important;
      }
      
      .section-title-modal {
        font-size: 0.8rem !important;
        margin-bottom: 0.25rem !important;
      }
      
      .contract-modal .form-group {
        margin-bottom: 0.5rem !important;
      }
      
      .contract-modal .form-label-sm {
        font-size: 0.65rem !important;
        margin-bottom: 0.25rem !important;
      }
      
      .contract-modal .form-control-sm {
        font-size: 0.7rem !important;
        padding: 0.2rem 0.4rem !important;
        height: auto !important;
      }
      
      .contract-modal .btn-sm {
        font-size: 0.7rem !important;
        padding: 0.2rem 0.4rem !important;
      }
      
      .contract-modal .table-sm th,
      .contract-modal .table-sm td {
        font-size: 0.65rem !important;
        padding: 0.2rem !important;
      }
      
      .contract-modal .col-md-1,
      .contract-modal .col-md-2,
      .contract-modal .col-md-3,
      .contract-modal .col-md-4,
      .contract-modal .col-md-5,
      .contract-modal .col-md-6,
      .contract-modal .col-md-7 {
        padding: 0 0.25rem !important;
      }
      
      .contract-modal .row.g-0 > .col {
        padding: 0 0.25rem !important;
      }
      
      /* Ensure modal content is visible */
      .edit-contract-modal .modal-content {
        height: 90vh;
        max-height: 90vh;
      }
      
      .edit-contract-modal .modal-body {
        height: calc(90vh - 120px);
        overflow-y: auto;
        padding: 0;
      }
      
      .edit-contract-modal .contract-page {
        height: 100%;
        overflow-y: auto;
        background: white !important;
      }
      
      .edit-contract-modal .contract-form {
        height: 100%;
        padding: 0.5rem;
        background: white !important;
      }
      
      /* Remove purple background and make form container full height */
      .edit-contract-modal .contract-page {
        background: white !important;
        background-image: none !important;
        background: linear-gradient(to bottom, white, white) !important;
        min-height: 100%;
        height: auto;
      }
      
      .edit-contract-modal .contract-form {
        background: white !important;
        background-image: none !important;
        min-height: 100%;
        height: auto;
      }
      
      /* Make form elements more compact in modal */
      .edit-contract-modal .form-control-sm {
        height: 28px !important;
        font-size: 0.7rem !important;
      }
      
      .edit-contract-modal .btn-sm {
        height: 28px !important;
        font-size: 0.7rem !important;
        padding: 0.2rem 0.4rem !important;
      }
      
      .edit-contract-modal .form-label-sm {
        font-size: 0.65rem !important;
        margin-bottom: 0.2rem !important;
      }
      
      .edit-contract-modal .form-group {
        margin-bottom: 0.4rem !important;
      }
      
      /* Override any existing background styles */
      .edit-contract-modal * {
        background-image: none !important;
      }
      
      .edit-contract-modal .contract-page,
      .edit-contract-modal .contract-form,
      .edit-contract-modal .form-section {
        background: white !important;
        background-image: none !important;
      }
      
      /* Override the specific purple background from Contract.scss */
      .edit-contract-modal .contract-page {
        background: white !important;
        background-image: none !important;
        background: linear-gradient(to bottom, white, white) !important;
        background-color: white !important;
        min-height: 100%;
        height: auto;
        position: relative !important;
        top: auto !important;
        left: auto !important;
        right: auto !important;
        bottom: auto !important;
        overflow: visible !important;
      }
      
      /* Force white background on all form elements */
      .edit-contract-modal .form-section {
        background: white !important;
        background-color: white !important;
        background-image: none !important;
        border: 1px solid #dee2e6;
        border-radius: 8px;
        padding: 1rem;
        margin-bottom: 1rem;
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      }
      
      .edit-contract-modal .form-control,
      .edit-contract-modal .form-select,
      .edit-contract-modal input,
      .edit-contract-modal select {
        background: white !important;
        background-color: white !important;
        border: 1px solid #ced4da;
      }
      
      .edit-contract-modal .table {
        background: white !important;
        background-color: white !important;
      }
      
      .edit-contract-modal .table th,
      .edit-contract-modal .table td {
        background: white !important;
        background-color: white !important;
      }
      
      /* Ensure proper spacing and visibility */
      .edit-contract-modal .contract-form {
        background: white !important;
        background-color: white !important;
        padding: 1rem;
        min-height: calc(90vh - 140px);
      }
      
      .edit-contract-modal .contract-page {
        background: white !important;
        background-color: white !important;
        min-height: 100%;
        padding: 0;
      }
      
      /* Additional overrides for Contract.scss */
      .edit-contract-modal .contract-page {
        background: white !important;
        background-image: none !important;
        background: linear-gradient(to bottom, white, white) !important;
        background-color: white !important;
        min-height: 100vh;
        padding: 0;
        margin: 0;
        font-family: inherit;
        position: relative !important;
        top: auto !important;
        left: auto !important;
        right: auto !important;
        bottom: auto !important;
        overflow: visible !important;
      }
      
      /* Table scrollbar styles */
      .table-responsive::-webkit-scrollbar {
        width: 8px;
      }
      
      .table-responsive::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 4px;
      }
      
      .table-responsive::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 4px;
      }
      
      .table-responsive::-webkit-scrollbar-thumb:hover {
        background: #a8a8a8;
      }
      
      /* Ensure table header and footer are visible during scroll */
      .table-responsive thead th {
        position: sticky;
        top: 0;
        z-index: 10;
        background-color: #0000FF !important;
        color: white !important;
      }
      
      .table-responsive tfoot tr {
        position: sticky;
        bottom: 0;
        z-index: 10;
      }
      
      /* Custom styles for Voucher modal */
      .voucher-modal .modal-header {
        background: linear-gradient(135deg, #17a2b8, #138496) !important;
        border-bottom: 2px solid #117a8b;
      }
      
      .voucher-modal .modal-title {
        color: white !important;
        font-weight: 600;
      }
      
      .voucher-modal .form-label {
        color: #495057;
        font-weight: 600;
        font-size: 0.875rem;
        margin-bottom: 0.5rem;
      }
      
      .voucher-modal .form-control,
      .voucher-modal .react-select__control {
        border: 1px solid #ced4da;
        border-radius: 0.375rem;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
      }
      
      .voucher-modal .form-control:focus,
      .voucher-modal .react-select__control--is-focused {
        border-color: #86b7fe;
        box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);
      }
      
      .voucher-modal .btn {
        font-weight: 500;
        border-radius: 0.375rem;
        transition: all 0.15s ease-in-out;
      }
      
      .voucher-modal .btn:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
      }
      
      .voucher-modal .btn-success {
        background: linear-gradient(135deg, #28a745, #20c997);
        border: none;
      }
      
      .voucher-modal .btn-danger {
        background: linear-gradient(135deg, #dc3545, #e74c3c);
        border: none;
      }
      
      .voucher-modal .btn-primary {
        background: linear-gradient(135deg, #007bff, #0056b3);
        border: none;
      }
      
      .voucher-modal .btn-secondary {
        background: linear-gradient(135deg, #6c757d, #495057);
        border: none;
      }
      
      .edit-contract-modal .contract-form {
        background: #fafbfc !important;
        background-color: #fafbfc !important;
        background-image: none !important;
        padding: 0.25rem;
        margin: 0;
        width: 100%;
        height: 100%;
        overflow: auto;
      }
      
      /* Ensure form sections are properly sized and visible */
      .edit-contract-modal .form-section {
        background: white !important;
        background-color: white !important;
        background-image: none !important;
        border: 1px solid #dee2e6;
        border-radius: 8px;
        padding: 1rem;
        margin-bottom: 1rem;
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        min-height: auto;
        height: auto;
        position: relative;
        overflow: visible;
      }
      
      /* Make sure the modal content takes full height */
      .edit-contract-modal .modal-content {
        height: 90vh;
        max-height: 90vh;
        background: white;
      }
      
      .edit-contract-modal .modal-body {
        height: calc(90vh - 120px);
        overflow-y: auto;
        padding: 0;
        background: white;
      }
      
      /* Ensure the contract page takes full modal height */
      .edit-contract-modal .contract-page {
        height: 100%;
        min-height: 100%;
        background: white !important;
        background-color: white !important;
        background-image: none !important;
        position: relative !important;
        overflow: visible !important;
      }
      
      /* Ensure the contract form takes full height */
      .edit-contract-modal .contract-form {
        height: 100%;
        min-height: 100%;
        background: white !important;
        background-color: white !important;
        background-image: none !important;
        overflow: visible !important;
      }
      
      /* Pagination Styles */
      .pagination-controls .btn-outline-primary {
        border-color: #dee2e6;
        color: #6c757d;
        background-color: white;
        transition: all 0.15s ease-in-out;
      }
      
      .pagination-controls .btn-outline-primary:hover:not(:disabled) {
        background-color: #e9ecef;
        border-color: #adb5bd;
        color: #495057;
      }
      
      .pagination-controls .btn-outline-primary:disabled {
        background-color: #f8f9fa;
        border-color: #e9ecef;
        color: #adb5bd;
        cursor: not-allowed;
      }
      
      .pagination-controls .btn-primary {
        background-color: #0d6efd;
        border-color: #0d6efd;
        color: white;
        font-weight: 600;
      }
      
      .pagination-controls .form-select-sm {
        border-color: #dee2e6;
        background-color: #f8f9fa;
        transition: all 0.15s ease-in-out;
      }
      
      .pagination-controls .form-select-sm:focus {
        border-color: #86b7fe;
        box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);
      }
      
      /* Table row transition for smooth interactions */
      .table tbody tr {
        transition: all 0.2s ease-in-out;
      }
      
      /* Improved scrollbar styling */
      .table-responsive::-webkit-scrollbar {
        width: 12px;
        height: 12px;
      }
      
      .table-responsive::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 6px;
      }
      
      .table-responsive::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 6px;
        border: 2px solid #f1f1f1;
      }
      
      .table-responsive::-webkit-scrollbar-thumb:hover {
        background: #a8a8a8;
      }
      
      .table-responsive::-webkit-scrollbar-corner {
        background: #f1f1f1;
      }
      
      /* Better table borders */
      .table-bordered {
        border: 2px solid #dee2e6;
      }
      
      .table-bordered th,
      .table-bordered td {
        border: 1px solid #dee2e6;
      }
      
      /* Enhanced sticky header */
      .table thead th {
        position: sticky;
        top: 0;
        z-index: 10;
        background-color: #0000FF !important;
        color: white !important;
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      }
      
      /* Enhanced sticky footer */
      .table tfoot tr {
        position: sticky;
        bottom: 0;
        z-index: 10;
        box-shadow: 0 -2px 4px rgba(0,0,0,0.1);
      }

      /* Nested modals inside EditContract (add Seller/Buyer/ContractType/Commodity) must render above EditContract modal */
      .modal.edit-contract-nested-modal {
        z-index: 10500 !important;
      }
      .modal-backdrop.edit-contract-nested-backdrop {
        z-index: 10499 !important;
      }
    `
    document.head.appendChild(styleElement)

    const loadLedgers = async () => {
      try {
        setLedgerLoading(true)
        await Fn_FillListData(
          dispatch,
          setState,
          "LedgerArray",
          API_URL + "/Id/0"
        )
        Fn_FillListData(
          dispatch,
          setState,
          "TaxAccountArray",
          API_URL1 + "/Id/0"
        )
        Fn_FillListData(dispatch, setState, "UnitArray", API_URL2 + "/Id/0")
        Fn_FillListData(dispatch, setState, "ItemArray", API_URL3 + "/Id/0")
        Fn_FillListData(dispatch, setState, "MonthArray", API_URL4 + "/Id/0")
        Fn_FillListData(dispatch, setState, "GlobalArray", API_URL7 + "/Id/0")
        Fn_FillListData(
          dispatch,
          setState,
          "VoucherNoArray",
          API_URL5 + "/Id/0"
        )
        Fn_FillListData(dispatch, setState, "VoucherHArray", API_URL6 + "/Id/0")

        setLedgerLoading(false)
      } catch (error) {
        console.error("Error loading ledgers:", error)
        toast.error("Failed to load ledgers")
        setLedgerLoading(false)
      }
    }

    loadLedgers()

    // Cleanup function to remove the style element
    return () => {
      if (styleElement.parentNode) {
        styleElement.parentNode.removeChild(styleElement)
      }
    }
  }, [dispatch, API_URL])

  // Handle mobile-responsive viewport scroll locking to prevent drag-to-refresh
  useEffect(() => {
    const isMobile = () => window.innerWidth <= 768;
    if (isMobile()) {
      document.body.classList.add('no-overscroll');
      document.documentElement.classList.add('no-overscroll');
    }

    const handleResize = () => {
      if (isMobile()) {
        document.body.classList.add('no-overscroll');
        document.documentElement.classList.add('no-overscroll');
      } else {
        document.body.classList.remove('no-overscroll');
        document.documentElement.classList.remove('no-overscroll');
      }
    };
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', () => {
      setTimeout(handleResize, 150);
    });

    return () => {
      window.removeEventListener('resize', handleResize);
      document.body.classList.remove('no-overscroll');
      document.documentElement.classList.remove('no-overscroll');
    };
  }, [])

  // Set first ledger as selected when LedgerArray is loaded and fetch initial data
  useEffect(() => {
    if (state.LedgerArray && state.LedgerArray.length > 0 && !selectedLedger) {
      const firstLedgerId = state.LedgerArray[0].Id.toString()
      setSelectedLedger(firstLedgerId)
    }
  }, [state.LedgerArray])

  // Auto-fetch data whenever selectedLedger changes (including initial load)
  useEffect(() => {
    if (selectedLedger && state.LedgerArray && state.LedgerArray.length > 0) {
      fetchReportData()
    }
  }, [selectedLedger])

  // Auto-fetch data when any filter changes (excluding multi-select items) - debounced to prevent stale intermediate requests
  useEffect(() => {
    if (selectedLedger && state.LedgerArray && state.LedgerArray.length > 0) {
      const timer = setTimeout(() => {
        fetchReportData(null, true)
      }, 250)
      return () => clearTimeout(timer)
    }
  }, [
    selectedParty,
    selectedContractTypes,
    selectedPorts,
    selectedItem,
    fromDate,
    toDate,
    state.Pending,
    state.NotStarted,
    state.Completed,
    state.LAP,
    state.LIP,
  ])

  // Separate useEffect for period changes - only fetch when user explicitly changes period
  useEffect(() => {
    if (periodChangedByUser.current && selectedLedger && state.LedgerArray && state.LedgerArray.length > 0) {
      periodChangedByUser.current = false
      fetchReportData(null, true)
    }
  }, [selectedPeriod])

  useEffect(() => {
    if (selectedLedger && state.LedgerArray && state.LedgerArray.length > 0) {
      fetchReportData(null, false)
    }
  }, [selectedItems])

  // Note: selectedParties is intentionally NOT in the dependency arrays
  // because party filtering happens on frontend only, not via API call

  // Debounced auto-fetch for text inputs (DeliveryPort)
  useEffect(() => {
    if (selectedLedger && state.LedgerArray && state.LedgerArray.length > 0) {
      const timeoutId = setTimeout(() => {
        fetchReportData()
      }, 500) // 500ms delay for text inputs

      return () => clearTimeout(timeoutId)
    }
  }, [state.DeliveryPort, selectedPorts])

  // Handle navigation state from NewLedgerReport (or contractIds for "sirf payload wale contracts")
  useEffect(() => {
    if (location.state && !navStateProcessedRef.current) {
      const { ledgerIds: navLedgerIds, ledgerNames, fromDate: navFromDate, toDate: navToDate, itemIds, contractIds, completed, notStarted, pending } = location.state

      // Parse nav dates properly
      let parsedFromDate = null
      let parsedToDate = null
      if (navFromDate) {
        parsedFromDate = navFromDate instanceof Date
          ? navFromDate
          : new Date(typeof navFromDate === 'string' ? navFromDate.split('T')[0] + 'T00:00:00' : navFromDate)
        setFromDate(parsedFromDate)
      }
      if (navToDate) {
        parsedToDate = navToDate instanceof Date
          ? navToDate
          : new Date(typeof navToDate === 'string' ? navToDate.split('T')[0] + 'T00:00:00' : navToDate)
        setToDate(parsedToDate)
      }

      // Apply filter overrides from nav (Completed: false, NotStarted: true, Pending: true when coming from NewLedgerReport)
      const filterOverrides = (completed !== undefined || notStarted !== undefined || pending !== undefined)
        ? {
          completed: completed !== undefined ? Boolean(completed) : false,
          notStarted: notStarted !== undefined ? Boolean(notStarted) : true,
          pending: pending !== undefined ? Boolean(pending) : true,
        }
        : null
      if (filterOverrides) {
        setState(prev => ({
          ...prev,
          Completed: filterOverrides.completed,
          NotStarted: filterOverrides.notStarted,
          Pending: filterOverrides.pending,
        }))
      }

      // Prefer comma-separated ledgerIds from NewLedgerReport (no dependency on LedgerArray)
      if (navLedgerIds && typeof navLedgerIds === 'string' && navLedgerIds.trim()) {
        navStateProcessedRef.current = true
        const ledgerIdsStr = navLedgerIds.trim()
        const ledgerIdList = ledgerIdsStr.split(",").map(id => id.trim()).filter(id => id)
        if (ledgerIdList.length > 0) {
          setSelectedLedger(ledgerIdList.join(","))
          setLedgerDropdown(ledgerIdList)
          if (ledgerNames && typeof ledgerNames === 'string') {
            setSelectedLedgerNames(ledgerNames.split(",").map(name => name.trim()).filter(Boolean))
          }
          const contractIdsStr = Array.isArray(contractIds)
            ? contractIds.join(",")
            : (typeof contractIds === 'string' ? contractIds : '')
          autoFetchLedgerData(ledgerIdsStr, parsedFromDate || navFromDate, parsedToDate || navToDate, itemIds, contractIdsStr, filterOverrides)
        }
        try {
          window.history.replaceState({}, document.title)
        } catch (e) {
          console.warn("Could not clear history state:", e)
        }
      } else if (ledgerNames && state.LedgerArray && state.LedgerArray.length > 0) {
        navStateProcessedRef.current = true
        // Fallback: convert ledger names to IDs when LedgerArray is loaded
        const ledgerNameList = ledgerNames.split(",").map(name => name.trim())
        const ledgerIds = ledgerNameList
          .map(name => {
            const ledger = state.LedgerArray.find(l => l.Name === name)
            return ledger ? ledger.Id : null
          })
          .filter(id => id !== null)

        if (ledgerIds.length > 0) {
          setSelectedLedger(ledgerIds.join(","))
          setLedgerDropdown(ledgerIds)
          setSelectedLedgerNames(ledgerNameList)
          const contractIdsStr = Array.isArray(contractIds)
            ? contractIds.join(",")
            : (typeof contractIds === 'string' ? contractIds : '')
          autoFetchLedgerData(ledgerIds.join(","), parsedFromDate || navFromDate, parsedToDate || navToDate, itemIds, contractIdsStr, filterOverrides)
        }
        try {
          window.history.replaceState({}, document.title)
        } catch (e) {
          console.warn("Could not clear history state:", e)
        }
      }
    }
  }, [location.state, state.LedgerArray])

  // Auto-fetch ledger data function (contractIds = comma-separated IDs; filterOverrides = { completed, notStarted, pending } from nav)
  const autoFetchLedgerData = async (ledgerIds, fromDate, toDate, itemIds, contractIds = '', filterOverrides = null) => {
    try {
      setShouldRefreshItemOptions(true)
      setLoading(true)
      setShowReport(false)

      const completed = filterOverrides ? filterOverrides.completed : state.Completed
      const notStarted = filterOverrides ? filterOverrides.notStarted : state.NotStarted
      const pending = filterOverrides ? filterOverrides.pending : state.Pending

      let vformData = new FormData()
      vformData.append("LedgerIds", ledgerIds)
      vformData.append("FromDate", formatDateForInput(fromDate))
      vformData.append("ToDate", formatDateForInput(toDate))
      vformData.append("Completed", completed ? true : false)
      vformData.append("NotStarted", notStarted ? true : false)
      vformData.append("Pending", pending ? true : false)

      const itemIdsCsv = Array.isArray(itemIds)
        ? itemIds.map(id => id?.toString().trim()).filter(id => id).join(",")
        : itemIds
          ? itemIds
            .toString()
            .split(",")
            .map(id => id.trim())
            .filter(id => id)
            .join(",")
          : ""
      vformData.append("ItemIds", itemIdsCsv)

      const contractIdsStr = typeof contractIds === 'string' ? contractIds.trim() : (Array.isArray(contractIds) ? contractIds.join(",") : '')
      if (contractIdsStr) vformData.append("ContractIds", contractIdsStr)

      const result = await Fn_GetReport(
        dispatch,
        setState,
        "FillArray",
        API_URL_Get,
        { arguList: { id: 0, formData: vformData } },
        true
      )

      if (!result || (Array.isArray(result) && result.length === 0)) {
        setState(prev => ({
          ...prev,
          FillArray: [],
          isProgress: false,
        }))
      }

      // Fetch period data for dropdown (pass filter overrides so NotLifted/PartialLift/FullLift match)
      await fetchPeriodData(
        ledgerIds,
        formatDateForInput(fromDate),
        formatDateForInput(toDate),
        itemIdsCsv,
        filterOverrides ? { completed, notStarted, pending } : null
      )

      setShowReport(true)
    } catch (error) {
      console.error("Error auto-fetching ledger data:", error)
      toast.error("Error loading ledger data")
    } finally {
      setLoading(false)
    }
  }

  // Fetch period data for dropdown (filterOverrides = { completed, notStarted, pending } when from nav)
  const fetchPeriodData = async (ledgerIds, fromDate, toDate, itemIds, filterOverrides = null) => {
    try {
      const notStarted = filterOverrides ? filterOverrides.notStarted : state.NotStarted
      const pending = filterOverrides ? filterOverrides.pending : state.Pending
      const completed = filterOverrides ? filterOverrides.completed : state.Completed

      let vformData = new FormData()
      vformData.append("LedgerIds", ledgerIds)
      // fromDate and toDate are already formatted strings here
      vformData.append("FromDate", fromDate || "")
      vformData.append("ToDate", toDate || "")
      vformData.append("ItemIds", itemIds || "")
      vformData.append("NotLifted", notStarted ? true : false)
      vformData.append("PartialLift", pending ? true : false)
      vformData.append("FullLift", completed ? true : false)

      await Fn_GetReport(
        dispatch,
        setState,
        "PeriodDataArray",
        API_URL_PeriodData,
        { arguList: { id: 0, formData: vformData } },
        true
      )
    } catch (error) {
      console.error("Error fetching period data:", error)
    }
  }

  // Modal functions
  const openEditContractModal = contractData => {
    setSelectedContractData(contractData)
    setShowEditContractModal(true)
    setModalLoading(true)

    // Set loading to false after a short delay to simulate loading
    setTimeout(() => {
      setModalLoading(false)
    }, 1000)
  }

  const closeEditContractModal = () => {
    setShowEditContractModal(false)
    setSelectedContractData(null)
    setModalLoading(false)
  }

  // Voucher Modal functions
  const openVoucherModal = (mode = "save", voucherId = null) => {
    setVoucherMode(mode)
    setVoucherErrors({})
    setVoucherSearchTerm("")

    if (mode === "save") {
      // Save mode: Get next voucher number from VoucherNoArray
      const nextVoucherNo =
        state.VoucherNoArray && state.VoucherNoArray.length > 0
          ? state.VoucherNoArray[0]?.VoucherNoNew || ""
          : ""

      setVoucherData({
        id: 0,
        VoucherNo: nextVoucherNo,
        VoucherDate: new Date(),
        F_LedgerMasterDr: "",
        F_LedgerMasterCr: "",
        Amount: "",
        Narration: "",
      })
    } else if (mode === "edit" && voucherId) {
      // Edit mode: Find voucher data from VoucherHArray
      const voucherToEdit = state.VoucherHArray.find(v => v.Id === voucherId)
      if (voucherToEdit) {
        setVoucherData({
          id: voucherToEdit.Id,
          VoucherNo: voucherToEdit.VoucherNo || "",
          VoucherDate: voucherToEdit.VoucherDate
            ? new Date(voucherToEdit.VoucherDate)
            : new Date(),
          F_LedgerMasterDr: voucherToEdit.F_LedgerMasterDr || "",
          F_LedgerMasterCr: voucherToEdit.F_LedgerMasterCr || "",
          Amount: voucherToEdit.Amount || "",
          Narration: voucherToEdit.Narration || "",
        })
      }
    }

    setShowVoucherModal(true)
  }

  const closeVoucherModal = () => {
    setShowVoucherModal(false)
    setVoucherMode("save")
    setVoucherData({
      id: 0,
      VoucherNo: "",
      VoucherDate: "",
      F_LedgerMasterDr: "",
      F_LedgerMasterCr: "",
      Amount: "",
      Narration: "",
    })
    setVoucherErrors({})
    setVoucherSearchTerm("")
  }

  const handleSaveVoucher = async e => {
    e.preventDefault()

    // Validate form before submission
    if (!validateVoucherForm()) {
      toast.error("Please fix the errors in the form")
      return
    }

    setVoucherLoading(true)

    try {
      if (voucherMode === "save") {
        // Save new voucher
        let vformData = new FormData()
        vformData.append("F_LedgerMasterDr", voucherData.F_LedgerMasterDr || 0)
        vformData.append("F_LedgerMasterCr", voucherData.F_LedgerMasterCr || 0)
        vformData.append("Amount", voucherData.Amount || 0)
        vformData.append("Narration", voucherData.Narration || "")
        vformData.append(
          "VoucherDate",
          voucherData.VoucherDate
            ? voucherData.VoucherDate.toISOString().split("T")[0]
            : ""
        )
        vformData.append("VoucherNo", voucherData.VoucherNo || "")

        const res = await Fn_AddEditData(
          dispatch,
          setState,
          { arguList: { id: 0, formData: vformData } },
          API_URL_SAVE,
          true,
          "LedgerReport",
          navigate,
          "#"
        )

        if (res) {
          toast.success("Voucher saved successfully!")
          // Refresh voucher data
          await Promise.all([
            Fn_FillListData(
              dispatch,
              setState,
              "VoucherHArray",
              API_URL6 + "/Id/0"
            ),
            Fn_FillListData(
              dispatch,
              setState,
              "VoucherNoArray",
              API_URL5 + "/Id/0"
            ),
          ])
          // Reset form for new voucher
          setVoucherData({
            id: 0,
            VoucherNo:
              state.VoucherNoArray && state.VoucherNoArray.length > 0
                ? state.VoucherNoArray[0]?.VoucherNoNew || ""
                : "",
            VoucherDate: new Date(),
            F_LedgerMasterDr: "",
            F_LedgerMasterCr: "",
            Amount: "",
            Narration: "",
          })
          setVoucherMode("save")
          setVoucherErrors({})
        }
      } else if (voucherMode === "edit") {
        // Update existing voucher
        let vformData = new FormData()
        vformData.append("F_LedgerMasterDr", voucherData.F_LedgerMasterDr || 0)
        vformData.append(
          "VoucherDate",
          voucherData.VoucherDate
            ? voucherData.VoucherDate.toISOString().split("T")[0]
            : ""
        )
        vformData.append("F_LedgerMasterCr", voucherData.F_LedgerMasterCr || 0)
        vformData.append("Amount", voucherData.Amount || 0)
        vformData.append("Narration", voucherData.Narration || "")
        vformData.append("VoucherNo", voucherData.VoucherNo || "")

        const res = await Fn_AddEditData(
          dispatch,
          setState,
          { arguList: { id: voucherData.id, formData: vformData } },
          API_URL_SAVE,
          true,
          "LedgerReport",
          navigate,
          "#"
        )

        if (res) {
          toast.success("Voucher updated successfully!")
          // Refresh voucher data
          await Promise.all([
            Fn_FillListData(
              dispatch,
              setState,
              "VoucherHArray",
              API_URL6 + "/Id/0"
            ),
            Fn_FillListData(
              dispatch,
              setState,
              "VoucherNoArray",
              API_URL5 + "/Id/0"
            ),
          ])
          closeVoucherModal()
        }
      }
    } catch (error) {
      console.error("Error saving voucher:", error)
      toast.error("Failed to save voucher")
    } finally {
      setVoucherLoading(false)
    }
  }

  const validateVoucherForm = () => {
    const errors = {}

    if (!voucherData.F_LedgerMasterDr) {
      errors.F_LedgerMasterDr = "Cash/Bank is required"
    }

    if (!voucherData.F_LedgerMasterCr) {
      errors.F_LedgerMasterCr = "Party Name is required"
    }

    if (!voucherData.Amount || parseFloat(voucherData.Amount) <= 0) {
      errors.Amount = "Valid amount is required"
    }

    if (!voucherData.VoucherDate) {
      errors.VoucherDate = "Voucher date is required"
    }

    setVoucherErrors(errors)
    return Object.keys(errors).length === 0
  }

  const handleDeleteVoucher = async Id => {
    if (
      window.confirm(
        "Are you sure you want to delete this voucher? This action cannot be undone."
      )
    ) {
      setVoucherLoading(true)
      Fn_DeleteData(dispatch, setState, Id, `${API_URL_Delete}`, true)
      closeVoucherModal()
    }
  }

  function formatDate(date) {
    if (!date) return ""
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, "0")
    const day = String(date.getDate()).padStart(2, "0")
    return `${year}-${month}-${day}`
  }

  // Get unique items from FillArray
  const buildItemOptions = data => {
    if (!data || data.length === 0) {
      return [{ value: "", label: "All" }]
    }

    const uniqueItemsMap = new Map()
    data.forEach(row => {
      if (row.Item && row.Item.trim() && row.F_ItemType !== null && row.F_ItemType !== undefined) {
        const key = String(row.F_ItemType)
        if (!uniqueItemsMap.has(key)) {
          uniqueItemsMap.set(key, row.Item.trim())
        }
      }
    })

    const items = Array.from(uniqueItemsMap.entries())
      .sort((a, b) => a[1].localeCompare(b[1]))
      .map(([value, label]) => ({ value, label }))

    return [{ value: "", label: "All" }, ...items]
  }

  // Calculate totals for a specific ledger group
  const calculateLedgerGroupTotals = groupItems => {
    if (!groupItems || groupItems.length === 0) {
      return {
        totalPurQty: 0,
        totalSelQty: 0,
        purchaseAvgRate: 0,
        sellAvgRate: 0,
        totalSAdvPayment: 0,
        totalPAdvPayment: 0,
      }
    }

    let totalPurQty = 0
    let totalSelQty = 0
    let totalPurchaseWeightedValue = 0
    let totalSellWeightedValue = 0
    let purchaseCount = 0
    let sellCount = 0
    let totalSAdvPayment = 0
    let totalPAdvPayment = 0

    // First pass: Calculate total quantities and adv payments
    groupItems.forEach(item => {
      const purQty = parseFloat(item.PurQty) || 0
      const selQty = parseFloat(item.SelQty) || 0
      const advPayment = parseFloat(item.AdvPayment) || 0

      if (item.Status === "P") {
        // Purchase/Buy
        totalPurQty += purQty
        purchaseCount++
        totalPAdvPayment += advPayment
      } else if (item.Status === "S") {
        // Sell
        totalSelQty += selQty
        sellCount++
        totalSAdvPayment += advPayment
      }
    })

    // Second pass: Calculate weighted average rates
    groupItems.forEach(item => {
      const purQty = parseFloat(item.PurQty) || 0
      const selQty = parseFloat(item.SelQty) || 0
      const rate = parseFloat(item.Rate) || 0

      if (item.Status === "P" && totalPurQty > 0) {
        // Purchase/Buy
        totalPurchaseWeightedValue +=
          (parseFloat(purQty) * parseFloat(rate)) / totalPurQty
      } else if (item.Status === "S" && totalSelQty > 0) {
        // Sell
        totalSellWeightedValue +=
          (parseFloat(selQty) * parseFloat(rate)) / totalSelQty
      }
    })

    return {
      totalPurQty,
      totalSelQty,
      purchaseAvgRate:
        purchaseCount > 0
          ? parseFloat(totalPurchaseWeightedValue.toFixed(2))
          : 0,
      sellAvgRate:
        sellCount > 0 ? parseFloat(totalSellWeightedValue.toFixed(2)) : 0,
      totalSAdvPayment,
      totalPAdvPayment,
    }
  }

  // Helper to check if a name is in full capital letters
  const isFullCapital = (name) => {
    if (!name || typeof name !== 'string') return false;
    const trimmed = name.trim();
    return /[A-Z]/.test(trimmed) && !/[a-z]/.test(trimmed);
  };

  // Helper to render party name with highlight if full capital
  const renderPartyName = (name, type) => {
    if (!name || name === '-') return '-';
    const isCapital = isFullCapital(name);
    const highlightColor = type === 'seller' ? '#c2185b' : '#0d47a1';

    if (isCapital) {
      return (
        <span
          style={{
            backgroundColor: '#fff59d',
            color: highlightColor,
            padding: '1px 5px',
            borderRadius: '3px',
            border: '1px solid #fbc02d',
            fontWeight: '800',
            display: 'inline-block',
            boxShadow: '0 1px 2px rgba(0,0,0,0.12)',
            maxWidth: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
          title="Full Capital Name"
        >
          {name}
        </span>
      );
    }

    return name;
  };

  // Extract unique parties from Buyer and Seller columns
  const getUniquePartiesFromData = () => {
    if (!state.FillArray || state.FillArray.length === 0) return []

    const partiesSet = new Set()

    state.FillArray.forEach(row => {
      if (row.Buyer && row.Buyer.trim()) {
        partiesSet.add(row.Buyer.trim())
      }
      if (row.Seller && row.Seller.trim()) {
        partiesSet.add(row.Seller.trim())
      }
    })

    // Convert to array of objects with label and value properties
    return Array.from(partiesSet).sort().map(party => ({
      value: party,
      label: party
    }))
  }

  // Extract unique ports from DeliveryPort column
  const getUniquePortsFromData = () => {
    if (!state.FillArray || state.FillArray.length === 0) return []

    const portsSet = new Set()

    state.FillArray.forEach(row => {
      if (row.DeliveryPort && row.DeliveryPort.trim()) {
        portsSet.add(row.DeliveryPort.trim())
      }
    })

    // Convert to array of objects with label and value properties
    return Array.from(portsSet).sort().map(port => ({
      value: port,
      label: port
    }))
  }

  const getRowIdentifier = row => {
    if (!row) return ""
    if (row.Id !== undefined && row.Id !== null) {
      return String(row.Id)
    }
    if (row.AutoId !== undefined && row.AutoId !== null) {
      return String(row.AutoId)
    }
    return [
      row.ContractNo || "NA",
      row.ContractDate || "NA",
      row.Seller || "NA",
      row.Buyer || "NA",
      row.Item || "NA",
      row.Rate || "NA",
    ].join("_")
  }

  const toggleRowSelection = row => {
    const rowId = getRowIdentifier(row)
    if (!rowId) return
    if (selectedRowIds.has(rowId)) {
      setSelectedRowIds(prev => { const updated = new Set(prev); updated.delete(rowId); return updated })
      setSelectionOrder(prev => prev.filter(id => id !== rowId))
    } else {
      setSelectedRowIds(prev => { const updated = new Set(prev); updated.add(rowId); return updated })
      setSelectionOrder(prev => [...prev, rowId])
    }
  }

  // Select all rows by default when FillArray is populated
  useEffect(() => {
    if (state.FillArray && state.FillArray.length > 0) {
      const allRowIds = state.FillArray
        .map(row => getRowIdentifier(row))
        .filter(id => Boolean(id))
      setSelectedRowIds(new Set(allRowIds))
      setSelectionOrder(allRowIds)
      
      setSelectedParties(null)
    }
  }, [state.FillArray])

  // Group data by ledger names function - create separate groups for each ledger
  const getGroupedData = data => {
    if (!data || data.length === 0) return data

    // Filter data by selected items if any specific items are selected
    let filteredData = data
    const hasSpecificItemsSelected =
      selectedItems &&
      selectedItems.length > 0 &&
      !(selectedItems.length === 1 && selectedItems[0] === "")

    if (hasSpecificItemsSelected) {
      filteredData = data.filter(row =>
        row.F_ItemType !== null &&
        row.F_ItemType !== undefined &&
        selectedItems.some(selectedItem => String(row.F_ItemType) === String(selectedItem))
      )
    }

    // Filter data by selected parties if any parties are selected
    if (selectedParties !== null) {
      const selectedPartiesLower = selectedParties.map(p => p.toLowerCase())
      filteredData = filteredData.filter(row => {
        const buyer = row.Buyer ? row.Buyer.trim().toLowerCase() : null
        const seller = row.Seller ? row.Seller.trim().toLowerCase() : null
        
        const isBuyerValid = buyer ? selectedPartiesLower.includes(buyer) : true
        const isSellerValid = seller ? selectedPartiesLower.includes(seller) : true
        
        return isBuyerValid && isSellerValid
      })
    }

    // Filter data by selected vessel if one is selected
    if (selectedVessels.length > 0) {
      const vesselSet = selectedVessels.map(v => v.toLowerCase())
      filteredData = filteredData.filter(row =>
        row.Vessel && vesselSet.includes(row.Vessel.trim().toLowerCase())
      )
    }

    // Get all ledger names - prioritize modal selection over navigation
    let ledgerNamesFromNav = []

    // First, check if we have selected ledger names from modal
    if (selectedLedgerNames.length > 0) {
      ledgerNamesFromNav = selectedLedgerNames
    }
    // Otherwise, use navigation state ledger names
    else if (location.state?.ledgerNames) {
      ledgerNamesFromNav = location.state.ledgerNames
        .split(",")
        .map(name => name.trim())
        .filter(Boolean)
    }

    const deriveItemFields = (item, ledgerName) => {
      let newStatus = item.Status || "-"
      const compareName = ledgerName || item.Ledger || ""
      if (compareName && item.Seller && item.Seller === compareName) {
        newStatus = "S"
      } else if (compareName && item.Buyer && item.Buyer === compareName) {
        newStatus = "P"
      }
      const qty = parseFloat(item.Qty) || 0
      return {
        ...item,
        Status: newStatus,
        PurQty: newStatus === "P" ? qty : 0,
        SelQty: newStatus === "S" ? qty : 0,
      }
    }

    if (ledgerNamesFromNav.length === 0) {
      // Fallback: show all data in one group if no ledger names
      const mappedAll = filteredData.map(item => deriveItemFields(item, null))
      return [
        {
          isGroup: true,
          groupName: "All Records",
          ledgerName: "All Records",
          count: mappedAll.length,
          items: mappedAll,
          groupByField: "none",
        },
      ]
    }

    let allGroups = []

    // Create separate groups for each ledger name
    // Each ledger independently shows all contracts where it appears (as Seller OR Buyer)
    ledgerNamesFromNav.forEach((ledgerName, index) => {
      // Find items that match this ledger name in either Seller or Buyer
      const matchingItems = filteredData
        .filter(item => {
          const sellerMatch = item.Seller && item.Seller === ledgerName
          const buyerMatch = item.Buyer && item.Buyer === ledgerName
          return sellerMatch || buyerMatch
        })
        // Deduplicate within this group only: if same ContractNo appears multiple times, keep only the first one
        .filter((item, index, self) => {
          const contractNo = item.ContractNo ? String(item.ContractNo).trim() : null
          if (!contractNo) return false
          return index === self.findIndex(i => String(i.ContractNo).trim() === contractNo)
        })

      if (matchingItems.length > 0) {
        const mappedItems = matchingItems.map(item => deriveItemFields(item, ledgerName));

        allGroups.push({
          isGroup: true,
          groupName: ledgerName,
          ledgerName: ledgerName,
          ledgerIndex: index + 1,
          count: mappedItems.length,
          items: mappedItems,
          groupByField: "ledger",
        })
      }
    })

    // Add remaining items that don't match any ledger at all
    const matchedContractNos = new Set()
    ledgerNamesFromNav.forEach(ledgerName => {
      filteredData.forEach(item => {
        const sellerMatch = item.Seller && item.Seller === ledgerName
        const buyerMatch = item.Buyer && item.Buyer === ledgerName
        if (sellerMatch || buyerMatch) {
          const contractNo = item.ContractNo ? String(item.ContractNo).trim() : null
          if (contractNo) matchedContractNos.add(contractNo)
        }
      })
    })

    const remainingItems = filteredData
      .filter(item => {
        const contractNo = item.ContractNo ? String(item.ContractNo).trim() : null
        return contractNo && !matchedContractNos.has(contractNo)
      })
      // Deduplicate within remaining group
      .filter((item, index, self) => {
        const contractNo = item.ContractNo ? String(item.ContractNo).trim() : null
        if (!contractNo) return false
        return index === self.findIndex(i => String(i.ContractNo).trim() === contractNo)
      })

    if (remainingItems.length > 0) {
      const mappedRemaining = remainingItems.map(item => deriveItemFields(item, null))
      allGroups.push({
        isGroup: true,
        groupName: "Other Records",
        ledgerName: "Other Records",
        count: mappedRemaining.length,
        items: mappedRemaining,
        groupByField: "none",
      })
    }

    return allGroups
  }

  // Sort data function
  const getSortedData = data => {
    if (!sortConfig.key) return data

    return [...data].sort((a, b) => {
      let aVal = a[sortConfig.key]
      let bVal = b[sortConfig.key]

      // Handle numeric values
      if (typeof aVal === "number" || !isNaN(parseFloat(aVal))) {
        aVal = parseFloat(aVal) || 0
        bVal = parseFloat(bVal) || 0
      }

      // Handle date values
      if (sortConfig.key.includes("Date") || sortConfig.key.includes("date")) {
        aVal = new Date(aVal)
        bVal = new Date(bVal)
      }

      if (aVal < bVal) {
        return sortConfig.direction === "asc" ? -1 : 1
      }
      if (aVal > bVal) {
        return sortConfig.direction === "asc" ? 1 : -1
      }
      return 0
    })
  }

  // Process data with grouping and sorting - always grouped
  const processedData = () => {
    if (!state.FillArray || state.FillArray.length === 0) return []

    let data = state.FillArray

    // Always create grouped data structure
    const groupedData = getGroupedData(data)

    // Sort items within each group
    groupedData.forEach(group => {
      group.items = getSortedData(group.items)
    })

    return groupedData
  }

  // Flatten processed data for pagination calculation - always grouped
  const flattenedData = () => {
    const data = processedData()
    // For grouped data, flatten to get total count
    return data.reduce((acc, group) => [...acc, ...group.items], [])
  }

  // Current page data for display - always grouped
  const currentPageData = () => {
    const data = processedData()
    // For grouped data, we'll handle pagination in rendering
    return data
  }

  // Pagination calculations - always grouped
  const totalRecords = flattenedData().length
  const totalPages = Math.ceil(totalRecords / rowsPerPage)

  // Reset pagination when data changes
  useEffect(() => {
    setCurrentPage(1)
  }, [state.FillArray])

  useEffect(() => {
    if (!state.FillArray) return

    if (shouldRefreshItemOptions) {
      setItemOptions(buildItemOptions(state.FillArray))
    }
  }, [state.FillArray, shouldRefreshItemOptions])

  // Pagination handlers
  const handlePageChange = page => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page)
    }
  }

  const handleRowsPerPageChange = newRowsPerPage => {
    setRowsPerPage(newRowsPerPage)
    setCurrentPage(1) // Reset to first page when changing page size
  }

  // Sorting function
  const handleSort = key => {
    let direction = "asc"
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc"
    }
    setSortConfig({ key, direction })
  }

  const tableData = currentPageData()
  const flattenedVisibleRows = tableData.reduce((acc, group) => {
    if (group && Array.isArray(group.items)) {
      return acc.concat(group.items)
    }
    return acc
  }, [])
  const visibleRowIds = flattenedVisibleRows
    .map(getRowIdentifier)
    .filter(id => Boolean(id))
  const allVisibleRowsSelected =
    visibleRowIds.length > 0 &&
    visibleRowIds.every(id => selectedRowIds.has(id))
  const someVisibleRowsSelected = visibleRowIds.some(id =>
    selectedRowIds.has(id)
  )

  const handleSelectAllVisibleRows = () => {
    if (visibleRowIds.length === 0) return
    setSelectedRowIds(prev => {
      const updated = new Set(prev)
      if (allVisibleRowsSelected) {
        visibleRowIds.forEach(id => updated.delete(id))
        setSelectionOrder(prev => prev.filter(id => !visibleRowIds.includes(id)))
      } else {
        const newIds = visibleRowIds.filter(id => !updated.has(id))
        visibleRowIds.forEach(id => updated.add(id))
        setSelectionOrder(prev => [...prev, ...newIds])
      }
      return updated
    })
  }

  useEffect(() => {
    if (selectAllRef.current) {
      selectAllRef.current.indeterminate =
        someVisibleRowsSelected && !allVisibleRowsSelected
    }
  }, [someVisibleRowsSelected, allVisibleRowsSelected])

  // Handle ledger modal OK button
  const handleLedgerModalOk = async () => {
    if (tempLedgerSelection.length === 0) {
      toast.warning("Please select at least one ledger")
      return
    }

    // Convert selected IDs to comma-separated string
    const ledgerIdsString = tempLedgerSelection.join(",")
    setSelectedLedger(ledgerIdsString)
    setLedgerDropdown(tempLedgerSelection)

    // Get ledger names for grouping
    const names = tempLedgerSelection
      .map(id => {
        const ledger = state.LedgerArray.find(l => l.Id === id)
        return ledger ? ledger.Name : null
      })
      .filter(Boolean)

    setSelectedLedgerNames(names)

    // Close modal
    setShowLedgerModal(false)

    toast.success(`${tempLedgerSelection.length} ledger(s) selected`)

    // Auto-fetch report data with the selected ledger IDs
    await fetchReportData(ledgerIdsString)
  }

  // Handle opening ledger modal
  const handleOpenLedgerModal = () => {
    setTempLedgerSelection(ledgerDropdown)
    setLedgerSearchTerm("")
    setShowLedgerModal(true)
  }

  // Handle ledger toggle in modal
  const handleLedgerToggle = (ledgerId) => {
    setTempLedgerSelection(prev =>
      prev.includes(ledgerId)
        ? prev.filter(id => id !== ledgerId)
        : [...prev, ledgerId]
    )
  }

  // Handle select all ledgers
  const handleSelectAllLedgers = () => {
    const filteredLedgers = getFilteredLedgers()
    const allIds = filteredLedgers.map(ledger => ledger.Id)
    setTempLedgerSelection(allIds)
  }

  // Handle deselect all ledgers
  const handleDeselectAllLedgers = () => {
    setTempLedgerSelection([])
  }

  // Handle multi-select item changes with support for the "All" option
  const handleSelectedItemsChange = newSelectedItems => {
    if (!newSelectedItems || newSelectedItems.length === 0) {
      setSelectedItems([])
      return
    }

    let normalized = newSelectedItems.map(item => (item === "" ? "" : String(item)))

    if (normalized.includes("") && normalized.length > 1) {
      normalized = normalized.filter(item => item !== "")
    }

    setSelectedItems(normalized)
  }

  // Vessel modal handlers
  const openVesselModal = () => {
    setTempSelectedVessels([...selectedVessels])
    setShowVesselModal(true)
  }
  const closeVesselModal = () => setShowVesselModal(false)
  const handleVesselModalDone = () => {
    setSelectedVessels([...tempSelectedVessels])
    setShowVesselModal(false)
  }
  const getUniqueVesselsFromData = () => {
    return Array.from(new Set((state.FillArray || []).map(r => r.Vessel).filter(Boolean))).sort().map(v => ({ value: v, label: v }))
  }

  // Filters Modal Handlers - Individual dropdown modals
  const openPartyModal = () => {
    if (selectedParties === null) {
      const allParties = getUniquePartiesFromData().map(p => p.value)
      setTempSelectedParties(allParties)
    } else {
      setTempSelectedParties(selectedParties)
    }
    setShowPartyModal(true)
  }

  const closePartyModal = () => {
    setShowPartyModal(false)
  }

  const handlePartyModalDone = () => {
    console.log("=== PARTY CHANGE ===")
    console.log("selectedParties:", JSON.stringify(tempSelectedParties))
    console.log("selectedPeriod state:", JSON.stringify(selectedPeriod))
    console.log("selectedPeriodRef:", JSON.stringify(selectedPeriodRef.current))
    setSelectedParties(tempSelectedParties)
    setShowPartyModal(false)
  }

  const openItemModal = () => {
    setTempSelectedItems(selectedItems)
    setShowItemModal(true)
  }

  const closeItemModal = () => {
    setShowItemModal(false)
  }

  const handleItemModalDone = () => {
    console.log("=== ITEM CHANGE ===")
    console.log("tempSelectedItems:", JSON.stringify(tempSelectedItems))
    console.log("selectedPeriod state:", JSON.stringify(selectedPeriod))
    console.log("selectedPeriodRef:", JSON.stringify(selectedPeriodRef.current))
    // Handle items with normalization
    if (!tempSelectedItems || tempSelectedItems.length === 0) {
      setSelectedItems([])
    } else {
      let normalized = tempSelectedItems.map(item => (item === "" ? "" : String(item)))
      if (normalized.includes("") && normalized.length > 1) {
        normalized = normalized.filter(item => item !== "")
      }
      setSelectedItems(normalized)
    }
    setShowItemModal(false)
  }

  const openPeriodModal = () => {
    console.log("=== OPEN PERIOD MODAL ===")
    console.log("selectedPeriod state:", JSON.stringify(selectedPeriod))
    console.log("selectedPeriodRef:", JSON.stringify(selectedPeriodRef.current))
    const current = selectedPeriod.length > 0 ? selectedPeriod : selectedPeriodRef.current
    console.log("setting tempSelectedPeriod to:", JSON.stringify(current))
    setTempSelectedPeriod([...current])
    setShowPeriodModal(true)
  }

  const closePeriodModal = () => {
    setShowPeriodModal(false)
  }

  const handlePeriodModalDone = () => {
    console.log("=== PERIOD CHANGE ===")
    console.log("tempSelectedPeriod:", JSON.stringify(tempSelectedPeriod))
    console.log("selectedPeriod state before:", JSON.stringify(selectedPeriod))
    console.log("selectedPeriodRef before:", JSON.stringify(selectedPeriodRef.current))
    periodChangedByUser.current = true
    setSelectedPeriod(tempSelectedPeriod)
    selectedPeriodRef.current = [...tempSelectedPeriod]
    setShowPeriodModal(false)
  }

  const openContractTypeModal = () => {
    setTempSelectedContractTypes([...selectedContractTypes])
    setShowContractTypeModal(true)
  }

  const closeContractTypeModal = () => {
    setShowContractTypeModal(false)
  }

  const handleContractTypeModalDone = () => {
    setSelectedContractTypes([...tempSelectedContractTypes])
    setShowContractTypeModal(false)
  }

  const openPortModal = () => {
    setTempSelectedPorts([...selectedPorts])
    setShowPortModal(true)
  }

  const closePortModal = () => {
    setShowPortModal(false)
  }

  const handlePortModalDone = () => {
    setSelectedPorts([...tempSelectedPorts])
    setShowPortModal(false)
  }

  const handleTempSelectedItemsChange = newSelectedItems => {
    if (!newSelectedItems || newSelectedItems.length === 0) {
      setTempSelectedItems([])
      return
    }

    let normalized = newSelectedItems.map(item => (item === "" ? "" : String(item)))

    if (normalized.includes("") && normalized.length > 1) {
      normalized = normalized.filter(item => item !== "")
    }

    setTempSelectedItems(normalized)
  }

  // Get filtered ledgers based on search term
  const getFilteredLedgers = () => {
    if (!state.LedgerArray) return []

    if (!ledgerSearchTerm) return state.LedgerArray

    return state.LedgerArray.filter(ledger =>
      ledger.Name && ledger.Name.toLowerCase().includes(ledgerSearchTerm.toLowerCase())
    )
  }

  // Auto-fetch data function
  const fetchReportData = async (overrideLedgerIds = null, refreshItemOptions = true, contractIdsOverride = '') => {
    setShouldRefreshItemOptions(refreshItemOptions)
    // Use override if provided, otherwise use state
    const ledgerIds = overrideLedgerIds || selectedLedger

    // Validate that a ledger is selected
    if (!ledgerIds) {
      return
    }

    setLoading(true)
    setShowReport(false)

    try {
      let vformData = new FormData()
      vformData.append("LedgerIds", ledgerIds)
      vformData.append("F_PartyLedger", selectedParty || 0)
      const contractTypeIds = selectedContractTypes && selectedContractTypes.length > 0 ? selectedContractTypes.join(",") : "0"
      vformData.append("F_ContractLedger", contractTypeIds)
      vformData.append("LiftingAfterPeriod", state.LAP ? true : false)
      vformData.append("LiftingInPeriod", state.LIP ? true : false)

      vformData.append("F_ItemMaster", selectedItem || 0)
      const selectedItemIds =
        selectedItems && selectedItems.length > 0
          ? selectedItems.filter(item => item !== "")
          : []
      const itemIdsCsv =
        selectedItemIds.length > 0
          ? selectedItemIds.map(id => id.toString().trim()).filter(id => id !== "").join(",")
          : ""
      vformData.append("ItemIds", itemIdsCsv)

      // Send selected periods' names as comma-separated string in SearchValue, or "All" if nothing selected
      const activePeriod = selectedPeriodRef.current
      let searchValue = "All"
      if (activePeriod && activePeriod.length > 0) {
        searchValue = activePeriod.join(",")
      }
      vformData.append("SearchValue", searchValue)

      vformData.append("Vessel", state.Vessel || "")

      const portCsv = selectedPorts && selectedPorts.length > 0 ? selectedPorts.join(",") : ""
      vformData.append("DeliveryPort", portCsv || state.DeliveryPort || "")
      vformData.append("Completed", state.Completed ? true : false)
      vformData.append("NotStarted", state.NotStarted ? true : false)
      vformData.append("Pending", state.Pending ? true : false)

      vformData.append("FromDate", formatDateForInput(fromDate) || "")
      vformData.append("ToDate", formatDateForInput(toDate) || "")

      // When contractIds provided, API returns only those contracts (sirf payload wale)
      const contractIdsParam = typeof contractIdsOverride === 'string' && contractIdsOverride.trim()
        ? contractIdsOverride.trim()
        : ''
      if (contractIdsParam) vformData.append("ContractIds", contractIdsParam)

      // Fetch period data for dropdown
      await fetchPeriodData(
        ledgerIds,
        formatDateForInput(fromDate),
        formatDateForInput(toDate),
        itemIdsCsv
      )

      const currentReqId = ++fetchReportRequestIdRef.current

      const result = await Fn_GetReport(
        dispatch,
        setState,
        "FillArray",
        API_URL_Get,
        { arguList: { id: 0, formData: vformData } },
        true
      )

      if (currentReqId !== fetchReportRequestIdRef.current) {
        return
      }

      if (!result || (Array.isArray(result) && result.length === 0)) {
        setState(prev => ({
          ...prev,
          FillArray: [],
          isProgress: false,
        }))
      }

      setShowReport(true)
      // Show success toast only if not initial load
      if (state.FillArray && state.FillArray.length > 0) {
        toast.success(`Report updated with ${state.FillArray.length} contracts`)
      }
    } catch (error) {
      console.error("Error generating report:", error)
      toast.error("Failed to generate report")
    } finally {
      setLoading(false)
    }
  }

  // Handle global refresh from Navbar
  const handleRefreshDataRef = useRef(null);
  useEffect(() => {
    handleRefreshDataRef.current = async () => {
      window.dispatchEvent(new Event('app-refresh-start'));
      try {
        await fetchReportData(null, true);
      } finally {
        window.dispatchEvent(new Event('app-refresh-end'));
      }
    };
  }, [fetchReportData]);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault(); // Tell Navbar we handled it
      if (handleRefreshDataRef.current) handleRefreshDataRef.current();
    };
    window.addEventListener('app-refresh-data', handler);
    return () => window.removeEventListener('app-refresh-data', handler);
  }, []);

  const handleDownloadPDF = () => {
    if (!pendingShareFile) return
    const url = URL.createObjectURL(pendingShareFile)
    const a = document.createElement('a')
    a.href = url
    a.download = pendingShareFile.name
    a.click()
    URL.revokeObjectURL(url)
    toast.success('PDF downloaded!')
    setShowSharePDFModal(false)
    setPendingShareFile(null)
  }

  const handleSharePDFClick = async () => {
    if (!pendingShareFile || !navigator.share) return
    try {
      await navigator.share({
        title: 'Ledger Report',
        text: 'Please find attached the Ledger Report',
        files: [pendingShareFile]
      })
      toast.success('PDF shared successfully!')
      setShowSharePDFModal(false)
      setPendingShareFile(null)
    } catch (shareError) {
      if (shareError.name === 'AbortError') {
        toast.info('Share cancelled.')
      } else {
        console.error('Share error:', shareError)
        toast.error('Share failed. Try again.')
      }
      setShowSharePDFModal(false)
      setPendingShareFile(null)
    }
  }

  // PDF Export - Open Remarks Modal
  const exportToPDF = () => {
    if (!state.FillArray || state.FillArray.length === 0) {
      toast.error("No data to export")
      return
    }

    if (selectedRowIds.size === 0) {
      toast.warning("Please select at least one contract to export")
      return
    }

    // Open remarks modal
    setRemarks('')
    setShowRemarksModal(true)
  }

  // Generate PDF with jsPDF + jspdf-autotable, then share
  const handleGeneratePDF = async () => {
    if (!state.FillArray || state.FillArray.length === 0) {
      toast.error("No data to export")
      return
    }

    if (selectedRowIds.size === 0) {
      toast.warning("Please select at least one contract to export")
      return
    }

    const rowsForExport = state.FillArray.filter(row =>
      selectedRowIds.has(getRowIdentifier(row))
    )

    if (!rowsForExport || rowsForExport.length === 0) {
      toast.error("Selected contracts are unavailable for export")
      return
    }

    const groupedData = getGroupedData(rowsForExport)
    groupedData.forEach(group => {
      group.items = getSortedData(group.items)
    })
    const ledgerLabel =
      ledgerDropdown.length > 0
        ? ledgerDropdown.map(id => state.LedgerArray.find(l => l.Id === id)?.Name || "").filter(Boolean).join(", ")
        : "All Ledgers"

    // Row font colour matching screen UI: S=red, P=green
    const getRowFill = row => {
      if (row.Status === 'S') return [255, 0, 0]
      if (row.Status === 'P') return [0, 128, 0]
      return [0, 0, 0]
    }

    const allDerivedRowsPDF = groupedData.flatMap(g => g.items || [])
    const overall = calculateLedgerGroupTotals(allDerivedRowsPDF)
    overall.diffAmt = overall.totalSelQty * overall.sellAvgRate - overall.totalPurQty * overall.purchaseAvgRate

    try {
      // -- Landscape A4 gives ~277 mm usable width --
      const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' })
      await registerHindiFont(doc)
      setHindiFont(doc)
      const pageW = doc.internal.pageSize.getWidth()  // 297 mm
      const pageH = doc.internal.pageSize.getHeight() // 210 mm
      const filename = `Ledger_Report_${new Date().toISOString().split('T')[0]}.pdf`

      // -- Top header banner --
      doc.setTextColor(0, 0, 180)
      doc.setFontSize(15)
      doc.setFont('helvetica', 'bold')
      doc.text(`${getCompanyName().toUpperCase()} - LEDGER REPORT`, 8, 9)
      doc.setFontSize(7.5)
      doc.setFont('helvetica', 'normal')
      doc.text(`Ledger: ${ledgerLabel}`, 8, 14)
      doc.text(
        `Period: ${fromDate.toLocaleDateString()} - ${toDate.toLocaleDateString()}   |   Generated: ${new Date().toLocaleString()}`,
        8, 18.5
      )
      doc.setTextColor(0, 0, 0)

      // -- Column definitions (total = 283 mm, margin 7 each side) --
      const cols = [
        { header: 'Sr. No.', dataKey: 'SrNo', width: 12, type: 'number' },
        { header: 'Contract No', dataKey: 'ContractNo', width: 19 },
        { header: 'Date', dataKey: 'ContractDate', width: 18 },
        { header: 'Seller', dataKey: 'Seller', width: 30 },
        { header: 'Buyer', dataKey: 'Buyer', width: 30 },
        { header: 'S/P', dataKey: 'Status', width: 8 },
        { header: 'Item', dataKey: 'Item', width: 20 },
        { header: 'Pur Qty', dataKey: 'PurQty', width: 18, type: 'number' },
        { header: 'Sel Qty', dataKey: 'SelQty', width: 18, type: 'number' },
        { header: 'Rate', dataKey: 'Rate', width: 18 },
        { header: 'Period', dataKey: 'ShipmentOrLifted', width: 16 },
        { header: 'S Adv Pay', dataKey: 'SAdvPayment', width: 18 },
        { header: 'P Adv Pay', dataKey: 'PAdvPayment', width: 18 },
        { header: 'Adv Date', dataKey: 'AdvDate', width: 18 }
      ]

      if (isDetailed) {
        cols.push({ header: 'Lifting (Date|Lorry|BNo|Qty|Rate)', dataKey: 'DetailedLifting', width: 64 });
      }

      const head = [cols.map(c => c.header)]
      const columnStyles = {}
      cols.forEach((col, i) => {
        columnStyles[i] = {
          cellWidth: col.width,
          halign: (col.type === 'number' || col.dataKey.includes('Qty') || col.dataKey === 'Rate' || col.dataKey.includes('AdvPayment')) ? 'right' : 'left',
          overflow: 'linebreak',
        }
      })

      // -- Build body rows --
      // Each group: [header-span-row, ...data-rows, subtotal-span-row]
      const body = []
      const rowMeta = [] // parallel array: { type: 'group'|'data'|'subtotal'|'overall', fill? }

      groupedData.forEach(group => {
        const gt = calculateLedgerGroupTotals(group.items)
        const gtDiffAmt = gt.totalSelQty * gt.sellAvgRate - gt.totalPurQty * gt.purchaseAvgRate

        // Group header row � party name (colSpan 5) + stats cells matching table's tan header row
        const grpRemCols = cols.length - 14
        body.push([
          { content: `${group.groupName}  (${group.count} rec)`, colSpan: 6, styles: { textColor: [44, 62, 80], fontStyle: 'bold', fontSize: 8, cellPadding: { top: 2, bottom: 2, left: 4, right: 2 } } },
          { content: `Buy Qty\n${gt.totalPurQty.toFixed(2)}`, styles: { textColor: [0, 102, 204], fontStyle: 'bold', fontSize: 7.5, halign: 'center', cellPadding: 1.5 } },
          { content: `Sell Qty\n${gt.totalSelQty.toFixed(2)}`, styles: { textColor: [180, 30, 30], fontStyle: 'bold', fontSize: 7.5, halign: 'center', cellPadding: 1.5 } },
          { content: `Buy Avg\n${gt.purchaseAvgRate.toFixed(2)}`, styles: { textColor: [0, 102, 204], fontStyle: 'bold', fontSize: 7.5, halign: 'center', cellPadding: 1.5 } },
          { content: `Sell Avg\n${gt.sellAvgRate.toFixed(2)}`, styles: { textColor: [180, 30, 30], fontStyle: 'bold', fontSize: 7.5, halign: 'center', cellPadding: 1.5 } },
          { content: `Diff Amt\n${gtDiffAmt.toFixed(2)}`, styles: { textColor: gtDiffAmt >= 0 ? [25, 135, 84] : [180, 30, 30], fontStyle: 'bold', fontSize: 7.5, halign: 'center', cellPadding: 1.5 } },
          { content: `S Adv Pay\n${gt.totalSAdvPayment.toFixed(2)}`, styles: { textColor: [180, 30, 30], fontStyle: 'bold', fontSize: 7.5, halign: 'center', cellPadding: 1.5 } },
          { content: `P Adv Pay\n${gt.totalPAdvPayment.toFixed(2)}`, styles: { textColor: [0, 102, 204], fontStyle: 'bold', fontSize: 7.5, halign: 'center', cellPadding: 1.5 } },
          ...(grpRemCols > 0 ? [{ content: '', colSpan: grpRemCols, styles: {} }] : []),
        ])
        rowMeta.push({ type: 'group' })

        // Data rows
        group.items.forEach(row => {
          let liftingString = "";

          if (isDetailed && row.LiftingJson) {
            try {
              const liftingData = JSON.parse(row.LiftingJson);
              if (Array.isArray(liftingData) && liftingData.length > 0) {
                liftingString = liftingData.map(lift => {
                  const date = lift.LiftDate || "-";
                  const qty = Number(lift.LiftedQty).toFixed(4).replace(/\.?0+$/, '');
                  const lorry = lift.LorryNo || "-";
                  const bno = lift.BNo || lift.InvoiceNo || "-";
                  const lRate = lift.Rate != null ? lift.Rate : "-";
                  return `${date} | ${lorry} | ${bno} | ${qty} | ${lRate}`;
                }).join('\n');
              } else { liftingString = "-"; }
            } catch (e) { liftingString = "Invalid Data"; }
          } else if (isDetailed) {
            liftingString = "-";
          }

          const rowPushData = [
            selectionOrder.indexOf(getRowIdentifier(row)) + 1,
            row.ContractNo || '',
            row.ContractDate || '',
            row.Seller || '',
            row.Buyer || '',
            row.Status || '',
            row.Item || '',
            row.PurQty != null ? Number(row.PurQty) : 0,
            row.SelQty != null ? Number(row.SelQty) : 0,
            row.Rate != null ? parseFloat(row.Rate) : 0,
            row.ShipmentOrLifted || '-',
            row.Status === 'S' ? (row.AdvPayment != null ? parseFloat(row.AdvPayment).toFixed(2) : '0.00') : '',
            row.Status === 'P' ? (row.AdvPayment != null ? parseFloat(row.AdvPayment).toFixed(2) : '0.00') : '',
            row.AdvDate || '',
          ]

          if (isDetailed) {
            rowPushData.push(liftingString);
          }

          body.push(rowPushData)
          rowMeta.push({ type: 'data', fill: getRowFill(row) })
        })
      })

      // Overall totals row � same structure as group header rows
      const overallRemCols = cols.length - 14
      body.push([
        { content: `OVERALL TOTALS  (${rowsForExport.length} records)`, colSpan: 6, styles: { halign: 'right', fontStyle: 'bold', textColor: [75, 0, 130] } },
        { content: `Buy Qty\n${overall.totalPurQty.toFixed(2)}`, styles: { textColor: [0, 102, 204], fontStyle: 'bold', fontSize: 7.5, halign: 'center', cellPadding: 1.5 } },
        { content: `Sell Qty\n${overall.totalSelQty.toFixed(2)}`, styles: { textColor: [180, 30, 30], fontStyle: 'bold', fontSize: 7.5, halign: 'center', cellPadding: 1.5 } },
        { content: `Buy Avg\n${overall.purchaseAvgRate.toFixed(2)}`, styles: { textColor: [0, 102, 204], fontStyle: 'bold', fontSize: 7.5, halign: 'center', cellPadding: 1.5 } },
        { content: `Sell Avg\n${overall.sellAvgRate.toFixed(2)}`, styles: { textColor: [180, 30, 30], fontStyle: 'bold', fontSize: 7.5, halign: 'center', cellPadding: 1.5 } },
        { content: `Diff Amt\n${overall.diffAmt.toFixed(2)}`, styles: { textColor: overall.diffAmt >= 0 ? [25, 135, 84] : [180, 30, 30], fontStyle: 'bold', fontSize: 7.5, halign: 'center', cellPadding: 1.5 } },
        { content: `S Adv Pay\n${overall.totalSAdvPayment.toFixed(2)}`, styles: { textColor: [180, 30, 30], fontStyle: 'bold', fontSize: 7.5, halign: 'center', cellPadding: 1.5 } },
        { content: `P Adv Pay\n${overall.totalPAdvPayment.toFixed(2)}`, styles: { textColor: [0, 102, 204], fontStyle: 'bold', fontSize: 7.5, halign: 'center', cellPadding: 1.5 } },
        ...(overallRemCols > 0 ? [{ content: '', colSpan: overallRemCols }] : []),
      ])
      rowMeta.push({ type: 'overall' })

      // -- Render autoTable --
      doc.autoTable({
        head,
        body,
        startY: 23,
        margin: { left: 7, right: 7 },
        tableWidth: 'auto',
        styles: {
          font: 'NotoSansDevanagari',
          fontSize: 7.5,
          fontStyle: 'bold',
          cellPadding: 1.8,
          lineColor: [0, 0, 0],
          lineWidth: 0.4,
          valign: 'middle',
          overflow: 'linebreak',
          textColor: [0, 0, 0],
        },
        headStyles: {
          textColor: [0, 0, 200],
          fontStyle: 'bold',
          fontSize: 8,
          halign: 'center',
          cellPadding: 2.5,
          lineColor: [0, 0, 0],
          lineWidth: 0.5,
        },
        bodyStyles: {
          fontStyle: 'bold',
          textColor: [0, 0, 0],
        },
        columnStyles,
        willDrawCell: data => {
          if (data.section !== 'body') return
          const meta = rowMeta[data.row.index]
          if (meta && meta.type === 'data' && meta.fill) {
            data.cell.styles.textColor = meta.fill
          } else if (meta && meta.type === 'subtotal') {
            data.cell.styles.textColor = [40, 40, 110]
            data.cell.styles.fontStyle = 'bold'
          } else if (meta && meta.type === 'overall') {
            data.cell.styles.textColor = [75, 0, 130]
            data.cell.styles.fontStyle = 'bold'
          }
        },
        didDrawPage: pageData => {
          // Page footer
          const totalPages = doc.internal.getNumberOfPages()
          doc.setFontSize(6.5)
          doc.setTextColor(130, 130, 130)
          doc.text(
            `Page ${pageData.pageNumber} of ${totalPages}   |   Ledger Report   |   ${new Date().toLocaleDateString()}`,
            pageW / 2,
            pageH - 4,
            { align: 'center' }
          )
          doc.setTextColor(0, 0, 0)
        },
      })

      // -- Remarks (rendered via canvas for proper Hindi/Devanagari shaping) --
      if (remarks && remarks.trim()) {
        let fy = (doc.lastAutoTable ? doc.lastAutoTable.finalY : 30) + 8
        if (fy > pageH - 30) { doc.addPage(); fy = 20 }

        const scale = 3
        const pxPerMm = 3.78 * scale
        const availWidthMm = pageW - 14
        const availWidthPx = Math.round(availWidthMm * pxPerMm)
        const fontSizePx = 60 * scale
        const lineHeightPx = Math.round(fontSizePx * 1.5)
        const fontFace = `"Noto Sans Devanagari", "Nirmala UI", Arial, sans-serif`

        // Measure and word-wrap using canvas measureText
        const measCanvas = document.createElement('canvas')
        measCanvas.width = availWidthPx
        measCanvas.height = lineHeightPx * 2
        const measCtx = measCanvas.getContext('2d')
        measCtx.font = `${fontSizePx}px ${fontFace}`
        const words = remarks.trim().split(' ')
        const wrappedLines = []
        let curLine = ''
        for (const word of words) {
          const test = curLine ? curLine + ' ' + word : word
          if (measCtx.measureText(test).width > availWidthPx - 10 && curLine) {
            wrappedLines.push(curLine)
            curLine = word
          } else {
            curLine = test
          }
        }
        if (curLine) wrappedLines.push(curLine)

        const totalLines = 1 + wrappedLines.length // 1 for "Remarks:" label
        const canvasH = (totalLines + 1) * lineHeightPx

        const canvas = document.createElement('canvas')
        canvas.width = availWidthPx
        canvas.height = canvasH
        const ctx = canvas.getContext('2d')
        ctx.fillStyle = '#ffffff'
        ctx.fillRect(0, 0, canvas.width, canvas.height)
        ctx.fillStyle = '#000000'

        // Draw "Remarks:" label bold
        ctx.font = `bold ${fontSizePx}px ${fontFace}`
        ctx.fillText('Remarks:', 0, lineHeightPx)

        // Draw remarks body
        ctx.font = `${fontSizePx}px ${fontFace}`
        wrappedLines.forEach((l, i) => {
          ctx.fillText(l, 0, (i + 2) * lineHeightPx)
        })

        const imgData = canvas.toDataURL('image/png')
        const imgHMm = canvasH / pxPerMm
        doc.addImage(imgData, 'PNG', 7, fy, availWidthMm, imgHMm)
      }

      const pdfBlob = doc.output('blob')
      setShowRemarksModal(false)
      setRemarks('')

      const file = new File([pdfBlob], filename, { type: 'application/pdf' })

      if (navigator.share) {
        setPendingShareFile(file)
        setShowSharePDFModal(true)
      } else {
        // Fallback: direct download
        const url = URL.createObjectURL(pdfBlob)
        const a = document.createElement('a')
        a.href = url
        a.download = filename
        a.click()
        URL.revokeObjectURL(url)
        toast.success('PDF downloaded!')
      }
    } catch (error) {
      console.error('PDF generation error:', error)
      toast.error('Error generating PDF. Please try again.')
      setShowRemarksModal(false)
    }
  }

  const exportToExcel = async () => {
    if (!state.FillArray || state.FillArray.length === 0) {
      toast.error("No data to export")
      return
    }

    if (selectedRowIds.size === 0) {
      toast.warning("Please select at least one contract to export")
      return
    }

    const rowsForExport = state.FillArray.filter(row =>
      selectedRowIds.has(getRowIdentifier(row))
    )

    if (!rowsForExport || rowsForExport.length === 0) {
      toast.error("Selected contracts are unavailable for export")
      return
    }

    // Get grouped data
    const groupedData = getGroupedData(rowsForExport)
    groupedData.forEach(group => {
      group.items = getSortedData(group.items)
    })

    const selectedLedgerName =
      state.LedgerArray.find(l => l.Id === parseInt(selectedLedger))?.Name ||
      "Unknown"

    // Use same calculation as the table display � calculateLedgerGroupTotals

    // Helper function to get row font color based on lifted status
    // Row font colour matching screen UI: S=red, P=green
    const getRowFontColor = row => {
      if (row.Status === 'S') return "FFFF0000" // Red for Sell
      if (row.Status === 'P') return "FF008000" // Green for Purchase
      return "FF000000" // Black - default
    }

    // Calculate overall totals � same function as table display
    const allDerivedRowsExcel = groupedData.flatMap(g => g.items || [])
    const overallTotals = calculateLedgerGroupTotals(allDerivedRowsExcel)
    overallTotals.diffAmt = overallTotals.totalSelQty * overallTotals.sellAvgRate - overallTotals.totalPurQty * overallTotals.purchaseAvgRate

    // Create a new workbook
    const workbook = new ExcelJS.Workbook()
    const worksheet = workbook.addWorksheet("Ledger Report")

    // Determine the last column letter for merging based on isDetailed
    const lastCol = isDetailed ? "V" : "U"

    // Add title and header info
    let currentRow = 1
    worksheet.mergeCells(`A${currentRow}:${lastCol}${currentRow}`)
    const titleRow = worksheet.getCell(`A${currentRow}`)
    titleRow.value = `${getCompanyName().toUpperCase()} - LEDGER REPORT`
    titleRow.font = { bold: true, size: 16 }
    titleRow.alignment = { horizontal: "center" }
    currentRow++

    worksheet.mergeCells(`A${currentRow}:${lastCol}${currentRow}`)
    const ledgerRow = worksheet.getCell(`A${currentRow}`)
    ledgerRow.value = `Ledger: ${selectedLedgerName}`
    ledgerRow.font = { bold: true }
    currentRow++

    worksheet.mergeCells(`A${currentRow}:${lastCol}${currentRow}`)
    const periodRow = worksheet.getCell(`A${currentRow}`)
    periodRow.value = `Period: ${fromDate.toLocaleDateString()} to ${toDate.toLocaleDateString()}`
    currentRow++

    worksheet.mergeCells(`A${currentRow}:${lastCol}${currentRow}`)
    const dateRow = worksheet.getCell(`A${currentRow}`)
    dateRow.value = `Generated on: ${new Date().toLocaleString()}`
    currentRow++

    currentRow++ // Empty row

    // Column headers - exactly matching table columns
    const headers = [
      "Sr. No.",
      "Contract No",
      "Contract Date",
      "Seller",
      "Buyer",
      "S/P",
      "Tax",
      "Unit",
      "Item",
      "Pur Qty",
      "Sel Qty",
      "Vessel",
      "Rate",
      "Cont Period",
      "Delivery Port",
      "S Adv Pay",
      "P Adv Pay",
      "Adv Date",
      "Lifted",
      "Contract"
    ]
    if (isDetailed) {
      headers.push("Lifting");
      headers.push("Note");
    } else {
      headers.push("Note");
    }

    // Add each group with its data
    groupedData.forEach(group => {
      const groupTotals = calculateLedgerGroupTotals(group.items)
      const diffAmt = groupTotals.totalSelQty * groupTotals.sellAvgRate - groupTotals.totalPurQty * groupTotals.purchaseAvgRate

      // Group header row � party name (A:H merged) + stats cells matching table's tan header row
      const grpBorder = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } }

      worksheet.mergeCells(`A${currentRow}:I${currentRow}`)
      const groupHeaderCell = worksheet.getCell(`A${currentRow}`)
      groupHeaderCell.value = `${group.groupName}  (${group.count} records)`
      groupHeaderCell.font = { bold: true, size: 10, color: { argb: "FF2C3E50" } }
      groupHeaderCell.alignment = { vertical: "middle" }
      groupHeaderCell.border = grpBorder

      // Buy Qty (col J = index 10 in 1-based)
      const buyQtyCell = worksheet.getCell(`J${currentRow}`)
      buyQtyCell.value = Number(groupTotals.totalPurQty)
      buyQtyCell.numFmt = '0.00'
      buyQtyCell.font = { bold: true, color: { argb: "FF0066CC" } }
      buyQtyCell.alignment = { horizontal: "center", vertical: "middle" }
      buyQtyCell.border = grpBorder

      // Sell Qty (col K)
      const sellQtyCell = worksheet.getCell(`K${currentRow}`)
      sellQtyCell.value = Number(groupTotals.totalSelQty)
      sellQtyCell.numFmt = '0.00'
      sellQtyCell.font = { bold: true, color: { argb: "FFB41E1E" } }
      sellQtyCell.alignment = { horizontal: "center", vertical: "middle" }
      sellQtyCell.border = grpBorder

      // Buy Avg (col L)
      const buyAvgCell = worksheet.getCell(`L${currentRow}`)
      buyAvgCell.value = parseFloat(groupTotals.purchaseAvgRate.toFixed(2))
      buyAvgCell.numFmt = '0.00'
      buyAvgCell.font = { bold: true, color: { argb: "FF0066CC" } }
      buyAvgCell.alignment = { horizontal: "center", vertical: "middle" }
      buyAvgCell.border = grpBorder

      // Sell Avg (col M)
      const sellAvgCell = worksheet.getCell(`M${currentRow}`)
      sellAvgCell.value = parseFloat(groupTotals.sellAvgRate.toFixed(2))
      sellAvgCell.numFmt = '0.00'
      sellAvgCell.font = { bold: true, color: { argb: "FFB41E1E" } }
      sellAvgCell.alignment = { horizontal: "center", vertical: "middle" }
      sellAvgCell.border = grpBorder

      // Col N (Cont Period) — empty
      const mCell = worksheet.getCell(`N${currentRow}`)
      mCell.border = grpBorder

      // Diff Amt (col O)
      const diffAmtCell = worksheet.getCell(`O${currentRow}`)
      diffAmtCell.value = parseFloat(diffAmt.toFixed(2))
      diffAmtCell.numFmt = '0.00'
      diffAmtCell.font = { bold: true, color: { argb: diffAmt >= 0 ? "FF198754" : "FFdc3545" } }
      diffAmtCell.alignment = { horizontal: "center", vertical: "middle" }
      diffAmtCell.border = grpBorder

      // S Adv Pay (col P)
      const sAdvCell = worksheet.getCell(`P${currentRow}`)
      sAdvCell.value = parseFloat(groupTotals.totalSAdvPayment.toFixed(2))
      sAdvCell.numFmt = '0.00'
      sAdvCell.font = { bold: true, color: { argb: "FFB41E1E" } }
      sAdvCell.alignment = { horizontal: "center", vertical: "middle" }
      sAdvCell.border = grpBorder

      // P Adv Pay (col Q)
      const pAdvCell = worksheet.getCell(`Q${currentRow}`)
      pAdvCell.value = parseFloat(groupTotals.totalPAdvPayment.toFixed(2))
      pAdvCell.numFmt = '0.00'
      pAdvCell.font = { bold: true, color: { argb: "FF0066CC" } }
      pAdvCell.alignment = { horizontal: "center", vertical: "middle" }
      pAdvCell.border = grpBorder

      // Fill remaining cols with border
      for (let c = 18; c <= headers.length; c++) {
        const cell = worksheet.getCell(currentRow, c)
        cell.border = grpBorder
      }
      currentRow++

      // Add column headers for this group
      const headerRow = worksheet.getRow(currentRow)
      headers.forEach((header, index) => {
        const cell = headerRow.getCell(index + 1)
        cell.value = header
        cell.font = { bold: true, color: { argb: "FF0000C8" } }
        cell.alignment = { horizontal: "center", vertical: "middle" }
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        }
      })
      currentRow++

      // Add data rows for this group with white background and colored text
      group.items.forEach(row => {
        const dataRow = worksheet.getRow(currentRow)
        const fontColor = getRowFontColor(row)

        let lastColData = "";
        let liftingString = "";

        if (isDetailed && row.LiftingJson) {
          try {
            const liftingData = JSON.parse(row.LiftingJson);
            if (Array.isArray(liftingData) && liftingData.length > 0) {
              liftingString = liftingData.map(lift => {
                const date = lift.LiftDate || "-";
                const qty = Number(lift.LiftedQty).toFixed(4).replace(/\.?0+$/, '');
                const lorry = lift.LorryNo || "-";
                const bno = lift.BNo || lift.InvoiceNo || "-";
                const lRate = lift.Rate != null ? lift.Rate : "-";
                return `${date} | ${lorry} | ${bno} | ${qty} | ${lRate}`;
              }).join('\n');
            } else { liftingString = "-"; }
          } catch (e) { liftingString = "Invalid Data"; }
        } else if (isDetailed) {
          liftingString = "-";
        }

        lastColData = getCombinedNotes(row) || "-";

        const rowData = [
          selectionOrder.indexOf(getRowIdentifier(row)) + 1,
          row.ContractNo || "",
          row.ContractDate || "",
          row.Seller || "",
          row.Buyer || "",
          row.Status || "",
          row.Tax || "",
          row.Unit || "",
          row.Item || "",
          row.PurQty ? Number(row.PurQty) : 0,
          row.SelQty ? Number(row.SelQty) : 0,
          row.Vessel || "",
          row.Rate ? parseFloat(row.Rate).toFixed(2) : "0.00",
          row.ShipmentOrLifted || "-",
          row.DeliveryPort || "",
          row.Status === "S" ? (row.AdvPayment ? parseFloat(row.AdvPayment).toFixed(2) : "0.00") : "",
          row.Status === "P" ? (row.AdvPayment ? parseFloat(row.AdvPayment).toFixed(2) : "0.00") : "",
          row.AdvDate || "",
          row.Lifted ? parseFloat(row.Lifted).toFixed(2) : "0.00",
          row.Contract || "",
        ]

        if (isDetailed) {
          rowData.push(liftingString);
          rowData.push(lastColData);
        } else {
          rowData.push(lastColData);
        }

        rowData.forEach((value, index) => {
          const cell = dataRow.getCell(index + 1)
          cell.value = value
          cell.font = {
            color: { argb: fontColor }, // Colored text based on status
          }
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          }
        })
        currentRow++
      })
    })

    // Add overall totals row � same structure as group header rows (purple background)
    const overallDiffAmt = overallTotals.diffAmt
    const overallBorder = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } }

    worksheet.mergeCells(`A${currentRow}:I${currentRow}`)
    const overallHeaderCell = worksheet.getCell(`A${currentRow}`)
    overallHeaderCell.value = `OVERALL TOTALS  (${rowsForExport.length} records)`
    overallHeaderCell.font = { bold: true, size: 11, color: { argb: "FF4B0082" } }
    overallHeaderCell.alignment = { vertical: "middle" }
    overallHeaderCell.border = overallBorder

    const setOverallCell = (col, value, colorArgb) => {
      const cell = worksheet.getCell(`${col}${currentRow}`)
      cell.value = parseFloat(value.toFixed(2))
      cell.numFmt = '0.00'
      cell.font = { bold: true, color: { argb: colorArgb } }
      cell.alignment = { horizontal: "center", vertical: "middle" }
      cell.border = overallBorder
    }

    setOverallCell('J', overallTotals.totalPurQty, "FF0066CC")
    setOverallCell('K', overallTotals.totalSelQty, "FFB41E1E")
    setOverallCell('L', overallTotals.purchaseAvgRate, "FF0066CC")
    setOverallCell('M', overallTotals.sellAvgRate, "FFB41E1E")

    const mOverall = worksheet.getCell(`N${currentRow}`)
    mOverall.border = overallBorder

    setOverallCell('O', overallDiffAmt, overallDiffAmt >= 0 ? "FF198754" : "FFB41E1E")

    setOverallCell('P', overallTotals.totalSAdvPayment, "FFB41E1E")
    setOverallCell('Q', overallTotals.totalPAdvPayment, "FF0066CC")

    for (let c = 18; c <= headers.length; c++) {
      const cell = worksheet.getCell(currentRow, c)
      cell.border = overallBorder
    }
    currentRow++

    currentRow++ // Empty row
    worksheet.getCell(`A${currentRow}`).value = `Total Records: ${rowsForExport.length}`
    worksheet.getCell(`A${currentRow}`).font = { bold: true }
    currentRow++
    worksheet.getCell(`A${currentRow}`).value = `Total Groups: ${groupedData.length}`
    worksheet.getCell(`A${currentRow}`).font = { bold: true }

    // Auto-fit columns based on actual data content - precise calculation
    worksheet.columns.forEach((column, columnIndex) => {
      let maxDataLength = 0
      let sampleCount = 0
      const maxSamples = 100 // Check first 100 rows for performance

      // Check header length first
      const headerLength = headers[columnIndex] ? headers[columnIndex].length : 0
      maxDataLength = headerLength

      // Check actual data in cells
      column.eachCell({ includeEmpty: false }, (cell, rowNumber) => {
        // Skip header rows and title rows (first 5 rows typically)
        if (rowNumber <= 5) return

        if (cell.value !== null && cell.value !== undefined && cell.value !== "") {
          sampleCount++
          if (sampleCount > maxSamples) return // Stop after checking enough samples

          let cellValue = ""

          // Handle different data types
          if (typeof cell.value === 'number') {
            // For numbers, use the formatted string length
            cellValue = cell.value.toString()
          } else if (typeof cell.value === 'object' && cell.value instanceof Date) {
            cellValue = cell.value.toLocaleDateString()
          } else {
            cellValue = String(cell.value)
          }

          // Use actual character length (Excel uses character count, not pixels)
          const valueLength = cellValue.length
          maxDataLength = Math.max(maxDataLength, valueLength)
        }
      })

      // Calculate width: Excel width = character count + small padding
      // Excel column width is measured in characters (approximately)
      // Add minimal padding (1-2 characters) for readability
      const padding = 1.5 // Minimal padding
      let calculatedWidth = maxDataLength + padding

      // Set reasonable minimums based on column type
      const columnName = headers[columnIndex] || ""
      let minWidth = 8 // Default minimum

      if (columnName.includes("Qty") || columnName.includes("Rate") || columnName.includes("Payment") || columnName.includes("Lifted")) {
        minWidth = 12 // Numeric columns need a bit more
      } else if (columnName.includes("Date")) {
        minWidth = 12 // Date columns
      } else if (columnName.includes("Contract") || columnName.includes("Seller") || columnName.includes("Buyer")) {
        minWidth = 15 // Name columns
      } else if (columnName.includes("Note")) {
        minWidth = 20 // Note column can be wider
      } else {
        minWidth = Math.max(headerLength + 1, 8) // At least header length + 1
      }

      // Set maximum width to prevent extremely wide columns
      const maxWidth = columnName.includes("Note") ? 50 : 25 // Note can be wider, others limited

      // Final width: ensure it's between min and max
      column.width = Math.max(minWidth, Math.min(calculatedWidth, maxWidth))
    })

    // Generate Excel file
    const buffer = await workbook.xlsx.writeBuffer()
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    })
    const fileName = `ledger_report_${selectedLedgerName.replace(/[^a-zA-Z0-9]/g, "_")}_${fromDate.toISOString().split("T")[0]
      }_${toDate.toISOString().split("T")[0]}.xlsx`

    // Share or download
    const file = new File([blob], fileName, { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })

    if (navigator.share) {
      try {
        if (navigator.canShare && navigator.canShare({ files: [file] })) {
          await navigator.share({
            title: 'Ledger Report',
            text: 'Please find attached the Ledger Report',
            files: [file]
          })
          toast.success("Excel file shared successfully!")
          return
        }
      } catch (shareError) {
        if (shareError.name !== 'AbortError') {
          console.error('Share error:', shareError)
        }
      }
    }

    // Fallback: download
    const link = document.createElement("a")
    const url = URL.createObjectURL(blob)
    link.setAttribute("href", url)
    link.setAttribute("download", fileName)
    link.style.visibility = "hidden"
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)

    toast.success("Excel exported successfully with colored rows!")
  }

  const getFooterCalculations = () => {
    const allTotals = calculateLedgerGroupTotals(flattenedVisibleRows)
    let allPurQty = 0
    let allSelQty = 0
    let allPurchaseAmount = 0
    let allSellAmount = 0
    flattenedVisibleRows.forEach(row => {
      const qty = parseFloat(row.Qty) || 0
      const rate = parseFloat(row.Rate) || 0
      if (row.Status === "P") {
        allPurQty += qty
        allPurchaseAmount += qty * rate
      } else if (row.Status === "S") {
        allSelQty += qty
        allSellAmount += qty * rate
      }
    })
    const allPurchaseAvgRate = allPurQty > 0 ? allPurchaseAmount / allPurQty : 0
    const allSellAvgRate = allSelQty > 0 ? allSellAmount / allSelQty : 0
    const allDiff = (allSelQty * allSellAvgRate) - (allPurQty * allPurchaseAvgRate)
    const allLifted = state.FillArray.reduce((sum, row) => sum + (parseFloat(row.Lifted) || 0), 0)

    const selectedRows = flattenedVisibleRows.filter(row =>
      selectedRowIds.has(getRowIdentifier(row))
    )
    const selTotals = calculateLedgerGroupTotals(selectedRows)
    let selPurQty = 0
    let selSelQty = 0
    let selPurchaseAmount = 0
    let selSellAmount = 0
    selectedRows.forEach(row => {
      const qty = parseFloat(row.Qty) || 0
      const rate = parseFloat(row.Rate) || 0
      if (row.Status === "P") {
        selPurQty += qty
        selPurchaseAmount += qty * rate
      } else if (row.Status === "S") {
        selSelQty += qty
        selSellAmount += qty * rate
      }
    })
    const selPurchaseAvgRate = selPurQty > 0 ? selPurchaseAmount / selPurQty : 0
    const selSellAvgRate = selSelQty > 0 ? selSellAmount / selSelQty : 0
    const selDiff = (selSelQty * selSellAvgRate) - (selPurQty * selPurchaseAvgRate)
    const selLifted = selectedRows.reduce((sum, row) => sum + (parseFloat(row.Lifted) || 0), 0)

    return {
      all: {
        count: flattenedVisibleRows.length,
        buyQty: allPurQty,
        sellQty: allSelQty,
        buyAvg: allPurchaseAvgRate,
        sellAvg: allSellAvgRate,
        diff: allDiff,
        sAdv: allTotals.totalSAdvPayment,
        pAdv: allTotals.totalPAdvPayment,
        lifted: allLifted,
      },
      selected: {
        count: selectedRows.length,
        buyQty: selPurQty,
        sellQty: selSelQty,
        buyAvg: selPurchaseAvgRate,
        sellAvg: selSellAvgRate,
        diff: selDiff,
        sAdv: selTotals.totalSAdvPayment,
        pAdv: selTotals.totalPAdvPayment,
        lifted: selLifted,
        hasSelection: selectedRowIds.size > 0,
      }
    }
  }

  const getGroupHeaderCellProps = (colKey, group, ledgerTotals) => {
    let content = ""
    let halign = "center"
    const colW = columnWidths[colKey] || COLUMN_DEFAULT_WIDTHS[colKey] || 80
    let widthVal = `${colW}px`
    
    // Default styling — no internal column borders for group header row (looks like a merged row)
    let cellStyle = {
      backgroundColor: "#D2B48C",
      color: "#2c3e50",
      padding: "2px 4px",
      verticalAlign: "middle",
      borderTop: "1.5px solid black",
      borderBottom: "1.5px solid black",
      borderLeft: "none",
      borderRight: "none",
      boxShadow: "none",
      fontSize: "0.6rem",
      fontWeight: "bold",
      width: widthVal,
      minWidth: widthVal,
      maxWidth: widthVal,
      boxSizing: "border-box",
    }
    
    if (colKey === "CheckBox") {
      content = (
        <div style={{ position: "relative" }}>
          {/* Desktop: Party name only */}
          <span
            className="fw-bold d-none d-md-inline-block"
            style={{
              color: "red",
              fontWeight: "bold",
              fontSize: "0.75rem",
              lineHeight: "1.3",
              whiteSpace: "nowrap",
              position: "absolute",
              zIndex: 2,
              top: "50%",
              left: 10,
              transform: "translateY(-50%)"
            }}
          >
            {group.groupName}
          </span>
          {/* Mobile: Party name on first line, totals on second line */}
          <div className="d-md-none">
            <div
              className="fw-bold"
              style={{
                color: "red",
                fontWeight: "bold",
                fontSize: "0.75rem",
                wordBreak: "break-all",
                overflowWrap: "break-word",
                lineHeight: "1.3",
                marginBottom: "2px",
              }}
            >
              {group.groupName}
            </div>
            <small style={{ fontSize: "0.7rem", fontWeight: "bold", display: "block", minWidth: "250px" }}>
              <span style={{ color: "#000000", fontWeight: "bold" }}>B:{Number(ledgerTotals.totalPurQty).toFixed(2)}</span>
              <span style={{ color: "#555", fontWeight: "bold" }}> | </span>
              <span style={{ color: "#d62d5d", fontWeight: "bold" }}>S:{Number(ledgerTotals.totalSelQty).toFixed(2)}</span>
              <span style={{ color: "#555", fontWeight: "bold" }}> | </span>
              <span style={{ color: "#000000", fontWeight: "bold" }}>BA:{Number(ledgerTotals.purchaseAvgRate).toFixed(2)}</span>
              <span style={{ color: "#555", fontWeight: "bold" }}> | </span>
              <span style={{ color: "#d62d5d", fontWeight: "bold" }}>SA:{Number(ledgerTotals.sellAvgRate).toFixed(2)}</span>
              <span style={{ color: "#555", fontWeight: "bold" }}> | </span>
              {(() => {
                const diff = ledgerTotals.totalSelQty * ledgerTotals.sellAvgRate - ledgerTotals.totalPurQty * ledgerTotals.purchaseAvgRate
                return (
                  <span style={{ color: diff >= 0 ? "#198754" : "#dc3545", fontWeight: "bold" }}>
                    Diff:{Number(diff).toFixed(2)}
                  </span>
                )
              })()}
            </small>
          </div>
        </div>
      )
      halign = "start"
      cellStyle.paddingLeft = "2px"
    } else if (colKey === "ContractNo") {
      content = ""
    } else if (colKey === "PurQty") {
      content = (
        <div>
          <div style={{ fontSize: "0.55rem", color: "#0066cc" }}>Buy Qty</div>
          <div style={{ fontSize: "0.65rem", fontWeight: "bold" }}>
            {ledgerTotals.totalPurQty.toLocaleString()}
          </div>
        </div>
      )
    } else if (colKey === "SelQty") {
      content = (
        <div>
          <div style={{ fontSize: "0.55rem", color: "#dc3545" }}>Sell Qty</div>
          <div style={{ fontSize: "0.65rem", fontWeight: "bold" }}>
            {ledgerTotals.totalSelQty.toLocaleString()}
          </div>
        </div>
      )
    } else if (colKey === "Vessel") {
      content = (
        <div>
          <div style={{ fontSize: "0.55rem", color: "#0066cc" }}>Buy Avg</div>
          <div style={{ fontSize: "0.65rem", fontWeight: "bold" }}>
            {ledgerTotals.purchaseAvgRate.toLocaleString(undefined, { maximumFractionDigits: 2 })}
          </div>
        </div>
      )
    } else if (colKey === "Rate") {
      content = (
        <div>
          <div style={{ fontSize: "0.55rem", color: "#dc3545" }}>Sell Avg</div>
          <div style={{ fontSize: "0.65rem", fontWeight: "bold" }}>
            {ledgerTotals.sellAvgRate.toLocaleString(undefined, { maximumFractionDigits: 2 })}
          </div>
        </div>
      )
    } else if (colKey === "DeliveryPort") {
      const diffVal = ledgerTotals.totalSelQty * ledgerTotals.sellAvgRate - ledgerTotals.totalPurQty * ledgerTotals.purchaseAvgRate
      content = (
        <div>
          <div style={{ fontSize: "0.55rem", color: diffVal >= 0 ? "#198754" : "#dc3545" }}>Diff Amt</div>
          <div
            style={{
              fontSize: "0.65rem",
              fontWeight: "bold",
              color: diffVal >= 0 ? "#198754" : "#dc3545"
            }}
          >
            {parseFloat(diffVal).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </div>
        </div>
      )
    } else if (colKey === "SAdvPayment") {
      content = (
        <div>
          <div style={{ fontSize: "0.55rem", color: "#dc3545" }}>S Adv Pay</div>
          <div style={{ fontSize: "0.65rem", fontWeight: "bold" }}>
            {ledgerTotals.totalSAdvPayment.toFixed(2)}
          </div>
        </div>
      )
    } else if (colKey === "PAdvPayment") {
      content = (
        <div>
          <div style={{ fontSize: "0.55rem", color: "#0066cc" }}>P Adv Pay</div>
          <div style={{ fontSize: "0.65rem", fontWeight: "bold" }}>
            {ledgerTotals.totalPAdvPayment.toFixed(2)}
          </div>
        </div>
      )
    } else if (colKey === "Note") {
      content = (
        <Button
          size="sm"
          variant="outline-primary"
          style={{
            fontSize: "0.6rem",
            padding: "3px 8px",
          }}
          onClick={() => {
            const csv = group.items
              .map(
                row =>
                  `"${row.ContractNo}","${row.ContractDate}","${row.Seller}","${row.Buyer}","${row.Status}","${row.Tax}","${row.Unit}","${row.Item}","${row.PurQty}","${row.SelQty}","${row.Vessel}","${row.Rate}","${row.ShipmentDate}","${row.LiftedDate}","${row.DeliveryPort}","${row.AdvPayment}","${row.AdvDate}","${row.Lifted}","${row.Contract}","${getCombinedNotes(row)}"`
              )
              .join("\n")
            navigator.clipboard.writeText(csv)
            toast.success(
              `Copied ${group.count} records for ${group.groupName} to clipboard`
            )
          }}
          title="Copy group data to clipboard"
        >
          <i className="fas fa-copy"></i>
        </Button>
      )
      halign = "end"
    }
    
    return {
      halign,
      content,
      style: cellStyle,
      widthVal
    }
  }

  const getFooterCellProps = (colKey, type, footerCalcs) => {
    const totals = type === 'all' ? footerCalcs.all : footerCalcs.selected
    let content = ""
    let halign = "center"

    if (colKey === "CheckBox") {
      content = totals.count
    } else if (colKey === "ContractNo") {
      content = `B: ${totals.buyQty.toFixed(2)}`
    } else if (colKey === "ContractDate") {
      content = `S: ${totals.sellQty.toFixed(2)}`
    } else if (colKey === "Seller") {
      content = `Diff: ${totals.diff.toFixed(2)}`
      halign = "start"
    } else if (colKey === "SAdvPayment") {
      content = totals.sAdv.toFixed(2)
      halign = "end"
    } else if (colKey === "PAdvPayment") {
      content = totals.pAdv.toFixed(2)
      halign = "end"
    } else if (colKey === "Lifted") {
      content = totals.lifted.toFixed(2)
      halign = "end"
    }

    return { content, halign }
  }

  return (
    <div
      className="ledger-report-container"
      style={{
        height: "100vh",
        marginTop: "0",
        paddingTop: "40px",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        paddingBottom: "0",
      }}
    >
      {/* <Breadcrumbs title={breadCrumbTitle} breadcrumbItem={breadcrumbItem} /> */}

      <div className="col-12" style={{ flex: "0 0 auto", marginBottom: "0" }}>
        <div className="card border-0 shadow-sm" style={{ marginBottom: "0" }}>
          <div className="card-body" style={{ padding: "0.25rem" }}>
            <div style={{ overflowX: "auto", overflowY: "hidden" }}>
              <div className="d-flex align-items-center filter-theme-light" style={{ backgroundColor: "#E3F2FD", padding: "4px", borderRadius: "4px", flexWrap: "nowrap", minWidth: "fit-content", border: "1px solid #2196F3", gap: `${topGap}px` }}>
                {renderFilterBar(topFilterOrder, topFilterWidths, topGap, setTopGap, topDragStart, topDragOver, topDrop, topDragEnd, topTouchDragStart, topTouchDragMove, topTouchDragEnd, topResizeDown, resetTopLayout, renderTopFilterContent, topFilterStart, topActiveReorderId)}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Table Data Section - Full Height Layout */}
      {(showReport || (state.FillArray && state.FillArray.length > 0)) && (
        <div
          className="row ledger-table-section"
          style={{
            flex: "1 1 auto",
            marginBottom: "0",
            marginTop: "0",
            minHeight: "0",
            overflow: "hidden",
          }}
        >
          <div
            className="col-12"
            style={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              padding: "0",
            }}
          >
            <div
              className="card"
              style={{ height: "100%", marginBottom: "0", border: "none" }}
            >
              <div
                className="card-body"
                style={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  padding: "0",
                  overflow: "hidden",
                  margin: "0",
                }}
              >
                {state.FillArray && state.FillArray.length > 0 ? (
                  <>
                    <div
                      ref={tableContainerRef}
                      className="table-responsive position-relative ledger-table-scroll"
                      style={{
                        flex: "1 1 auto",
                        overflow: "auto",
                        border: "1px solid #dee2e6",
                        borderRadius: "0",
                        minHeight: "0",
                        height: "100%",
                      }}
                    >
                      {(() => {
                        const lrCols = lrVisibleColumns();
                        const totalTableWidth = lrCols.reduce(
                          (sum, col) => sum + (columnWidths[col.key] || COLUMN_DEFAULT_WIDTHS[col.key] || 80),
                          0
                        );
                        return (
                          <Table
                            bordered
                            hover
                            className="resizable-table"
                            style={{
                              tableLayout: "fixed",
                              width: `${totalTableWidth}px`,
                              minWidth: `${totalTableWidth}px`,
                              whiteSpace: "nowrap",
                              margin: 0,
                              padding: 0,
                            }}
                          >
                            <colgroup>
                              {lrCols.map((col) => {
                                const colW = columnWidths[col.key] || COLUMN_DEFAULT_WIDTHS[col.key] || 80;
                                return (
                                  <col
                                    key={col.key}
                                    style={{
                                      width: `${colW}px`,
                                      minWidth: `${colW}px`,
                                      maxWidth: `${colW}px`,
                                    }}
                                  />
                                );
                              })}
                            </colgroup>
                            <thead
                              style={{
                                position: "sticky",
                                top: 0,
                                zIndex: 10,
                              }}
                            >
                              <tr>
                                {lrCols.map((col) => {
                                  const colW = columnWidths[col.key] || COLUMN_DEFAULT_WIDTHS[col.key] || 80;
                                  return (
                                    <th
                                      key={col.key}
                                      className={`text-center align-middle${lrDragOverKey === col.key ? ' col-drag-over' : ''}`}
                                      draggable={col.key !== 'CheckBox'}
                                      onDragStart={col.key !== 'CheckBox' ? (e => lrDragStart(e, col.key)) : undefined}
                                      onDragOver={e => lrDragOver(e, col.key)}
                                      onDrop={e => lrDrop(e, col.key)}
                                      onDragEnd={lrDragEnd}
                                      style={{
                                        backgroundColor: "#0000FF",
                                        color: "white",
                                        height: "25px",
                                        fontSize: "0.7rem",
                                        fontWeight: "600",
                                        padding: col.key === 'CheckBox' ? '6px 12px' : '0 8px',
                                        width: `${colW}px`,
                                        maxWidth: `${colW}px`,
                                        minWidth: `${colW}px`,
                                        boxSizing: "border-box",
                                        cursor: col.key !== 'CheckBox' ? "grab" : "default",
                                        border: "1.5px solid black",
                                        boxShadow: "none",
                                        position: "relative",
                                        overflow: "hidden",
                                        userSelect: "none",
                                      }}
                                      onClick={(e) => {
                                        if (isResizing && isResizing()) return;
                                        if (lrJustDraggedRef.current) return;
                                        if (col.sortKey) handleSort(col.sortKey);
                                      }}
                                    >
                                      {col.key === 'CheckBox' ? (
                                        <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", pointerEvents: "none" }}>
                                          <input
                                            type="checkbox"
                                            ref={selectAllRef}
                                            checked={allVisibleRowsSelected}
                                            onClick={e => { e.stopPropagation(); handleSelectAllVisibleRows() }}
                                            disabled={visibleRowIds.length === 0}
                                            style={{ width: "12px", height: "12px", margin: "0", cursor: "pointer", pointerEvents: "auto" }}
                                            title="Select all visible contracts"
                                          />
                                        </div>
                                      ) : (
                                        <div style={{ width: "100%", paddingRight: col.sortKey ? "14px" : "0", overflow: "hidden", display: "flex", alignItems: "center", justifyContent: "center", minWidth: 0 }}>
                                          {col.sortKey && (
                                            <span style={{ display: "inline-flex", flexDirection: "column", marginRight: "2px", flexShrink: 0, lineHeight: 0 }}>
                                              <i className={`fas fa-caret-up ${sortConfig.key === col.sortKey && sortConfig.direction === "asc" ? "text-warning" : "text-light"}`} style={{ fontSize: "0.55rem", lineHeight: "0.55rem" }}></i>
                                              <i className={`fas fa-caret-down ${sortConfig.key === col.sortKey && sortConfig.direction === "desc" ? "text-warning" : "text-light"}`} style={{ fontSize: "0.55rem", lineHeight: "0.55rem" }}></i>
                                            </span>
                                          )}
                                          <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{col.label}</span>
                                        </div>
                                      )}
                                      <div
                                        className="col-resize-handle"
                                        onClick={e => { e.preventDefault(); e.stopPropagation(); }}
                                        onMouseDown={e => handleResizeMouseDown(e, col.key)}
                                        onTouchStart={e => handleResizeMouseDown(e, col.key)}
                                      />
                                    </th>
                                  );
                                })}
                              </tr>
                            </thead>
                            <tbody>
                              {(() => {
                                const data = tableData
                                // Always render grouped data
                                return data.map((group, groupIndex) => (
                                  <React.Fragment key={groupIndex}>
                                    {/* Group Header Row with Totals */}
                                    {(() => {
                                      const selectedGroupItems = group.items.filter(item => {
                                        const id = getRowIdentifier(item)
                                        return id && selectedRowIds.has(id)
                                      })
                                      const ledgerTotals =
                                        calculateLedgerGroupTotals(selectedGroupItems.length > 0 ? selectedGroupItems : group.items)
                                      return (
                                        <tr
                                          style={{
                                            backgroundColor: "#D2B48C",
                                            height: "28px",
                                            border: "1px solid #d2b48c",
                                          }}
                                        >
                                          {lrCols.map((col) => {
                                            const cellProps = getGroupHeaderCellProps(col.key, group, ledgerTotals)
                                            return (
                                              <td
                                                key={col.key}
                                                className={`group-header-td text-${cellProps.halign}`}
                                                style={{
                                                  ...cellProps.style,
                                                  width: cellProps.widthVal,
                                                  maxWidth: cellProps.widthVal,
                                                  minWidth: cellProps.widthVal,
                                                  boxSizing: "border-box",
                                                  overflow: (col.key === "ContractNo" || col.key === "CheckBox") ? "visible" : "hidden",
                                                  textOverflow: "ellipsis",
                                                  whiteSpace: "nowrap",
                                                }}
                                              >
                                                {cellProps.content}
                                              </td>
                                            )
                                          })}
                                        </tr>
                                      )
                                    })()}
                                    {/* Group Items */}
                                    {group.items.map((row, rowIndex) => {
                                      const rowId = getRowIdentifier(row)
                                      const isRowSelected = rowId
                                        ? selectedRowIds.has(rowId)
                                        : false

                                      return (
                                        <tr
                                          key={`${groupIndex}-${rowIndex}`}
                                          className={
                                            row.Lifted == 0 ||
                                              row.Lifted == null ||
                                              row.Lifted == undefined
                                              ? "table-secondary fw-semibold" // light grey
                                              : row.Lifted == row.PurQty ||
                                                row.Lifted == row.SelQty
                                                ? "table-info fw-semibold" // light blue
                                                : row.PurQty > row.Lifted ||
                                                  row.SelQty > row.Lifted
                                                  ? "table-danger fw-semibold" // light red
                                                  : ""
                                          }
                                          style={{
                                            height: "25px",
                                            borderBottom: "1px solid #dee2e6",
                                            color: row.Status === "S" ? "#d62d5d" : row.Status === "P" ? "#166534" : "inherit",
                                            fontWeight: row.Status === "S" ? "bold" : "inherit",
                                          }}

                                        >
                                          {lrCols.map((col) => {
                                            const colW = columnWidths[col.key] || COLUMN_DEFAULT_WIDTHS[col.key] || 80;
                                            const colWVal = `${colW}px`;
                                            const tdStyle = {
                                              verticalAlign: "middle",
                                              padding: col.key === 'CheckBox' ? '4px' : '2px 4px',
                                              border: "1.5px solid black",
                                              color: row.Status === "S" ? "#d62d5d" : row.Status === "P" ? "#166534" : "inherit",
                                              fontWeight: row.Status === "S" ? "bold" : "inherit",
                                              fontSize: "0.7rem",
                                              width: colWVal,
                                              minWidth: colWVal,
                                              maxWidth: colWVal,
                                              boxSizing: "border-box",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              whiteSpace: "nowrap",
                                            }
                                            const tdNumStyle = {
                                              ...tdStyle,
                                              textAlign: "right",
                                              boxShadow: "none",
                                            }
                                            switch (col.key) {
                                              case 'CheckBox': return (
                                                <td key={col.key} className={`text-center align-middle ${rowId && selectedRowIds.has(rowId) ? 'contractno-selected' : 'contractno-unselected'}`} style={{ ...tdStyle, padding: "4px" }}>
                                                  {rowId && selectedRowIds.has(rowId) ? (
                                                    <div
                                                      onClick={e => { e.stopPropagation(); toggleRowSelection(row) }}
                                                      style={{ width: "24px", height: "24px", borderRadius: "4px", backgroundColor: "#556ee6", color: "white", fontWeight: "bold", fontSize: "0.75rem", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", margin: "0 auto", border: "2px solid #556ee6" }}
                                                      title={`Sequence #${selectionOrder.indexOf(rowId) + 1} - Click to deselect`}
                                                    >
                                                      {selectionOrder.indexOf(rowId) + 1}
                                                    </div>
                                                  ) : (
                                                    <input type="checkbox" checked={false} onClick={e => { e.stopPropagation(); toggleRowSelection(row) }} style={{ width: "12px", height: "12px", margin: "0", cursor: "pointer" }} title="Select contract" />
                                                  )}
                                                </td>
                                              )
                                              case 'ContractNo': return (
                                                <td key={col.key} className={`${row.Status === "S" ? "fw-bold" : "fw-semibold"} ${rowId && selectedRowIds.has(rowId) ? 'contractno-selected' : 'contractno-unselected'}`} style={{ ...tdStyle, padding: "2px 2px", backgroundColor: rowId && selectedRowIds.has(rowId) ? "#fffec8" : undefined }}>
                                                  {row.ContractNo ? (
                                                    <div className="d-flex align-items-center" style={{ overflow: "hidden", minWidth: 0, width: "100%" }}>
                                                      <Button variant="link" className={`p-0 text-decoration-none fw-bold ${row.Status === "S" ? "" : row.Status === "P" ? "" : "text-primary"}`} style={{ cursor: "pointer", transition: "all 0.2s ease", border: "none", background: "none", padding: "1px 2px", borderRadius: "4px", display: "inline-flex", alignItems: "center", gap: "3px", fontSize: "0.75rem", whiteSpace: "nowrap", width: "100%", minWidth: 0, overflow: "hidden", justifyContent: "flex-start", color: row.Status === "S" ? "#d62d5d" : row.Status === "P" ? "#166534" : "#0d6efd", fontWeight: "bold" }} onMouseEnter={e => { e.target.style.color = row.Status === "S" ? "#b02550" : row.Status === "P" ? "#0d4f27" : "#0056b3"; e.target.style.textDecoration = "underline"; e.target.style.backgroundColor = "#f8f9fa" }} onMouseLeave={e => { e.target.style.color = row.Status === "S" ? "#d62d5d" : row.Status === "P" ? "#166534" : "#0d6efd"; e.target.style.textDecoration = "none"; e.target.style.backgroundColor = "transparent" }} onClick={event => { const button = event.target.closest("button"); const orig = button.innerHTML; button.innerHTML = '<i class="fas fa-spinner fa-spin me-1"></i>Loading...'; button.disabled = true; setTimeout(() => { openEditContractModal(row); button.innerHTML = orig; button.disabled = false }, 300) }} title={`Click to edit contract: ${row.ContractNo}`} tabIndex={0} role="button">
                                                        <i className={`fas fa-edit ${row.Status === "S" ? "" : row.Status === "P" ? "" : "text-primary"}`} style={{ color: row.Status === "S" ? "#d62d5d" : row.Status === "P" ? "#166534" : "#0d6efd", flexShrink: 0 }}></i>
                                                        <span style={{ overflow: "hidden", textOverflow: "ellipsis", minWidth: 0 }}>{row.ContractNo}</span>
                                                      </Button>
                                                    </div>
                                                  ) : "-"}
                                                </td>
                                              )
                                              case 'ContractDate': return <td key={col.key} className={row.Status === "S" ? "fw-bold" : ""} style={{ ...tdStyle, textAlign: "center" }}>{row.ContractDate || "-"}</td>
                                              case 'Seller': return <td key={col.key} className={row.Status === "S" ? "fw-bold" : ""} style={tdStyle}>{renderPartyName(row.Seller, 'seller')}</td>
                                              case 'Buyer': return <td key={col.key} className={row.Status === "S" ? "fw-bold" : ""} style={tdStyle}>{renderPartyName(row.Buyer, 'buyer')}</td>
                                              case 'Status': return <td key={col.key} className={row.Status === "S" ? "fw-bold" : ""} style={{ ...tdStyle, textAlign: "center" }}>{row.Status || "-"}</td>
                                              case 'Unit': return <td key={col.key} className={row.Status === "S" ? "fw-bold" : ""} style={{ ...tdStyle, textAlign: "center" }}>{row.Unit || "-"}</td>
                                              case 'Item': return <td key={col.key} className={row.Status === "S" ? "fw-bold" : ""} style={{ ...tdStyle, textAlign: "center" }}>{row.Item || "-"}</td>
                                              case 'PurQty': return <td key={col.key} className={row.Status === "S" ? "text-end fw-bold" : "text-end fw-semibold"} style={tdNumStyle}>{row.PurQty ? parseFloat(row.PurQty).toFixed(2) : "0.00"}</td>
                                              case 'SelQty': return <td key={col.key} className={row.Status === "S" ? "text-end fw-bold" : "text-end fw-semibold"} style={tdNumStyle}>{row.SelQty ? parseFloat(row.SelQty).toFixed(2) : "0.00"}</td>
                                              case 'Vessel': return <td key={col.key} className={row.Status === "S" ? "fw-bold" : ""} style={tdStyle}>{row.Vessel || "-"}</td>
                                              case 'Rate': return <td key={col.key} className={row.Status === "S" ? "text-end fw-bold" : "text-end fw-semibold"} style={tdNumStyle}>{row.Rate ? parseFloat(row.Rate).toFixed(2) : "0.00"}</td>
                                              case 'ContPeriod': return <td key={col.key} className={row.Status === "S" ? "text-center fw-bold" : "text-center"} style={tdStyle}>{row.ShipmentOrLifted || "-"}</td>
                                              case 'DeliveryPort': return <td key={col.key} className={row.Status === "S" ? "fw-bold" : ""} style={tdStyle}>{row.DeliveryPort || "-"}</td>
                                              case 'SAdvPayment': return <td key={col.key} className={row.Status === "S" ? "text-end fw-bold" : "text-end fw-semibold"} style={tdNumStyle}>{row.Status === "S" ? (row.AdvPayment ? parseFloat(row.AdvPayment).toFixed(2) : "0.00") : ""}</td>
                                              case 'PAdvPayment': return <td key={col.key} className={row.Status === "S" ? "text-end fw-bold" : "text-end fw-semibold"} style={tdNumStyle}>{row.Status === "P" ? (row.AdvPayment ? parseFloat(row.AdvPayment).toFixed(2) : "0.00") : ""}</td>
                                              case 'AdvDate': return <td key={col.key} className={row.Status === "S" ? "fw-bold" : ""} style={{ ...tdStyle, textAlign: "center" }}>{row.AdvDate || "-"}</td>
                                              case 'Lifted': return <td key={col.key} className={row.Status === "S" ? "text-end fw-bold" : "text-end fw-semibold"} style={tdNumStyle}>{row.Lifted ? parseFloat(row.Lifted).toFixed(2) : "0.00"}</td>
                                              case 'Contract': return <td key={col.key} className={row.Status === "S" ? "fw-bold" : ""} style={{ ...tdStyle, textAlign: "center" }}>{row.Contract || "-"}</td>
                                              case 'Lifting': return (
                                                <td key={col.key} className={`ledger-note-cell ${row.Status === "S" ? "fw-bold" : ""}`} style={{ ...tdStyle, verticalAlign: "top", padding: "0" }}>
                                                  {(() => {
                                                    if (!row.LiftingJson) return "-";
                                                    try {
                                                      const liftingData = JSON.parse(row.LiftingJson);
                                                      if (!Array.isArray(liftingData) || liftingData.length === 0) return "-";
                                                      return (
                                                        <div style={{ maxHeight: "150px", overflowY: "auto", width: "100%", margin: 0, padding: 0 }}>
                                                          <table style={{ width: "100%", fontSize: "0.55rem", borderCollapse: "collapse", margin: 0, padding: 0, border: "none" }}>
                                                            <thead style={{ position: "sticky", top: 0, backgroundColor: "#f8f9fa", zIndex: 1, borderBottom: "1px solid #ccc" }}>
                                                              <tr>
                                                                <th style={{ padding: "2px", textAlign: "left", width: "15%", fontWeight: 600 }}>Date</th>
                                                                <th style={{ padding: "2px", textAlign: "left", width: "25%", fontWeight: 600 }}>LorryNo</th>
                                                                <th style={{ padding: "2px", textAlign: "left", width: "25%", fontWeight: 600 }}>BNo/InvNo</th>
                                                                <th style={{ padding: "2px", textAlign: "left", width: "15%", fontWeight: 600 }}>Qty</th>
                                                                <th style={{ padding: "2px", textAlign: "left", width: "20%", fontWeight: 600 }}>Rate</th>
                                                              </tr>
                                                            </thead>
                                                            <tbody>
                                                              {liftingData.map((lift, idx) => (
                                                                <tr key={idx} style={{ borderBottom: "1px dashed #eee" }}>
                                                                  <td style={{ padding: '2px', textAlign: 'left' }}>{lift.LiftDate || '-'}</td>
                                                                  <td style={{ padding: '2px', textAlign: 'left' }}>{lift.LorryNo || '-'}</td>
                                                                  <td style={{ padding: '2px', textAlign: 'left' }}>{lift.BNo || lift.InvoiceNo || '-'}</td>
                                                                  <td style={{ padding: '2px', textAlign: 'left' }}>{Number(lift.LiftedQty).toFixed(4).replace(/\.?0+$/, '')}</td>
                                                                  <td style={{ padding: '2px', textAlign: 'left' }}>{lift.Rate != null ? lift.Rate : '-'}</td>
                                                                </tr>
                                                              ))}
                                                            </tbody>
                                                          </table>
                                                        </div>
                                                      );
                                                    } catch (e) { return "Invalid Data"; }
                                                  })()}
                                                </td>
                                              )
                                              case 'Note': return (
                                                <td key={col.key} className={`ledger-note-cell ${row.Status === "S" ? "fw-bold" : ""}`} style={{ ...tdStyle, verticalAlign: "middle" }}>
                                                  <div className="note-inner">{getCombinedNotes(row)}</div>
                                                </td>
                                              )
                                              default: return null
                                            }
                                          })}
                                        </tr>
                                      )
                                    })}
                                  </React.Fragment>
                                ))
                              })()}
                            </tbody>
                            <tfoot
                              style={{
                                position: "sticky",
                                bottom: 0,
                                zIndex: 10,
                                overflow: "visible",
                              }}
                            >
                              {(() => {
                                const footerCalcs = getFooterCalculations()
                                return (
                                  <>
                                    {/* --- All Records Totals --- */}
                                    {/* Mobile view */}
                                    <tr className="totals-row d-md-none">
                                      <td
                                        colSpan={lrCols.length}
                                        className="border-bottom text-start p-0"
                                        style={{
                                          verticalAlign: "middle",
                                          border: "none",
                                        }}
                                      >
                                        <div
                                          style={{
                                            backgroundColor: "#4B0082",
                                            padding: "6px 8px",
                                            width: "100%",
                                            height: "100%",
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "2px",
                                            boxSizing: "border-box",
                                          }}
                                        >
                                          {/* <div className="fw-bold" style={{ fontSize: "0.75rem", color: "#FFD700" }}>
                                        All ({footerCalcs.all.count} Records)
                                      </div> */}
                                          <small style={{ fontSize: "0.7rem", fontWeight: "bold", display: "block" }}>
                                            <span style={{ color: "#FFD700" }}>{footerCalcs.all.count}</span>
                                            <span style={{ color: "#A0A0A0" }}> | </span>
                                            <span style={{ color: "#FFFFFF" }}>B:{footerCalcs.all.buyQty.toFixed(2)}</span>
                                            <span style={{ color: "#A0A0A0" }}> | </span>
                                            <span style={{ color: "#FFFFFF" }}>S:{footerCalcs.all.sellQty.toFixed(2)}</span>
                                            <span style={{ color: "#A0A0A0" }}> | </span>
                                            <span style={{ color: "#FFFFFF" }}>BA:{footerCalcs.all.buyAvg.toFixed(2)}</span>
                                            <span style={{ color: "#A0A0A0" }}> | </span>
                                            <span style={{ color: "#FFFFFF" }}>SA:{footerCalcs.all.sellAvg.toFixed(2)}</span>
                                            <span style={{ color: "#A0A0A0" }}> | </span>
                                            <span style={{ color: footerCalcs.all.diff >= 0 ? "#90EE90" : "#FFB6C1" }}>
                                              Diff:{footerCalcs.all.diff.toFixed(2)}
                                            </span>
                                            <span style={{ color: "#A0A0A0" }}> | </span>
                                            <span style={{ color: "#FFFFFF" }}>S.Adv:{footerCalcs.all.sAdv.toFixed(2)}</span>
                                            <span style={{ color: "#A0A0A0" }}> | </span>
                                            <span style={{ color: "#FFFFFF" }}>P.Adv:{footerCalcs.all.pAdv.toFixed(2)}</span>
                                            <span style={{ color: "#A0A0A0" }}> | </span>
                                            <span style={{ color: "#FFFFFF" }}>Lifted:{footerCalcs.all.lifted.toFixed(2)}</span>
                                          </small>
                                        </div>
                                      </td>
                                    </tr>
                                    {/* Desktop view */}
                                    <tr
                                      className="totals-row d-none d-md-table-row"
                                      style={{
                                        height: "25px",
                                        backgroundColor: "#4B0082",
                                        color: "#FFFFFF",
                                      }}
                                    >
                                      {lrCols.map((col) => {
                                        const widthVal = `${columnWidths[col.key] || COLUMN_DEFAULT_WIDTHS[col.key] || 80}px`
                                        const cellProps = getFooterCellProps(col.key, 'all', footerCalcs)
                                        return (
                                          <td
                                            key={col.key}
                                            className={`text-${cellProps.halign} fw-bold`}
                                            style={{
                                              verticalAlign: "middle",
                                              padding: "0 4px",
                                              border: "1.5px solid black",
                                              width: widthVal,
                                              maxWidth: widthVal,
                                              minWidth: widthVal,
                                              boxSizing: "border-box",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              whiteSpace: "nowrap",
                                              fontSize: "0.65rem",
                                              color: "#FFFFFF",
                                            }}
                                          >
                                            {cellProps.content}
                                          </td>
                                        )
                                      })}
                                    </tr>

                                    {/* --- Selected Rows Totals --- */}
                                    {footerCalcs.selected.hasSelection && (
                                      <>
                                        {/* Mobile view */}
                                        <tr className="selected-totals-row d-md-none">
                                          <td
                                            colSpan={lrCols.length}
                                            className="border-bottom text-start p-0"
                                            style={{
                                              verticalAlign: "middle",
                                              border: "none",
                                            }}
                                          >
                                            <div
                                              style={{
                                                backgroundColor: "#FF8C00",
                                                padding: "6px 8px",
                                                width: "100%",
                                                height: "100%",
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: "2px",
                                                boxSizing: "border-box",
                                              }}
                                            >
                                              {/* <div className="fw-bold" style={{ fontSize: "0.75rem", color: "#FFFFFF" }}>
                                            Selected ({footerCalcs.selected.count} Records)
                                          </div> */}
                                              <small style={{ fontSize: "0.7rem", fontWeight: "bold", display: "block" }}>
                                                <span style={{ color: "#000000" }}>{footerCalcs.selected.count}</span>
                                                <span style={{ color: "#333333" }}> | </span>
                                                <span style={{ color: "#000000" }}>B:{footerCalcs.selected.buyQty.toFixed(2)}</span>
                                                <span style={{ color: "#333333" }}> | </span>
                                                <span style={{ color: "#000000" }}>S:{footerCalcs.selected.sellQty.toFixed(2)}</span>
                                                <span style={{ color: "#333333" }}> | </span>
                                                <span style={{ color: "#000000" }}>BA:{footerCalcs.selected.buyAvg.toFixed(2)}</span>
                                                <span style={{ color: "#333333" }}> | </span>
                                                <span style={{ color: "#000000" }}>SA:{footerCalcs.selected.sellAvg.toFixed(2)}</span>
                                                <span style={{ color: "#333333" }}> | </span>
                                                <span style={{ color: footerCalcs.selected.diff >= 0 ? "#006400" : "#8B0000" }}>
                                                  Diff:{footerCalcs.selected.diff.toFixed(2)}
                                                </span>
                                                <span style={{ color: "#333333" }}> | </span>
                                                <span style={{ color: "#000000" }}>S.Adv:{footerCalcs.selected.sAdv.toFixed(2)}</span>
                                                <span style={{ color: "#333333" }}> | </span>
                                                <span style={{ color: "#000000" }}>P.Adv:{footerCalcs.selected.pAdv.toFixed(2)}</span>
                                                <span style={{ color: "#333333" }}> | </span>
                                                <span style={{ color: "#000000" }}>Lifted:{footerCalcs.selected.lifted.toFixed(2)}</span>
                                              </small>
                                            </div>
                                          </td>
                                        </tr>
                                        {/* Desktop view */}
                                        <tr
                                          className="selected-totals-row d-none d-md-table-row"
                                          style={{
                                            height: "25px",
                                            backgroundColor: "#FF8C00",
                                            color: "#FFFFFF",
                                          }}
                                        >
                                          {lrCols.map((col) => {
                                            const widthVal = `${columnWidths[col.key] || COLUMN_DEFAULT_WIDTHS[col.key] || 80}px`
                                            const cellProps = getFooterCellProps(col.key, 'selected', footerCalcs)
                                            return (
                                              <td
                                                key={col.key}
                                                className={`text-${cellProps.halign} fw-bold`}
                                                style={{
                                                  verticalAlign: "middle",
                                                  padding: "0 4px",
                                                  border: "1.5px solid black",
                                                  width: widthVal,
                                                  maxWidth: widthVal,
                                                  minWidth: widthVal,
                                                  boxSizing: "border-box",
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                  whiteSpace: "nowrap",
                                                  fontSize: "0.65rem",
                                                  color: "#FFFFFF",
                                                }}
                                              >
                                                {cellProps.content}
                                              </td>
                                            )
                                          })}
                                        </tr>
                                      </>
                                    )}
                                  </>
                                )
                              })()}
                            </tfoot>
                          </Table>
                        );
                      })()}
                    </div>

                    {/* Filters Bar - Party, Item, Period Dropdowns - Below Table (attached to table, no gap) */}
                    <div
                      className="bottom-filters-bar"
                      style={{
                        backgroundColor: "#6C244C",
                        color: "white",
                        borderRadius: "0",
                        fontSize: "0.8rem",
                        fontWeight: "bold",
                        marginTop: "0",
                        marginBottom: "0",
                        paddingTop: "6px",
                        paddingBottom: "6px",
                        flexShrink: "0",
                        width: "100%",
                        overflowX: "auto",
                        overflowY: "hidden",
                      }}
                    >
                      <div
                        className="d-flex align-items-center"
                        style={{
                          padding: "6px 12px",
                          gap: `${bottomGap}px`,
                          flexWrap: "nowrap",
                          minWidth: "fit-content"
                        }}
                      >
                        {/* Left side - Icon: toggles Detailed view */}
                        <div
                          className="d-flex align-items-center"
                          style={{ flex: "0 0 auto" }}
                          onClick={() => setIsDetailed(prev => !prev)}
                          title={isDetailed ? "Detailed ON � click to turn OFF" : "Detailed OFF � click to turn ON"}
                        >
                          <i
                            className="fas fa-list-alt me-2"
                            style={{
                              fontSize: "1rem",
                              cursor: "pointer",
                              color: isDetailed ? "#fff" : "#6c757d",
                              backgroundColor: isDetailed ? "#198754" : "#e9ecef",
                              borderRadius: "4px",
                              padding: "4px 5px",
                              border: isDetailed ? "1px solid #146c43" : "1px solid #ced4da",
                              transition: "all 0.2s",
                            }}
                          ></i>
                        </div>

                        {renderFilterBar(bottomFilterOrder, bottomFilterWidths, bottomGap, setBottomGap, bottomDragStart, bottomDragOver, bottomDrop, bottomDragEnd, bottomTouchDragStart, bottomTouchDragMove, bottomTouchDragEnd, bottomResizeDown, resetBottomLayout, renderBottomFilterContent, bottomFilterStart, bottomActiveReorderId)}

                      </div>
                    </div>



                    {/* Pagination Controls */}
                    {false && (
                      <div
                        className="d-flex justify-content-between align-items-center pagination-controls"
                        style={{
                          marginTop: "0",
                          paddingLeft: "0",
                          paddingRight: "0",
                          flexShrink: "0",
                          minHeight: "40px",
                          position: "sticky",
                          bottom: "0",
                          backgroundColor: "white",
                          zIndex: "10",
                        }}
                      >
                        {totalPages > 1 && (
                          <div
                            className="d-flex align-items-center"
                            style={{ gap: "0" }}
                          >
                            <Button
                              size="sm"
                              color="outline-primary"
                              onClick={() => handlePageChange(1)}
                              disabled={currentPage === 1}
                              title="First Page"
                            >
                              <i className="fas fa-angle-double-left"></i>
                            </Button>
                            <Button
                              size="sm"
                              color="outline-primary"
                              onClick={() => handlePageChange(currentPage - 1)}
                              disabled={currentPage === 1}
                              title="Previous Page"
                            >
                              <i className="fas fa-angle-left"></i>
                            </Button>

                            {/* Page Numbers */}
                            <div
                              className="d-flex align-items-center"
                              style={{ gap: "0" }}
                            >
                              {(() => {
                                const pageNumbers = []
                                const maxVisiblePages = 5
                                let startPage = Math.max(
                                  1,
                                  currentPage - Math.floor(maxVisiblePages / 2)
                                )
                                let endPage = Math.min(
                                  totalPages,
                                  startPage + maxVisiblePages - 1
                                )

                                // Adjust start page if we're near the end
                                if (endPage - startPage < maxVisiblePages - 1) {
                                  startPage = Math.max(
                                    1,
                                    endPage - maxVisiblePages + 1
                                  )
                                }

                                // Add first page and ellipsis if needed
                                if (startPage > 1) {
                                  pageNumbers.push(
                                    <Button
                                      key={1}
                                      size="sm"
                                      color={
                                        1 === currentPage
                                          ? "primary"
                                          : "outline-primary"
                                      }
                                      onClick={() => handlePageChange(1)}
                                      style={{
                                        minWidth: "35px",
                                        fontSize: "0.75rem",
                                      }}
                                    >
                                      1
                                    </Button>
                                  )
                                  if (startPage > 2) {
                                    pageNumbers.push(
                                      <span
                                        key="ellipsis1"
                                        className="text-muted px-2"
                                      >
                                        ...
                                      </span>
                                    )
                                  }
                                }

                                // Add visible page numbers
                                for (let i = startPage; i <= endPage; i++) {
                                  pageNumbers.push(
                                    <Button
                                      key={i}
                                      size="sm"
                                      color={
                                        i === currentPage
                                          ? "primary"
                                          : "outline-primary"
                                      }
                                      onClick={() => handlePageChange(i)}
                                      style={{
                                        minWidth: "35px",
                                        fontSize: "0.75rem",
                                      }}
                                    >
                                      {i}
                                    </Button>
                                  )
                                }

                                // Add ellipsis and last page if needed
                                if (endPage < totalPages) {
                                  if (endPage < totalPages - 1) {
                                    pageNumbers.push(
                                      <span
                                        key="ellipsis2"
                                        className="text-muted px-2"
                                      >
                                        ...
                                      </span>
                                    )
                                  }
                                  pageNumbers.push(
                                    <Button
                                      key={totalPages}
                                      size="sm"
                                      color={
                                        totalPages === currentPage
                                          ? "primary"
                                          : "outline-primary"
                                      }
                                      onClick={() =>
                                        handlePageChange(totalPages)
                                      }
                                      style={{
                                        minWidth: "35px",
                                        fontSize: "0.75rem",
                                      }}
                                    >
                                      {totalPages}
                                    </Button>
                                  )
                                }

                                return pageNumbers
                              })()}
                            </div>

                            <Button
                              size="sm"
                              color="outline-primary"
                              onClick={() => handlePageChange(currentPage + 1)}
                              disabled={currentPage === totalPages}
                              title="Next Page"
                            >
                              <i className="fas fa-angle-right"></i>
                            </Button>
                            <Button
                              size="sm"
                              color="outline-primary"
                              onClick={() => handlePageChange(totalPages)}
                              disabled={currentPage === totalPages}
                              title="Last Page"
                            >
                              <i className="fas fa-angle-double-right"></i>
                            </Button>
                          </div>
                        )}
                      </div>
                    )}
                  </>
                ) : (
                  <div className="text-center py-2">
                    <i className="fas fa-search fa-lg text-muted mb-1"></i>
                    <h6 className="text-muted mb-1" style={{ fontSize: "0.9rem" }}>
                      No data found for the selected criteria.
                    </h6>
                    <p className="text-muted small mb-0">
                      Try adjusting your search parameters.
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* EditContract Modal */}
      <Modal
        show={showEditContractModal}
        onHide={closeEditContractModal}
        size="xl"
        fullscreen="lg-down"
        centered
        className="edit-contract-modal"
        style={{ zIndex: 9999 }}
      >
        <ModalHeader className="bg-primary text-white">
          <div className="d-flex justify-content-between align-items-center w-100">
            <div>
              <h5 className="mb-0">
                <i className="fas fa-edit me-2"></i>
                Edit Contract: {selectedContractData?.ContractNo || "Unknown"}
                {modalLoading && (
                  <Spinner
                    animation="border"
                    size="sm"
                    className="ms-2 text-light"
                  />
                )}
              </h5>
            </div>
            <Button
              variant="light"
              onClick={closeEditContractModal}
              className="btn-sm"
              title="Back to Report"
            >
              <i className="fas fa-arrow-left me-1"></i>
              Back to Report
            </Button>
          </div>
        </ModalHeader>
        <ModalBody
          className="p-0"
          style={{ minHeight: "70vh", maxHeight: "80vh" }}
        >
          {selectedContractData && (
            <>
              <EditContract
                isModal={true}
                contractData={selectedContractData}
                onClose={closeEditContractModal}
              />
            </>
          )}
        </ModalBody>
      </Modal>



      {/* Voucher Modal */}
      <Modal
        show={showVoucherModal}
        onHide={closeVoucherModal}
        size="xl"
        centered
        className="voucher-modal"
        style={{ zIndex: 9999 }}
      >
        <ModalHeader className="bg-info text-white">
          <div className="d-flex justify-content-between align-items-center w-100">
            <div>
              <h5 className="mb-0">
                <i className="fas fa-file-invoice me-2"></i>
                Voucher Management
              </h5>
            </div>
            <Button
              variant="light"
              onClick={closeVoucherModal}
              className="btn-sm"
              title="Close"
            >
              <i className="fas fa-times"></i>
            </Button>
          </div>
        </ModalHeader>
        <ModalBody className="p-3">
          {/* Voucher List Section */}
          <Row className="mb-3">
            <Col md={12}>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <h6 className="mb-0 text-primary">
                  <i className="fas fa-list me-2"></i>
                  Existing Vouchers
                </h6>
                <Button
                  size="sm"
                  color="success"
                  onClick={() => {
                    setVoucherMode("save")
                    setVoucherData({
                      id: 0,
                      VoucherNo:
                        state.VoucherNoArray && state.VoucherNoArray.length > 0
                          ? state.VoucherNoArray[0]?.VoucherNoNew || ""
                          : "",
                      VoucherDate: new Date(),
                      F_LedgerMasterDr: "",
                      F_LedgerMasterCr: "",
                      Amount: "",
                      Narration: "",
                    })
                  }}
                >
                  <i className="fas fa-plus me-1"></i>
                  New Voucher
                </Button>
              </div>

              {/* Search Bar */}
              <div className="mb-2">
                <Input
                  type="text"
                  placeholder="Search vouchers by number, narration, or party..."
                  value={voucherSearchTerm}
                  onChange={e => setVoucherSearchTerm(e.target.value)}
                  className="form-control-sm"
                  style={{ maxWidth: "400px" }}
                />
              </div>

              {/* Voucher Table */}
              <div
                className="table-responsive"
                style={{ maxHeight: "300px", overflowY: "auto" }}
              >
                <Table striped size="sm" className="mb-0">
                  <thead className="table-light sticky-top">
                    <tr>
                      <th>Voucher No</th>
                      <th>Date</th>
                      <th>Cash/Bank</th>
                      <th>Party</th>
                      <th>Amount</th>
                      <th>Narration</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {state.VoucherHArray && state.VoucherHArray.length > 0 ? (
                      state.VoucherHArray.filter(voucher => {
                        if (!voucherSearchTerm) return true
                        const searchLower = voucherSearchTerm.toLowerCase()
                        return (
                          voucher.VoucherNo?.toLowerCase().includes(
                            searchLower
                          ) ||
                          voucher.Narration?.toLowerCase().includes(
                            searchLower
                          ) ||
                          state.LedgerArray.find(
                            l => l.Id === parseInt(voucher.F_LedgerMasterCr)
                          )
                            ?.Name?.toLowerCase()
                            .includes(searchLower) ||
                          state.LedgerArray.find(
                            l => l.Id === parseInt(voucher.F_LedgerMasterDr)
                          )
                            ?.Name?.toLowerCase()
                            .includes(searchLower)
                        )
                      }).map((voucher, index) => (
                        <tr
                          key={voucher.Id || index}
                          className={
                            voucherData.id === voucher.Id ? "table-primary" : ""
                          }
                        >
                          <td className="fw-semibold">{voucher.VoucherNo}</td>
                          <td>
                            {voucher.VoucherDate
                              ? new Date(
                                voucher.VoucherDate
                              ).toLocaleDateString("en-GB")
                              : "-"}
                          </td>
                          <td>
                            {state.LedgerArray.find(
                              l => l.Id === parseInt(voucher.F_LedgerMasterDr)
                            )?.Name || "-"}
                          </td>
                          <td>
                            {state.LedgerArray.find(
                              l => l.Id === parseInt(voucher.F_LedgerMasterCr)
                            )?.Name || "-"}
                          </td>
                          <td className="fw-bold text-success">
                            ?{parseFloat(voucher.Amount || 0).toFixed(2)}
                          </td>
                          <td
                            className="text-truncate"
                            style={{ maxWidth: "150px" }}
                            title={voucher.Narration}
                          >
                            {voucher.Narration || "-"}
                          </td>
                          <td>
                            <div className="btn-group btn-group-sm">
                              <Button
                                size="sm"
                                color="primary"
                                onClick={() => {
                                  setVoucherMode("edit")
                                  setVoucherData({
                                    id: voucher.Id,
                                    VoucherNo: voucher.VoucherNo || "",
                                    VoucherDate: voucher.VoucherDate
                                      ? new Date(voucher.VoucherDate)
                                      : new Date(),
                                    F_LedgerMasterDr:
                                      voucher.F_LedgerMasterDr || "",
                                    F_LedgerMasterCr:
                                      voucher.F_LedgerMasterCr || "",
                                    Amount: voucher.Amount || "",
                                    Narration: voucher.Narration || "",
                                  })
                                  setVoucherErrors({})
                                }}
                                title="Edit Voucher"
                              >
                                <i className="fas fa-edit"></i>
                              </Button>
                              <Button
                                size="sm"
                                color="danger"
                                onClick={() => {
                                  if (
                                    window.confirm(
                                      "Are you sure you want to delete this voucher?"
                                    )
                                  ) {
                                    handleDeleteVoucher(voucher.Id)
                                  }
                                }}
                                title="Delete Voucher"
                              >
                                <i className="fas fa-trash"></i>
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center text-muted py-3">
                          <i className="fas fa-inbox fa-2x mb-2"></i>
                          <br />
                          No vouchers found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </Col>
          </Row>

          {/* Divider */}
          <hr className="my-3" />

          {/* Voucher Form Section */}
          <div className="mb-3">
            <div className="d-flex justify-content-between align-items-center">
              <h6 className="mb-0 text-primary">
                <i className="fas fa-edit me-2"></i>
                {voucherMode === "save" ? "Add New Voucher" : "Edit Voucher"}
              </h6>
              {voucherMode === "edit" && voucherData.id && (
                <div className="text-muted small">
                  <span className="badge bg-info me-2">
                    <i className="fas fa-info-circle me-1"></i>
                    Editing Voucher #{voucherData.VoucherNo}
                  </span>
                  <span className="badge bg-secondary">
                    <i className="fas fa-calendar me-1"></i>
                    {voucherData.VoucherDate
                      ? new Date(voucherData.VoucherDate).toLocaleDateString(
                        "en-GB"
                      )
                      : "No Date"}
                  </span>
                </div>
              )}
            </div>
          </div>

          <Form onSubmit={handleSaveVoucher}>
            <Row className="g-2">
              <Col md={6}>
                <FormGroup className="mb-2">
                  <FormLabel htmlFor="voucherNo" className="fw-semibold">
                    Voucher No:
                  </FormLabel>
                  <Input
                    type="text"
                    id="voucherNo"
                    value={voucherData.VoucherNo}
                    onChange={e =>
                      setVoucherData({
                        ...voucherData,
                        VoucherNo: e.target.value,
                      })
                    }
                    className="form-control form-control-sm"
                    placeholder={
                      voucherMode === "save"
                        ? "Auto-generated voucher number"
                        : "Enter voucher number"
                    }
                    readOnly={voucherMode === "save"}
                    style={
                      voucherMode === "save"
                        ? { backgroundColor: "#e9ecef", cursor: "not-allowed" }
                        : {}
                    }
                  />
                  {voucherMode === "save" && (
                    <small className="text-muted">
                      Next voucher number:{" "}
                      {state.VoucherNoArray && state.VoucherNoArray.length > 0
                        ? state.VoucherNoArray[0]?.VoucherNoNew ||
                        "Not available"
                        : "Not available"}
                    </small>
                  )}
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup className="mb-2">
                  <FormLabel htmlFor="voucherDate" className="fw-semibold">
                    Voucher Date: <span className="text-danger">*</span>
                  </FormLabel>
                  <DatePicker
                    selected={voucherData.VoucherDate}
                    onChange={date => {
                      setVoucherData({ ...voucherData, VoucherDate: date })
                      // Clear error when user selects date
                      if (voucherErrors.VoucherDate) {
                        setVoucherErrors({ ...voucherErrors, VoucherDate: "" })
                      }
                    }}
                    className={`form-control form-control-sm ${voucherErrors.VoucherDate ? "is-invalid" : ""
                      }`}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="Select voucher date"
                    openToDate={new Date()}
                  />
                  {voucherErrors.VoucherDate && (
                    <div className="invalid-feedback d-block">
                      {voucherErrors.VoucherDate}
                    </div>
                  )}
                </FormGroup>
              </Col>
              <Col md={12}>
                <FormGroup className="mb-2">
                  <FormLabel htmlFor="dropdown1" className="fw-semibold">
                    Cash/Bank <span className="text-danger">*</span>
                  </FormLabel>
                  <Select
                    options={state.LedgerArray.map(ledger => ({
                      value: ledger.Id,
                      label: ledger.Name,
                    }))}
                    value={
                      state.LedgerArray
                        ? {
                          value: voucherData.F_LedgerMasterDr,
                          label: state.LedgerArray.find(
                            l =>
                              l.Id === parseInt(voucherData.F_LedgerMasterDr)
                          )?.Name,
                        }
                        : null
                    }
                    onChange={option => {
                      setVoucherData({
                        ...voucherData,
                        F_LedgerMasterDr: option?.value || "",
                      })
                      // Clear error when user makes selection
                      if (voucherErrors.F_LedgerMasterDr) {
                        setVoucherErrors({
                          ...voucherErrors,
                          F_LedgerMasterDr: "",
                        })
                      }
                    }}
                    placeholder="Select Cash/Bank"
                    className={`form-select-sm ${voucherErrors.F_LedgerMasterDr ? "is-invalid" : ""
                      }`}
                    style={{ backgroundColor: "#f8f9fa" }}
                    isSearchable
                    classNamePrefix="react-select"
                    noOptionsMessage={() => "No options found"}
                    isClearable
                  />
                  {voucherErrors.F_LedgerMasterDr && (
                    <div className="invalid-feedback d-block">
                      {voucherErrors.F_LedgerMasterDr}
                    </div>
                  )}
                </FormGroup>
              </Col>
              <Col md={12}>
                <FormGroup className="mb-2">
                  <FormLabel htmlFor="dropdown2" className="fw-semibold">
                    Party Name <span className="text-danger">*</span>
                  </FormLabel>
                  <Select
                    options={state.LedgerArray.map(ledger => ({
                      value: ledger.Id,
                      label: ledger.Name,
                    }))}
                    value={
                      state.LedgerArray.find(
                        l => l.Id === parseInt(voucherData.F_LedgerMasterCr)
                      )
                        ? {
                          value: voucherData.F_LedgerMasterCr,
                          label: state.LedgerArray.find(
                            l =>
                              l.Id === parseInt(voucherData.F_LedgerMasterCr)
                          )?.Name,
                        }
                        : null
                    }
                    onChange={option => {
                      setVoucherData({
                        ...voucherData,
                        F_LedgerMasterCr: option?.value || "",
                      })
                      // Clear error when user makes selection
                      if (voucherErrors.F_LedgerMasterCr) {
                        setVoucherErrors({
                          ...voucherErrors,
                          F_LedgerMasterCr: "",
                        })
                      }
                    }}
                    placeholder="Select Party Name"
                    className={`form-select-sm ${voucherErrors.F_LedgerMasterCr ? "is-invalid" : ""
                      }`}
                    style={{ backgroundColor: "#f8f9fa" }}
                    isSearchable
                    classNamePrefix="react-select"
                    noOptionsMessage={() => "No ledgers found"}
                    isClearable
                  />
                  {voucherErrors.F_LedgerMasterCr && (
                    <div className="invalid-feedback d-block">
                      {voucherErrors.F_LedgerMasterCr}
                    </div>
                  )}
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup className="mb-2">
                  <FormLabel htmlFor="amount" className="fw-semibold">
                    Amount: <span className="text-danger">*</span>
                  </FormLabel>
                  <Input
                    type="number"
                    id="amount"
                    value={voucherData.Amount}
                    onChange={e => {
                      setVoucherData({ ...voucherData, Amount: e.target.value })
                      // Clear error when user types
                      if (voucherErrors.Amount) {
                        setVoucherErrors({ ...voucherErrors, Amount: "" })
                      }
                    }}
                    className={`form-control form-control-sm ${voucherErrors.Amount ? "is-invalid" : ""
                      }`}
                    placeholder="Enter amount"
                    step="0.01"
                    min="0"
                  />
                  {voucherErrors.Amount && (
                    <div className="invalid-feedback d-block">
                      {voucherErrors.Amount}
                    </div>
                  )}
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup className="mb-2">
                  <FormLabel htmlFor="narration" className="fw-semibold">
                    Narration:
                  </FormLabel>
                  <Input
                    type="text"
                    id="narration"
                    value={voucherData.Narration}
                    onChange={e =>
                      setVoucherData({
                        ...voucherData,
                        Narration: e.target.value,
                      })
                    }
                    className="form-control form-control-sm"
                    placeholder="Enter narration"
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <Button
                  type="submit"
                  color="success"
                  className="px-4 py-2 w-100"
                  disabled={voucherLoading}
                >
                  {voucherLoading ? (
                    <>
                      <Spinner animation="border" size="sm" className="me-2" />
                      {voucherMode === "save" ? "Saving..." : "Updating..."}
                    </>
                  ) : (
                    <>
                      <i className="fas fa-save me-2"></i>
                      {voucherMode === "save"
                        ? "Save Voucher"
                        : "Update Voucher"}
                    </>
                  )}
                </Button>
              </Col>
              <Col md={3}>
                <Button
                  type="button"
                  color="danger"
                  className="px-4 py-2 w-100"
                  onClick={handleDeleteVoucher}
                  disabled={voucherMode === "save" || voucherLoading}
                >
                  <i className="fas fa-trash me-2"></i>
                  Delete Voucher
                </Button>
              </Col>
              <Col md={3}>
                <Button
                  type="button"
                  color="warning"
                  className="px-4 py-2 w-100"
                  onClick={() => {
                    setVoucherData({
                      id: 0,
                      VoucherNo:
                        state.VoucherNoArray && state.VoucherNoArray.length > 0
                          ? state.VoucherNoArray[0]?.VoucherNoNew || ""
                          : "",
                      VoucherDate: new Date(),
                      F_LedgerMasterDr: "",
                      F_LedgerMasterCr: "",
                      Amount: "",
                      Narration: "",
                    })
                    setVoucherMode("save")
                    setVoucherErrors({})
                  }}
                  disabled={voucherLoading}
                >
                  <i className="fas fa-undo me-2"></i>
                  Clear Form
                </Button>
              </Col>
              <Col md={3}>
                <Button
                  type="button"
                  color="secondary"
                  className="px-4 py-2 w-100"
                  onClick={closeVoucherModal}
                >
                  <i className="fas fa-times me-2"></i>
                  Close
                </Button>
              </Col>
            </Row>
          </Form>
        </ModalBody>
      </Modal>

      {/* Party Filter Modal */}
      <Modal
        show={showPartyModal}
        onHide={closePartyModal}
        size="lg"
        centered
        style={{ zIndex: 10000 }}
      >
        <ModalHeader className="bg-primary text-white">
          <div className="d-flex justify-content-between align-items-center w-100">
            <h5 className="mb-0">
              <i className="fas fa-users me-2"></i>
              Select Party
            </h5>
            <Button
              variant="light"
              onClick={closePartyModal}
              className="btn-close btn-close-white"
              style={{ border: "none", background: "transparent" }}
            >
              <i className="fas fa-times"></i>
            </Button>
          </div>
        </ModalHeader>
        <ModalBody style={{ padding: "1.5rem", maxHeight: "60vh", overflowY: "auto" }}>
          <Form>
            <FormGroup>
              <div className="mb-3">
                <FormLabel className="fw-semibold mb-0">
                  Party
                </FormLabel>
              </div>
              <div style={{ maxHeight: "400px", overflowY: "auto", border: "1px solid #dee2e6", borderRadius: "4px", padding: "10px" }}>
                {getUniquePartiesFromData().map((party) => {
                  const isHeadLedger = selectedLedgerNames.includes(party.value)
                  return (
                    <div
                      key={party.value}
                      style={{
                        padding: "8px",
                        cursor: isHeadLedger ? "not-allowed" : "pointer",
                        borderRadius: "4px",
                        backgroundColor: tempSelectedParties.some(p => p === party.value) ? "#e7f3ff" : "transparent",
                        marginBottom: "4px",
                        opacity: isHeadLedger ? 0.8 : 1,
                      }}
                      onClick={() => {
                        if (isHeadLedger) return;
                        
                        const isSelected = tempSelectedParties.some(p => p === party.value)
                        if (isSelected) {
                          setTempSelectedParties(tempSelectedParties.filter(p => p !== party.value))
                        } else {
                          setTempSelectedParties([...tempSelectedParties, party.value])
                        }
                      }}
                    >
                      <div className="d-flex align-items-center">
                        <input
                          type="checkbox"
                          checked={tempSelectedParties.some(p => p === party.value)}
                          onChange={() => { }}
                          style={{ marginRight: "10px", cursor: isHeadLedger ? "not-allowed" : "pointer" }}
                          disabled={isHeadLedger}
                        />
                        <span>{party.label} {isHeadLedger && <span className="badge bg-secondary ms-2" style={{ fontSize: "0.6rem" }}>Head</span>}</span>
                      </div>
                    </div>
                  )
                })}
                {getUniquePartiesFromData().length === 0 && (
                  <div className="text-center text-muted py-3">
                    No parties available
                  </div>
                )}
              </div>
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end gap-2">
          <Button variant="outline-secondary" size="sm" onClick={() => {
            const headLedgers = getUniquePartiesFromData()
              .filter(p => selectedLedgerNames.includes(p.value))
              .map(p => p.value)
            setTempSelectedParties(headLedgers)
          }}>
            Clear All
          </Button>
          <Button variant="outline-primary" size="sm" onClick={() => {
            const allParties = getUniquePartiesFromData().map(p => p.value)
            setTempSelectedParties(allParties)
          }}>
            Select All
          </Button>
          <Button variant="primary" onClick={handlePartyModalDone}>
            <i className="fas fa-check me-2"></i>
            Done
          </Button>
        </ModalFooter>
      </Modal>

      {/* Item Filter Modal */}
      <Modal
        show={showItemModal}
        onHide={closeItemModal}
        size="lg"
        centered
        style={{ zIndex: 10000 }}
      >
        <ModalHeader className="bg-primary text-white">
          <div className="d-flex justify-content-between align-items-center w-100">
            <h5 className="mb-0">
              <i className="fas fa-box me-2"></i>
              Select Items
            </h5>
            <Button
              variant="light"
              onClick={closeItemModal}
              className="btn-close btn-close-white"
              style={{ border: "none", background: "transparent" }}
            >
              <i className="fas fa-times"></i>
            </Button>
          </div>
        </ModalHeader>
        <ModalBody style={{ padding: "1.5rem", maxHeight: "60vh", overflowY: "auto" }}>
          <Form>
            <FormGroup>
              <div className="mb-3">
                <FormLabel className="fw-semibold mb-0">
                  Items
                </FormLabel>
              </div>
              <div style={{ maxHeight: "400px", overflowY: "auto", border: "1px solid #dee2e6", borderRadius: "4px", padding: "10px" }}>
                {itemOptions.map((item) => (
                  <div
                    key={item.value}
                    style={{
                      padding: "8px",
                      cursor: "pointer",
                      borderRadius: "4px",
                      backgroundColor: tempSelectedItems.some(i => String(i) === String(item.value)) ? "#e7f3ff" : "transparent",
                      marginBottom: "4px",
                    }}
                    onClick={() => {
                      const isSelected = tempSelectedItems.some(i => String(i) === String(item.value))
                      let newSelected = [...tempSelectedItems]

                      if (isSelected) {
                        newSelected = newSelected.filter(i => String(i) !== String(item.value))
                      } else {
                        newSelected.push(item.value)
                      }

                      // Normalize items
                      let normalized = newSelected.map(i => (i === "" ? "" : String(i)))
                      if (normalized.includes("") && normalized.length > 1) {
                        normalized = normalized.filter(i => i !== "")
                      }

                      setTempSelectedItems(normalized)
                    }}

                  >
                    <div className="d-flex align-items-center">
                      <input
                        type="checkbox"
                        checked={tempSelectedItems.some(i => String(i) === String(item.value))}
                        onChange={() => { }}
                        style={{ marginRight: "10px", cursor: "pointer" }}
                      />
                      <span>{item.label}</span>
                    </div>
                  </div>
                ))}
                {itemOptions.length === 0 && (
                  <div className="text-center text-muted py-3">
                    No items available
                  </div>
                )}
              </div>
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end gap-2">
          <Button variant="outline-secondary" size="sm" onClick={() => setTempSelectedItems([])}>
            Clear All
          </Button>
          <Button variant="outline-primary" size="sm" onClick={() => {
            const allItems = itemOptions.map(i => i.value)
            let normalized = allItems.map(item => (item === "" ? "" : String(item)))
            if (normalized.includes("") && normalized.length > 1) {
              normalized = normalized.filter(item => item !== "")
            }
            setTempSelectedItems(normalized)
          }}>
            Select All
          </Button>
          <Button variant="primary" onClick={handleItemModalDone}>
            <i className="fas fa-check me-2"></i>
            Done
          </Button>
        </ModalFooter>
      </Modal>

      {/* Vessel Filter Modal */}
      <Modal
        show={showVesselModal}
        onHide={closeVesselModal}
        size="lg"
        centered
        style={{ zIndex: 10000 }}
      >
        <ModalHeader className="bg-primary text-white">
          <div className="d-flex justify-content-between align-items-center w-100">
            <h5 className="mb-0">
              <i className="fas fa-ship me-2"></i>
              Select Vessel
            </h5>
            <Button
              variant="light"
              onClick={closeVesselModal}
              className="btn-close btn-close-white"
              style={{ border: "none", background: "transparent" }}
            >
              <i className="fas fa-times"></i>
            </Button>
          </div>
        </ModalHeader>
        <ModalBody style={{ padding: "1.5rem", maxHeight: "60vh", overflowY: "auto" }}>
          <Form>
            <FormGroup>
              <div className="mb-3">
                <FormLabel className="fw-semibold mb-0">Vessel</FormLabel>
              </div>
              <div style={{ maxHeight: "400px", overflowY: "auto", border: "1px solid #dee2e6", borderRadius: "4px", padding: "10px" }}>
                {getUniqueVesselsFromData().map((vessel) => (
                  <div
                    key={vessel.value}
                    style={{ padding: "8px", cursor: "pointer", borderRadius: "4px", backgroundColor: tempSelectedVessels.includes(vessel.value) ? "#e7f3ff" : "transparent", marginBottom: "4px" }}
                    onClick={() => {
                      if (tempSelectedVessels.includes(vessel.value)) {
                        setTempSelectedVessels(tempSelectedVessels.filter(v => v !== vessel.value))
                      } else {
                        setTempSelectedVessels([...tempSelectedVessels, vessel.value])
                      }
                    }}

                  >
                    <div className="d-flex align-items-center">
                      <input
                        type="checkbox"
                        checked={tempSelectedVessels.includes(vessel.value)}
                        onChange={() => { }}
                        style={{ marginRight: "10px", cursor: "pointer" }}
                      />
                      <span>{vessel.label}</span>
                    </div>
                  </div>
                ))}
                {getUniqueVesselsFromData().length === 0 && (
                  <div className="text-center text-muted py-3">No vessels available</div>
                )}
              </div>
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end gap-2">
          <Button variant="outline-secondary" size="sm" onClick={() => setTempSelectedVessels([])}>
            Clear
          </Button>
          <Button variant="outline-primary" size="sm" onClick={() => {
            const allVessels = getUniqueVesselsFromData().map(v => v.value)
            setTempSelectedVessels(allVessels)
          }}>
            Select All
          </Button>
          <Button variant="primary" onClick={handleVesselModalDone}>
            <i className="fas fa-check me-2"></i>
            Done
          </Button>
        </ModalFooter>
      </Modal>

      {/* Period Filter Modal */}
      {showPeriodModal && (
        <Modal
          show={showPeriodModal}
          onHide={closePeriodModal}
          size="lg"
          centered
          style={{ zIndex: 10000 }}
        >
          <ModalHeader className="bg-primary text-white">
            <div className="d-flex justify-content-between align-items-center w-100">
              <h5 className="mb-0">
                <i className="fas fa-calendar-alt me-2"></i>
                Select Period
              </h5>
              <Button
                variant="light"
                onClick={closePeriodModal}
                className="btn-close btn-close-white"
                style={{ border: "none", background: "transparent" }}
              >
                <i className="fas fa-times"></i>
              </Button>
            </div>
          </ModalHeader>
          <ModalBody style={{ padding: "1.5rem", maxHeight: "60vh", overflowY: "auto" }}>
            <Form>
              <FormGroup>
                <div className="mb-3">
                  <FormLabel className="fw-semibold mb-0">
                    Period
                  </FormLabel>
                </div>
                <div style={{ maxHeight: "400px", overflowY: "auto", border: "1px solid #dee2e6", borderRadius: "4px", padding: "10px" }}>
                  {state.PeriodDataArray.map((period) => (
                    <div
                      key={period.Name}
                      style={{
                        padding: "8px",
                        cursor: "pointer",
                        borderRadius: "4px",
                        backgroundColor: tempSelectedPeriod.some(p => p === period.Name) ? "#e7f3ff" : "transparent",
                        marginBottom: "4px",
                      }}
                      onClick={() => {
                        const isSelected = tempSelectedPeriod.some(p => p === period.Name)
                        if (isSelected) {
                          setTempSelectedPeriod(tempSelectedPeriod.filter(p => p !== period.Name))
                        } else {
                          setTempSelectedPeriod([...tempSelectedPeriod, period.Name])
                        }
                      }}

                    >
                      <div className="d-flex align-items-center">
                        <input
                          type="checkbox"
                          checked={tempSelectedPeriod.some(p => p === period.Name)}
                          onChange={() => { }}
                          style={{ marginRight: "10px", cursor: "pointer" }}
                        />
                        <span>{period.Name}</span>
                      </div>
                    </div>
                  ))}
                  {state.PeriodDataArray.length === 0 && (
                    <div className="text-center text-muted py-3">
                      No periods available
                    </div>
                  )}
                </div>
              </FormGroup>
            </Form>
          </ModalBody>
          <ModalFooter className="d-flex justify-content-end gap-2">
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={() => setTempSelectedPeriod([])}
            >
              Clear All
            </Button>
            <Button
              variant="outline-primary"
              size="sm"
              onClick={() => {
                const allPeriods = state.PeriodDataArray.map(p => p.Name)
                setTempSelectedPeriod(allPeriods)
              }}
            >
              Select All
            </Button>
            <Button variant="primary" onClick={handlePeriodModalDone}>
              <i className="fas fa-check me-2"></i>
              Done
            </Button>
          </ModalFooter>
        </Modal>
      )}

      {/* Ledger Selection Modal */}
      <Modal

        show={showLedgerModal}
        onHide={() => setShowLedgerModal(false)}
        size="lg"
        centered
        style={{ maxHeight: "90vh" }}
      >
        <ModalHeader closeButton>
          <h5 className="modal-title">Select Ledgers</h5>
        </ModalHeader>
        <ModalBody style={{ maxHeight: "calc(90vh - 180px)", overflowY: "auto" }}>
          {/* Search Box */}
          <div className="mb-3">
            <Input
              type="text"
              placeholder="Search ledgers..."
              value={ledgerSearchTerm}
              onChange={(e) => setLedgerSearchTerm(e.target.value)}
              className="form-control"
              style={{ fontSize: "0.9rem" }}
            />
          </div>

          {/* Ledger List */}
          <div
            style={{
              maxHeight: "350px",
              minHeight: "250px",
              overflowY: "auto",
              border: "1px solid #dee2e6",
              borderRadius: "4px",
            }}
          >
            {getFilteredLedgers().length === 0 ? (
              <div className="text-center py-4 text-muted">
                {ledgerSearchTerm ? "No ledgers found" : "No ledgers available"}
              </div>
            ) : (
              <div className="list-group list-group-flush">
                {getFilteredLedgers().map((ledger) => {
                  const isSelected = tempLedgerSelection.includes(ledger.Id)
                  return (
                    <div
                      key={ledger.Id}
                      className={`list-group-item list-group-item-action d-flex align-items-center ${isSelected ? "active" : ""
                        }`}
                      style={{
                        cursor: "pointer",
                        padding: "0.75rem 1rem",
                        backgroundColor: isSelected ? "#0d6efd" : "transparent",
                        color: isSelected ? "#fff" : "#000",
                        border: "none",
                        borderBottom: "1px solid #dee2e6",
                        transition: "background-color 0.2s ease",
                      }}
                      onClick={() => handleLedgerToggle(ledger.Id)}

                    >
                      <span style={{ fontSize: "0.9rem" }}>{ledger.Name}</span>
                      {isSelected && (
                        <i className="fas fa-check ms-auto" style={{ fontSize: "0.85rem" }}></i>
                      )}
                    </div>
                  )
                })}
              </div>
            )}
          </div>
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end gap-2">
          <Button variant="outline-secondary" size="sm" onClick={handleDeselectAllLedgers}>
            Clear All
          </Button>
          <Button variant="outline-primary" size="sm" onClick={handleSelectAllLedgers}>
            Select All
          </Button>
          <Button
            variant="primary"
            onClick={handleLedgerModalOk}
            disabled={tempLedgerSelection.length === 0}
          >
            <i className="fas fa-check me-2"></i>
            Done
          </Button>
        </ModalFooter>
      </Modal>

      {/* Scroll to Top Button for Table */}
      {showScrollTop && state.FillArray && state.FillArray.length > 0 && (
        <button
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            scrollToTop()
          }}
          className="scroll-to-top-btn"
          style={{
            position: "fixed",
            bottom: "20px",
            right: "20px",
            width: "50px",
            height: "50px",
            borderRadius: "50%",
            backgroundColor: "#0d6efd",
            color: "white",
            border: "none",
            cursor: "pointer",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
            zIndex: 99999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "20px",
            transition: "all 0.3s ease",
            outline: "none",
            WebkitTapHighlightColor: "transparent"
          }}

          title="Scroll to top of table"
        >
          <i className="fas fa-arrow-up"></i>
        </button>
      )}

      {/* Remarks Modal for PDF Export */}
      <Modal
        show={showRemarksModal}
        onHide={() => {
          setShowRemarksModal(false)
          setRemarks('')
        }}
        centered
        size="lg"
      >
        <ModalHeader closeButton>
          <h5 className="mb-0">
            <FileText className="me-2" size={18} />
            Add Remarks for PDF Export
          </h5>
        </ModalHeader>
        <ModalBody>
          <Form.Group>
            <Form.Label className="fw-semibold">Remarks</Form.Label>
            <Form.Control
              as="textarea"
              rows={5}
              placeholder="Enter remarks (optional)..."
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              style={{ resize: 'vertical' }}
            />
            <Form.Text className="text-muted">
              Remarks will be added at the end of the PDF document.
            </Form.Text>
          </Form.Group>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="secondary"
            onClick={() => {
              setShowRemarksModal(false)
              setRemarks('')
            }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleGeneratePDF}
          >
            <FileText className="me-2" size={16} />
            Generate PDF
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        show={showSharePDFModal}
        onHide={() => { setShowSharePDFModal(false); setPendingShareFile(null) }}
        centered
        style={{ zIndex: 10700 }}
      >
        <ModalHeader closeButton>
          <h5 className="mb-0">
            <FileText className="me-2" size={18} />
            PDF Ready
          </h5>
        </ModalHeader>
        <ModalBody>
          <p className="mb-0">Click Share to open the share dialog and send the PDF.</p>
        </ModalBody>
        <ModalFooter>
          <Button variant="secondary" onClick={() => { setShowSharePDFModal(false); setPendingShareFile(null) }}>
            Cancel
          </Button>
          <Button variant="success" onClick={handleDownloadPDF}>
            <Download size={14} className="me-1" />Download PDF
          </Button>
          <Button variant="primary" onClick={handleSharePDFClick}>
            Share PDF
          </Button>
        </ModalFooter>
      </Modal>

      {/* Mobile responsive styles for scroll button */}
      <style>{`
        @media (max-width: 768px) {
          .scroll-to-top-btn {
            width: 45px !important;
            height: 45px !important;
            bottom: 55px !important;
            right: 15px !important;
            font-size: 18px !important;
          }
        }
        @media (max-width: 576px) {
          .scroll-to-top-btn {
            width: 42px !important;
            height: 42px !important;
            bottom: 52px !important;
            right: 12px !important;
            font-size: 17px !important;
          }
        }
        @media (max-width: 480px) {
          .scroll-to-top-btn {
            width: 38px !important;
            height: 38px !important;
            bottom: 50px !important;
            right: 10px !important;
            font-size: 15px !important;
            box-shadow: 0 3px 8px rgba(0, 0, 0, 0.3) !important;
          }
        }
        @media (max-width: 375px) {
          .scroll-to-top-btn {
            width: 35px !important;
            height: 35px !important;
            bottom: 48px !important;
            right: 8px !important;
            font-size: 14px !important;
            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3) !important;
          }
        }
        @media (max-width: 320px) {
          .scroll-to-top-btn {
            width: 32px !important;
            height: 32px !important;
            bottom: 46px !important;
            right: 6px !important;
            font-size: 13px !important;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3) !important;
          }
        }
      `}</style>

      <Modal
        show={showContractTypeModal}
        onHide={closeContractTypeModal}
        size="lg"
        centered
        style={{ zIndex: 10000 }}
      >
        <ModalHeader className="bg-primary text-white">
          <div className="d-flex justify-content-between align-items-center w-100">
            <h5 className="mb-0">
              <i className="fas fa-file-contract me-2"></i>
              Select Contract Type
            </h5>
            <Button
              variant="light"
              onClick={closeContractTypeModal}
              className="btn-close btn-close-white"
              style={{ border: "none", background: "transparent" }}
            >
              <i className="fas fa-times"></i>
            </Button>
          </div>
        </ModalHeader>
        <ModalBody style={{ padding: "1.5rem", maxHeight: "60vh", overflowY: "auto" }}>
          <Form>
            <FormGroup>
              <div className="mb-3">
                <FormLabel className="fw-semibold mb-0">Contract Type</FormLabel>
              </div>
              <div style={{ maxHeight: "400px", overflowY: "auto", border: "1px solid #dee2e6", borderRadius: "4px", padding: "10px" }}>
                {state.TaxAccountArray.map((type) => (
                  <div
                    key={type.Id}
                    style={{
                      padding: "8px",
                      cursor: "pointer",
                      borderRadius: "4px",
                      backgroundColor: tempSelectedContractTypes.includes(type.Id) ? "#e7f3ff" : "transparent",
                      marginBottom: "4px",
                    }}
                    onClick={() => {
                      if (tempSelectedContractTypes.includes(type.Id)) {
                        setTempSelectedContractTypes(tempSelectedContractTypes.filter(id => id !== type.Id))
                      } else {
                        setTempSelectedContractTypes([...tempSelectedContractTypes, type.Id])
                      }
                    }}
                  >
                    <div className="d-flex align-items-center">
                      <input
                        type="checkbox"
                        checked={tempSelectedContractTypes.includes(type.Id)}
                        onChange={() => { }}
                        style={{ marginRight: "10px", cursor: "pointer" }}
                      />
                      <span>{type.Name}</span>
                    </div>
                  </div>
                ))}
                {state.TaxAccountArray.length === 0 && (
                  <div className="text-center text-muted py-3">No contract types available</div>
                )}
              </div>
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end gap-2">
          <Button variant="outline-secondary" size="sm" onClick={() => setTempSelectedContractTypes([])}>
            Clear All
          </Button>
          <Button variant="outline-primary" size="sm" onClick={() => setTempSelectedContractTypes(state.TaxAccountArray.map(t => t.Id))}>
            Select All
          </Button>
          <Button variant="primary" onClick={handleContractTypeModalDone}>
            <i className="fas fa-check me-2"></i>
            Done
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        show={showPortModal}
        onHide={closePortModal}
        size="lg"
        centered
        style={{ zIndex: 10000 }}
      >
        <ModalHeader className="bg-primary text-white">
          <div className="d-flex justify-content-between align-items-center w-100">
            <h5 className="mb-0">
              <i className="fas fa-map-marker-alt me-2"></i>
              Select Delivery Port
            </h5>
            <Button
              variant="light"
              onClick={closePortModal}
              className="btn-close btn-close-white"
              style={{ border: "none", background: "transparent" }}
            >
              <i className="fas fa-times"></i>
            </Button>
          </div>
        </ModalHeader>
        <ModalBody style={{ padding: "1.5rem", maxHeight: "60vh", overflowY: "auto" }}>
          <Form>
            <FormGroup>
              <div className="mb-3">
                <FormLabel className="fw-semibold mb-0">Delivery Port</FormLabel>
              </div>
              <div style={{ maxHeight: "400px", overflowY: "auto", border: "1px solid #dee2e6", borderRadius: "4px", padding: "10px" }}>
                {getUniquePortsFromData().map((port) => (
                  <div
                    key={port.value}
                    style={{
                      padding: "8px",
                      cursor: "pointer",
                      borderRadius: "4px",
                      backgroundColor: tempSelectedPorts.includes(port.value) ? "#e7f3ff" : "transparent",
                      marginBottom: "4px",
                    }}
                    onClick={() => {
                      if (tempSelectedPorts.includes(port.value)) {
                        setTempSelectedPorts(tempSelectedPorts.filter(p => p !== port.value))
                      } else {
                        setTempSelectedPorts([...tempSelectedPorts, port.value])
                      }
                    }}
                  >
                    <div className="d-flex align-items-center">
                      <input
                        type="checkbox"
                        checked={tempSelectedPorts.includes(port.value)}
                        onChange={() => { }}
                        style={{ marginRight: "10px", cursor: "pointer" }}
                      />
                      <span>{port.label}</span>
                    </div>
                  </div>
                ))}
                {getUniquePortsFromData().length === 0 && (
                  <div className="text-center text-muted py-3">No ports available</div>
                )}
              </div>
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end gap-2">
          <Button variant="outline-secondary" size="sm" onClick={() => setTempSelectedPorts([])}>
            Clear All
          </Button>
          <Button variant="outline-primary" size="sm" onClick={() => setTempSelectedPorts(getUniquePortsFromData().map(p => p.value))}>
            Select All
          </Button>
          <Button variant="primary" onClick={handlePortModalDone}>
            <i className="fas fa-check me-2"></i>
            Done
          </Button>
        </ModalFooter>
      </Modal>

      {/* Scroll to Top Button */}
      {showScrollTop && (
        <Button
          onClick={scrollToTop}
          style={{
            position: "fixed",
            bottom: "75px",
            right: "20px",
            zIndex: 9999,
            borderRadius: "50%",
            width: "40px",
            height: "40px",
            padding: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
            backgroundColor: "#0000FF",
            borderColor: "#0000FF"
          }}
          title="Scroll to top"
        >
          <i className="fas fa-chevron-up"></i>
        </Button>
      )}
    </div>
  )
}

export default LedgerReport
